/*****
 * ====================================================================================
 * Project: noloPath jQuery Plugin
 * Description: controls the behavior of the NOLOPATH form
 * Author: Ian Cruz @ Nolo
 * Version: 2.0.0
 * jQuery Version: 2.1.3
 * ====================================================================================
 */

// noloPath JQUERY PLUGIN
// ====================================================================================
(function(root, document, factory)
{
    if (typeof define === 'function' && define.amd) {
        define(['jquery', 'mustache', 'cookies', 'xss', 'redirect', 'jquery.noloPath/constants'], factory);
    } else {
        factory(root.jQuery, root.Mustache, root.Cookies, root.filterXSS, root.jQuery.redirect);
    }
}(window, document, function ($, Mustache, Cookies, filterXSS, Redirect)
{
    'use strict';

    // noloPath PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    // ================================================================================
    var noloPath = function (element, options) {
        this.$element    = $(element);
        this.options     = $.extend(true, {}, noloPath.DEFAULTS, this.getDataAttributeOptions(), options);
        this.surl        = this.getSurl();
        this.referer     = this.getSanitizedURL();
        this.query       = this.getQueryParams();
        this.errorData   = this.getErrorData();
        this.pathData    = this.getPathData();
        this.initDone    = false;
        this.formLoaded  = false;

        // init $element.data() objects
        this.$element.data('providersData', {});
        this.$element.data('questionData',  {});
        this.$element.data('zipCodeData',   {});

        var pathId = this.pathData.pathId;
        var pathKey = pathId.replace('-', '_');
        if (typeof $.NOLO_PATH_CONSTANTS.inlineErrorMessages[pathKey] !== 'undefined') {
            this.options.lang = pathKey;
            noloPath.DEFAULTS.lang = pathKey;
        }
        // Initialize the plugin
        this.init();

        // identify that the application init is completed
        this.initDone = true;

    }




    // noloPath PLUGIN NAME
    // ================================================================================
    noloPath.NAME  = 'noloPath';
    noloPath.DATANAME = 'nolo.' + noloPath.NAME;




    // noloPath VERSION
    // ================================================================================
    noloPath.VERSION  = '2.0.0';




    // noloPath CONTANTS
    // ================================================================================
    noloPath.CONSTANTS = $.extend({}, $.NOLO_PATH_CONSTANTS);

    // noloPath DEFAULT OPTIONS
    // ================================================================================
    // @note:
    // + for full details about all the default options that are available,
    //   refer to the configuration file defined by the php constant 'NOLO_LEADS_API_DATA_FILE_LEAD_FORM_CONFIG'
    noloPath.DEFAULTS = {
        'debug'      : false,
        'debugTrace' : '#nolopath-analytics',
        'lang': 'default'
    };




    // noloPath PUBLIC METHODS
    // ================================================================================
    /**
     * Initializes the plugin
     * @params N/A
     * @return undefined
     */
    noloPath.prototype.init = function(){
        var options = this.options;

        // initialize path theme
        this.initTheme();

        // initialize mustache templates
        this.initMustacheTemplates();

        // initialize the current step
        // -----
        // @note:
        // + this method is responsible to enabling the majority of behaviors to make the application work
        // + when the path has a practice area dropdown, this method is responsible for reinitializing the behaviors destroyed by the form load
        this.initSteps();

        // initialize sem cookies
        this.initCookies();

        // bind the practice area dropdown
        // -----
        // @note:
        // + the element that this will bind to may or may not exist depending on the path configuration
        // + when the element is found, the handler will destroy the existing form
        this.bindPracticeAreaSelect();

        // if pi-api5 a/b test, preselect any question set, but set aop selector to default
        // this.preselectPi5b(); og-pi5b

        // bind the submit button
        this.bindSubmitForm();

        // EHCS-5621: bind the ssdi-api4 interstitial "Call vs. Continue" handlers
        this.bindSsdiApi4Interstitial();

        // bind the phone CTA button
        this.bindVoiceCta();

        // bind the phone CTA button
        this.bindNgageClick();

        // bind Path Url Data To #nolopath-insert div
        this.bindPathUrlData();

        // check if needs to be pause reCaptcha checks for QA auto test
        if(location.search.includes('qa_autotest')) window.pauseReCaptcha = true;
        if(sessionStorage.getItem('refreshRecaptcha')) {
            this.setStatusError('formNotLoaded', 'error', noloPath.CONSTANTS.inlineErrorMessages.recaptchaRefreshMessages);
            var isMinPath3 = location.pathname.includes('min-path3');
            if(!isMinPath3) sessionStorage.removeItem('refreshRecaptcha');
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if(isSafari)$('#nolopath form').attr('action',location.hostname+location.pathname.split('/').slice(0,-1).join('/'));
            $("body").removeClass("threshold-error");
            $("body").addClass("refresh-error");
        }
    }

    noloPath.prototype.preselectPi5b = function () {
        var urlParams = new URLSearchParams(window.location.search);
        if (this.pathData.pathId == 'pi-api5' && urlParams.get('routing') == 'pi5b' && this.getCurrentStep() == 'step-1'){
            var $select = $('#nolopath-practice-area-select');
            $select.val('30a').trigger('change');
            $select.val('0').trigger('change.select');
            sessionStorage.removeItem('pid');
        } else if (this.pathData.pathId == 'pi-api5pp' && urlParams.get('routing') == 'pi5b' && this.getCurrentStep() == 'step-1'){
            var $select = $('#nolopath-practice-area-select');
            $select.val('30a').trigger('change');
            $select.val('0').trigger('change.select');
            sessionStorage.removeItem('pid');
        }
    }

    noloPath.prototype.initTheme = function(){
        var $elm = this.getElement();
        var theme_class = this.getOptions('themeClass');
        var hasThemeClass = ($elm.parents('.' + theme_class).length > 0);

        // if any of the parents don't have the theme class, add it to the immediate parent
        // -----
        // @note:
        // + we use the theme class to limit the application of the theme styles on a per path basis
        // + this will be particularly applicable in the cases where we are using
        //   the 'noloPathInsert' plugin to embed different paths on the same page
        if(!hasThemeClass){
            $elm.parent().addClass(theme_class);
        }
    }

    noloPath.prototype.initMustacheTemplates = function(){
        var $elm = this.getElement();
        var options = this.getOptions();
        var partials = options.template.partials;
        var partial, partialData, partialHtml;

        this.mst_main               = this.getMustacheElement(options.template.main).html();
        this.mst_title              = this.getMustacheElement(options.template.title).html();
        this.mst_breadcrumb         = this.getMustacheElement(options.template.breadcrumb).html();
        this.mst_summary            = this.getMustacheElement(options.template.summary).html();
        this.mst_alerts             = this.getMustacheElement(options.template.alerts).html();
        this.mst_providers          = this.getMustacheElement(options.template.providers).html();
        this.mst_providers_text     = this.getMustacheElement(options.template.providers_text).html();
        this.mst_confirmation       = this.getMustacheElement(options.template.confirmation).html();
        this.mst_breadcrumb_steps   = this.getMustacheElement(options.template.breadcrumb_steps).html();
        this.mst_form_progress_bar  = this.getMustacheElement(options.template.progress_bar).html();

        this.mst_partials = {};

        for (var i = 0; i < partials.length; i++){
            partial = this.getMustacheElement(partials[i]);
            partialData = partial.data();
            partialHtml = partial.html();

            if(partialData.mstFile){
                this.mst_partials[partialData.mstFile] = partialHtml;
            } else {
                this.mst_partials[partials[i]] = partialHtml;
            }
        }
    }

    noloPath.prototype.initSteps = function(data){
        // initialize the steps data
        // -----
        // @note:
        // + it is IMPERATIVE that this function is called as soon as possible
        // + the 'stepsData' property that this function sets is used by numerous others
        // + they will not function as expected if 'stepsData' is out-of-date
        this.setStepsData();

        // internally track the updated form title if available
        this.initFormTitle(data);

        // detect questions and cache them into memory
        this.initQuestionData(data);

        // set additional hidden fields
        this.initHiddenFields();

        // reset the providers text
        // -----
        // @note:
        // + the user can proceed through the form until the 'providers text' is diplayed
        // + they can then select a new practice area
        // + at that point, the 'providers text' can remain displayed with incorrect information
        this.setProvidersText();

        // rebind validators
        this.bindValidators();

        // attach event handler to the zip code field
        this.bindZipCodeField();

        // set status for form actions
        this.initFormActions();

        // bind custom field components
        this.bindRemoteUpdate();

        // bind forward/back buttons
        this.bindNavigateButtons();

        // bind overlay handler
        this.bindOverlay();

        // displays the current step
        this.loadCurrentStep();

        // render the breadcrumbs progress steps if they exist in theme
        this.initBreadcrumbSteps();


    }

    noloPath.prototype.initFormTitle = function(data){
        // update the 'title' option based on detected 'form_title'
        if((typeof data === 'object') && data.form_title){
            this.options.title = data.form_title;
        }
        //EHCS-2200: fix the title when back to step-1 from top lead
        if(!data && !this.getElement('.panel-title.form-title').text() && this.options.pathId=='min-path7' && this.options.step=='step-1') {
            this.getElement('.panel-title.form-title').html(this.options.title);
        }
    }

    noloPath.prototype.initQuestionData = function(data){

        var $elm = this.getElement();
        var $questions = this.getElement('.form-step-questions .form-item');
        var questionData = {
            'practice_area_name': this.getPathPracticeAreaName(),
            'practice_area_id': this.getPathPracticeAreaId(),
            'active': 1,
            'step_1_total': 0,
            'answered': 0,
            'map':{},
            'questions':[],
            'progressBarCount': 0
        };

        // if we are getting new data from the server, update the 'practice_area_name' and 'practice_area_id' properties to match
        if(typeof data === 'object'){
            questionData.practice_area_name = data.practice_area_name;
            questionData.practice_area_id = data.pid;
        }

        // generate question items
        $questions.each(function(i, obj) {
            var field = new noloPathQuestionItem($(obj));
            questionData.map['map_' + field.rawId] = field;
            questionData.questions.push(field);

            if(field.step === 'step-1' && field.id !== 'form-item-zip') {
                questionData.step_1_total++;
            }
        });

        // identify if there are form questions loaded
        if(questionData.questions.length > 0){
            this.formLoaded = true;
        } else {
            this.formLoaded = false;
        }

        // cache it
        $elm.data('questionData', questionData);

        // @note:
        // + bind 'on keyup' event if field with "has-char-limit" class is detected
        // + this is primarily created for EHCS-1056 but can be used for other cases as long as
        // + there is an element with class 'char-limit-message' under the element's parent
        var that = this;
        $.each($(".form-item .has-char-limit"), function(idx, element){
            that.bindDynamicCharacterMessage(element);
        });

        var pidSelected = $('#nolopath').data().practiceAreaId !== 1;
        if(pidSelected && $elm.hasClass('no-questions')){
            // check if a practice area is selected and remove 'no-questions' class to reveal routing question
            $elm.removeClass('no-questions');
        }
    }

    noloPath.prototype.initFormActions = function() {
        var $actions = this.getElement('.form-actions');

        // @note:
        // + the 'not-valid' class will be used to indicate that the current step does not have any questions answered
        // + the stylesheet will show/hide 'form-actions' based on this class
        $actions.addClass('not-valid').removeClass('valid');
    }

    noloPath.prototype.bindValidators = function(){
        var $formItems = this.getElement('.form-item');
        var validateSelect = $.proxy(this, 'validateSelect');
        var validateCheckbox = $.proxy(this, 'validateCheckbox');
        var validateRadio = $.proxy(this, 'validateRadio');
        var validatePhone = $.proxy(this, 'validatePhone');
        var validateInput = $.proxy(this, 'validateInput');
        var process = this;

        $formItems.each(function(i, obj) {
            var input = $(obj).find('.form-control, .radio input, .checkbox input');

            switch (input[0].tagName) {
                case 'SELECT':
                    input.on('change', validateSelect);
                    break;
                default:
                switch(input.attr('type')){
                    case 'checkbox':
                    input.on('change', validateCheckbox);
                    break;

                    case 'radio':
                    input.on('change', validateRadio);
                    break;

                    case 'tel':
                        if(process.options.type === 'organic') {//only add the validation for SEM sites
                            if( input.attr('name') != "zip" && input.hasClass("validate-phone")){
                                input.on('input', validatePhone);
                            } else if( input.attr('name') == "zip" ) {
                                process.configureBlurWorkaround(input, validateInput, 'blur input');
                            }
                        } else {
                            process.configureBlurWorkaround(input, validateInput, 'blur input');
                            if (input.attr('name') != "zip" && input.hasClass("validate-phone")) {
                                input.on('input', validatePhone);   
                            }
                        }
                    break;

                    default:
                    process.configureBlurWorkaround(input, validateInput, 'blur input');
                    break;
                }
                break;
            }
        });
    }

    noloPath.prototype.bindDynamicCharacterMessage = function(element){
        $(document).on("keyup", element, function(e) {
            var $elm = $(e.target);
            var char_limit = $elm.attr("maxlength");
            var remaining = char_limit - $elm.val().length;
            $elm.parent().parent().find(".char-limit-message").html(remaining + "/" + char_limit + " characters left.");
        });
    }

    noloPath.prototype.initCookies = function(){
        var params = this.getOptions('cookieUrlParams');
        var cName, cValue, cOptions;

        if(params.length > 0){
            cOptions = {
                'expires' : this.getOptions('cookieExpires'),
                'path'    : location.pathname,
                'domain'  : location.host,
                'secure'  : this.getOptions('cookieSecure')
            }

            for (var n = 0; n < params.length; n++){
                // build the cookie name by adding a prefix to the url parameter name
                cName = this.getOptions('cookieNamePrefix') + params[n];

                // retrieve the cookie value from the url parameter, if exists
                // otherwise, retrieve from cookie, if exists
                cValue = this.getElement('input[name="'+params[n]+'"]').val() || this.getCookie(cName);

                // if a cookie value exists, set/update the cookie
                if(cValue){
                    this.setCookie(cName, cValue, cOptions);
                }
            }
        }

        return false;
    }

    noloPath.prototype.initHiddenFields = function(){
        this.setSurl();
        this.setReferer();
        this.setBlockInfo();
        this.setNanigansPID();
        this.setDirectGuid();
        this.setAutoPopulateAOPid();
        this.setCompanyID();
    }

    noloPath.prototype.initBreadcrumbSteps = function(){
        var step_1_total = this.getQuestionData('step_1_total');
        var steps = [];
        // Filling the steps array and putting a step number as the only value for mustache rendering data
        for (var i=0; i<step_1_total; i++) {
            steps[i] = { stepNumber: i };
        }
        this.render(this.mst_breadcrumb_steps, '.breadcrumbs-steps-progress', { step: steps });
        this.updateProgress();

        if(this.options.pathId == 'min-path2' || this.options.pathId == 'min-path2es') {
            var currentStep = this.getCurrentStep();
            var questionMap = this.getQuestionData('map');
            var caseQuestionMap = questionMap.map_case_description !== 'undefined' ? questionMap.map_case_description : null;
            $(".case-description-msg.form-disclaimer").css('display','none');
            if(caseQuestionMap) {
                if(caseQuestionMap.step && caseQuestionMap.step == currentStep) {
                    $(".case-description-msg.form-disclaimer").css('display','block');
                }
            }
        }
    }

    noloPath.prototype.getDataAttributeOptions = function(){
        var options = this.$element.data();
        return options;
    }

    noloPath.prototype.getQueryParams = function(myQuery){
        var params = {};
        var query = (typeof myQuery === 'string') ? '?' + myQuery : location.search;
        var q, a, b;
        if(query.length > 0){
            q = query.substr(1, query.length-1);
            a = q.split('&');
            for (var i=0; i<a.length; i++){
                b = a[i].split('=');
                params[b[0]]=b[1];
            }
        }
        return params;
    }

    noloPath.prototype.getElement = function(selector){
        var $elm = this.$element;

        return (typeof selector === 'string') ? $elm.find(selector) : $elm;
    }

    noloPath.prototype.getOptions = function(key){
        var options = this.options;

        return (typeof key !== 'undefined') ? options[key] : options;
    }

    noloPath.prototype.getMustacheElement = function(mstId){
        var pathId = this.getPathID();

        return $('[type="x-tmpl-mustache"][data-path-id="'+pathId+'"][id="'+mstId+'"]');
    }

    noloPath.prototype.getErrorData = function(key){
        var data = this.errorData;

        if(!data){
            data = {
                'client':{},
                'server':{}
            };
        }

        return (typeof key !== 'undefined') ? data[key] : data;
    }

    noloPath.prototype.getServiceUrl = function(path){
        var serviceUrl = this.getOptions('serviceUrl');

        // append the path
        // ----
        // @note:
        // + generally, all paths will use the default service provided by the 'serviceUrl' option from the configuration
        // + however, we may deploy paths on domains like 'lawyers.com' that is not directly controlled by us
        // + we update the service url so web service calls like 'getFormQuestionsData' resolve correctly
        if(typeof path === 'string'){
            serviceUrl += path;
        }

        return serviceUrl;
    }

    noloPath.prototype.getBlockId = function(){
        var $elm = this.getElement('[name="block_id"]');

        // retrieve the 'block_id' hidden field value
        // -----
        // @note:
        // + the 'block_id' hidden field will be set by the 'noloPathInsert' plugin,
        //   or by Drupal's 'expert_leadgen_form_focus.js' script
        // + this will allow us to identify which Drupal block that a path was inserted into
        // + non-Drupal application will return empty, so set default to 'none'
        // + we need to report this value to the 'noloPathAnalytics' plugin for event tracking
        return $elm.val() || 'none';
    }
    noloPath.prototype.getRegionGeneral = function(regionId){
        if (regionId.indexOf('top') !== -1){
            return 'top';
        }else if (regionId.indexOf('main') !== -1){
            return 'top';
        }else if (regionId.indexOf('bottom') !== -1){
            return 'bottom';
        }
        return 'undefined';
    }
    noloPath.prototype.getRegionId = function(){
        var $elm = this.getElement('[name="region_id"]');

        // retrieve the 'region_id' hidden field value
        // -----
        // @note:
        // + the 'region_id' hidden field will be set by the 'noloPathInsert' plugin,
        //   or by Drupal's 'expert_leadgen_form_focus.js' script
        // + this will allow us to identify which Drupal region that a path was inserted into
        // + non-Drupal application will return empty, so set default to 'none'
        // + we need to report this value to the 'noloPathAnalytics' plugin for event tracking
        return $elm.val() || 'none';
    }

    noloPath.prototype.getPathData = function(key){
        var $elm = this.getElement();
        var data = this.pathData;

        // initialize the object
        if(!data){
            // these are AOP data attributes attached to $elm
            // packaging them here for easy reference throughout the plugin
            data = {
                'practiceAreaId'   : $elm.data('practiceAreaId'),
                'practiceAreaName' : $elm.data('practiceAreaName'),
                'subscriptionList' : $elm.data('subscriptionList'),
                'questionSet'      : $elm.data('questionSet'),
                'pathId'           : $elm.data('pathId'),
            };
        }

        return (typeof key !== 'undefined') ? data[key] : data;
    }

    noloPath.prototype.getPathID = function(){
        return this.getPathData('pathId');
    }

    noloPath.prototype.getPathLoader = function(){
        var $elm = this.getElement('[name="pathLoader"]');

        // retrieve the 'pathLoader' hidden field value
        // -----
        // @note:
        // + the 'pathLoader' hidden field will be set by the 'noloPathInsert' plugin
        // + this will allow us to identify that a path was used by it
        // + we need to report this value to the 'noloPathAnalytics' plugin for event tracking
        return $elm.val() || '';
    }

    noloPath.prototype.getPathPracticeAreaId = function(){
        return this.getPathData('practiceAreaId');
    }

    noloPath.prototype.getPathPracticeAreaName = function(){
        return this.getPathData('practiceAreaName');
    }

    noloPath.prototype.getPathQuestionSet = function(){
        return this.getPathData('questionSet');
    }

    noloPath.prototype.getPathSubscriptionList = function(){
        return this.getPathData('subscriptionList');
    }

    noloPath.prototype.getStepsData = function(key){
        var data = this.stepsData;
        return (typeof key !== 'undefined') ? data[key] : data;
    }

    noloPath.prototype.getQuestionData = function(key){
        var data = this.$element.data('questionData');
        return (typeof key !== 'undefined') ? data[key] : data;
    }

    noloPath.prototype.getSanitizedURL = function(){
        var locHref = location.href;
        var locHash = locHref.indexOf('#');
        var hasHash = (locHash !== -1);

        // remove hashes from url to prevent injection
        if(hasHash) {
            return locHref.substr(0, locHash);
        }

        return locHref;
    }

    noloPath.prototype.getSurl = function(){
        var locSearch = location.search;
        var locFull   = this.getSanitizedURL();
        var loc       = locFull.substr(0,(locFull.length - locSearch.length));
        // var pattern   = /(http|https)(:\/\/)/g;
        // var surl = loc.replace(pattern, '');
        var surl = loc;
        return surl;
    }

    noloPath.prototype.getLeadApiUrl = function(){
        var currentStep = this.getCurrentStep();
        var beforeLastStep = this.getBeforeLastStep();
        var getProviders = this.canGetProviders();

        // for Michigan (MI, zip code range 48001-49971),
        // state law requires that provider information be displayed
        // BEFORE submitting the users data to the 'lead_api'
        // -----
        // add 'get_providers=true' to the 'leadApiUrl' to retrieve provider data for processing
        // only do this BEFORE the last step
        return this.getLeadsSubmitApiUrl((getProviders && currentStep === beforeLastStep));
    }

    noloPath.prototype.getLeadsSubmitApiUrl = function(getProviders){
        var options = this.options;
        var leadApiUrl = options.leadsSubmitApi;
        var delimiter = '?';
        var errorData = this.getErrorData('client');
        var hasClientErrors = ((errorData.total > 0) || (typeof errorData.total === 'undefined'));

        // append the 'get_providers' parameter
        // -----
        // @note:
        // + 'getProviders' is a boolean generated by 'canGetProviders()'
        // + this will append a specific parameter to the LEADS API call that will retrieve provider info,
        //   along with the server validation results
        // + this parameter is NOT supposed to be added to a COMPLETED form
        // + we are using 'hasClientErrors' to prevent that
        if(typeof getProviders === 'boolean' && getProviders && hasClientErrors){
            // our 'leadApiUrl' may already have parameters
            // need to update the parameter 'delimiter' accordingly
            if(leadApiUrl.indexOf(delimiter)>-1){
                delimiter = '&';
            }

            leadApiUrl += delimiter + 'get_providers=true';
        }

        return leadApiUrl;
    }

    noloPath.prototype.getZipApiUrl = function(zip){
        var options = this.options;
        var z = escape(zip);
        var zipApiUrl = options['leadsZipApi'];

        // the 'zipApiUrl' may be required as a parameter in the form of a query (ex. zip=99999)
        // or in the form of a folder parameter (ex /api/validate/99999/someOtherParameter)
        // -----
        // o['leadsZipApi'] should include the string %ESCAPED_ZIP_CODE% to indicate that the zipcode
        // is supposed to be inserted in a specific location
        // -----
        // return the url after replacing the placeholder string with the actual zip code
        return zipApiUrl.replace("%ESCAPED_ZIP_CODE%", z);
    }

    noloPath.prototype.getNextStepUrl = function(step){
        var $elm = this.$element;
        var $form = $elm.find('form');
        var action = $form.attr('action');

        // IE can cache the action attribute, when the user hits the back button.
        // check it first, before appending the 'step' to the url
        if(action.indexOf(step) > 0){
            return action;
        }

        // append the 'step' to the post url
        return action + '/' + step;
    }

    noloPath.prototype.getCurrentStep = function(){
        return 'step-'+ this.getStepsData('current');
    }

    noloPath.prototype.getCurrentStepIndex = function(){
        return this.getStepsData('current');
    }

    noloPath.prototype.getPreviousStep = function(){
        var prevStep = this.getStepsData('previous');

        if (!prevStep){
            return;
        }

        return 'step-' + prevStep;
    }

    noloPath.prototype.getNextStep = function(){
        var nextStep = this.getStepsData('next');
        var totalSteps = this.getStepsData('total');

        if ((!nextStep) && (totalSteps > 0)){
            return 'confirm';
        }

        return 'step-' + nextStep;
    }

    noloPath.prototype.getBeforeLastStep = function(){
        return 'step-' + this.getStepsData('beforeLast');
    }

    noloPath.prototype.getLastStep = function(){
        return 'step-' + this.getStepsData('last');
    }

    noloPath.prototype.getTotalSteps = function(){
        return this.getStepsData('total');
    }

    noloPath.prototype.getSpecialStep = function(){
        var step = this.getCurrentStep();
        var lastStep = this.getLastStep();
        var beforeLastStep = this.getBeforeLastStep();

        // determine the next step
        switch(step){
            case 'confirm':
                return step;
            break;

            case 'step-1':
                return 'first';
            break;

            case beforeLastStep:
                return 'beforelast';
            break;

            case lastStep:
                return 'last';
            break;

            default:
                return;
            break;
        }
    }

    noloPath.prototype.getZipCodeFromIp = function($field){
        var $elm = this.$element;
        var cachedData = $elm.data('zipCodeData');
        var process = this;
        var isMobile = this.isMobile();
        var geolocate = !isMobile;
        var geocApiUrl = noloPath.CONSTANTS.geocApiUrl;

        // EHCS-569: compiled js for disable GEOC API
        var geolocate = false;

        // get zip code from ip only if the current view is not mobile
        if(geolocate){
            // create the promise
            var promise = $.ajax({
                type: 'GET',
                crossDomain: true,
                url: geocApiUrl,
                dataType: 'json',
            });

            // on success, clean the data and cache it
            promise.done(function(data, status, xhr){
                // update cached data
                var compile = $.extend(true, {}, cachedData, data);
                $elm.data('zipCodeData', compile);
                return;
            });

            // set the detected zipcode into the field, if available
            promise.done(function(){
                var data = $elm.data('zipCodeData');
                if (data.zipCode && $field && $field.length > 0){
                    $field.val(data.zipCode).trigger('blur').trigger('input');
                }
                return;
            });

            // catch ajax errors
            promise.fail(function(xhr, status, error){
                return process.onAjaxErrorSubmit(xhr, status, error, $field, geocApiUrl);
            });
        }
    }

    noloPath.prototype.getProvidersData = function(bypassZipCheck){
        var $elm = this.$element;

        // EHCS-5697: dv-api3-v2 doesn't use the "number of lawyers in your
        // area" providers feature at all (no showProviders config) — short
        // circuit completely rather than just gating the AJAX call further
        // below. Everything past this point assumes $elm.data('providersData')
        // is already a populated object once at least one call has resolved
        // (e.g. `cachedData.cached` checks). Since we never let the AJAX
        // call populate it for this path, a LATER call to this same
        // function (loadLastStep() unconditionally calls it again on
        // arrival at the final step) would throw reading `.cached` off
        // `undefined`, aborting mid-function — which leaves the
        // providersDataPromise it just registered (below) stuck pending
        // forever. submitForm()'s very first check holds off entirely
        // while that promise is pending, which is exactly what was
        // blocking "Submit" on the contact info step.
        if (['dv-api3', 'dv-api3-v2'].includes(this.pathData.pathId)) {
            var noopDfd = $.Deferred();
            $elm.data('providersDataPromise', noopDfd.promise());
            noopDfd.resolve();
            return noopDfd.promise();
        }

        var leadApiUrl = this.getLeadsSubmitApiUrl(true);
        var skey = $elm.find('input[name="skey"]').val();
        var postData = {
            'r': 'nololeadgenengine/rest/request/submit',
            'practice_area_id': $elm.find('input[name="practice_area_id"]').val(),
            'zip': $elm.find('input[name="zip"]').val(),
        };
        var getProviders = bypassZipCheck || this.canGetProviders();
        var process = this;
        var wait, timer;
        var cachedData = $elm.data('providersData');
        var hiddenData = $elm.find('input[name="nolopath_providers"]').val();
        var jsonData = hiddenData ? JSON.parse(decodeURIComponent(hiddenData)) : {};
        var zipCachedData = $elm.data('zipCodeData');
        // EHCS: track completion so callers (e.g. submitForm) can wait for this fetch to finish
        // before letting the user move on to the next step
        var dfd = $.Deferred();
        var asyncPending = false;
        $elm.data('providersDataPromise', dfd.promise());
        // add skey if available
        if(skey){
            postData.skey = skey;
        }

        // waiting function
        function waiting(){
            var deferred = $.Deferred();
            // check every second for cached data
            timer = setInterval(function() {
                if(!$elm.data('providersData').cached) {
                    // notify the 'deferred' object in-case we want to do a progress function call
                    deferred.notify();
                } else {
                    // resolve the 'deferred' object once cached data is available
                    clearInterval(timer);
                    deferred.resolve();
                }
            }, 1000);

            return deferred.promise();
        }

        // processData function
        function processData(){
            var providersData = $elm.data('providersData');
            var providers = providersData.providers || [];
            var show_profile = providersData.showProfile || false;
            var providers_length = providers.length;
            var practice_area = providersData.practiceAreaName || null;
            if (!bypassZipCheck) {
                process.setProviders(providers, show_profile);
            } else {
                process.setProvidersText(providers_length, practice_area);
            }
        }

        // sync cached data from previous step
        if(jsonData.cached && !cachedData.cached){
            cachedData = jsonData;
            $elm.data('providersData', jsonData);
        }

        // check for cached data **NOTE** Disabled because it doesn't show the AOP message upon change with it enabled.
        //if (cachedData.cached){
            // check if 'zip' and 'practice_area_id' changed since the last check
            if(postData.zip === cachedData.zip && postData.practice_area_id === cachedData.practiceAreaId){
                // use existing cached data
                processData();
            } else {
                //check if a session has already started before resetting
                if(!process.reset){
                    // reset the data so it can be updated with the new zipcode and practice area
                    cachedData = {};

                    // flag this current request session as 'reset' so we can grab new data
                    process.reset = true;
                } else {
                    // a request session is detected
                    // flag this current request session as 'queued' so we can wait for new data
                    process.queued = true;
                }
            }
        //}

        // when the data is both 'reset' and 'queued', begin waiting
        if (process.reset && process.queued){
            // an existing queued request is happening
            asyncPending = true;

            // wait until data('providersData') is populated
            wait = waiting();

            // when finished, use the cached data
            wait.done(function(){
                processData();
                dfd.resolve();
            });

            // just get out of this handler, now that it's done processing cached data
            return dfd.promise();
        }


        // cached data is not found, try to grab it from LEADS API
        if (!cachedData.cached){

            // get data if allowed to do so
            if(zipCachedData.status === 'error'){
                // the zip-code is not valid, as flagged by GEOC API or LEADS API
                getProviders = false;

                // reset the both memory and json cache
                $elm.data('providersData', {});
                $elm.find('input[name="nolopath_providers"]').val('{}');

                // no providers request will run for an invalid zip, so clear the session flags;
                // otherwise the next valid zip is queued forever and submit never fires
                process.reset = false;
                process.queued = false;

                // update components after reset
                processData();
            } else {
                // data is not cached, flag the 'providersData' object to queue
                process.reset = true;
                process.queued = true;
            }

            if (getProviders){
                // create the promise
                asyncPending = true;
                var promise = $.ajax({
                    type: 'POST',
                    crossDomain: true,
                    url: leadApiUrl,
                    data: $.param(postData),
                    dataType: 'json',
                });

                // on success, clean the data and cache it
                promise.done(function(data, status, xhr){
                    // set the skey hidden field to store the session id
                    var skey = process.setSkey(data.skey);
                    var isMichigan = process.isInMichigan(postData.zip);
                    var isOrganic = (process.options.type === 'organic');
                    var showProfile = (isMichigan && isOrganic);

                    // presubmit providers
                    if(data.providers){
                        var providers = [];
                        var provider;
                        for (var i in data.providers){
                            provider = new noloPathProviderItem(data.providers[i], process.options);
                            providers.push(data.providers[i]);
                        }

                        var providersData = {
                            'zip': postData.zip,
                            'practiceAreaId': postData.practice_area_id,
                            'practiceAreaName': data.practice_area_name,
                            'providers': providers,
                            'providersCount': providers.length,
                            'cached': true,
                            'showProfile': showProfile,
                        };

                        // cache the data into memory
                        $elm.data('providersData', providersData);

                        // reset the session flags so new requests can be processed properly
                        process.reset = false;
                        process.queued = false;

                        // encode the JSON string it can be properly stored and passed to the next step
                        // since setHiddenField() 'decodes' URI Components by default, also set the hidden field to accept the value as-is
                        process.setHiddenField('nolopath_providers', encodeURIComponent(JSON.stringify(providersData)), false);
                    }

                    return;
                });

                // do something with the data
                promise.done(function(){
                    processData();
                    dfd.resolve();
                });

                // catch ajax errors
                promise.fail(function(xhr, status, error){
                    dfd.reject();
                    return process.onAjaxErrorSubmit(xhr, status, error, null, leadApiUrl);
                });
            }
        }

        if (!asyncPending){
            dfd.resolve();
        }

        return dfd.promise();
    }

    // EHCS-4769: ssdi-api5 will be getting the provider count on the same page rather than between each step
    noloPath.prototype.getProvidersData_alt = function(bypassZipCheck){
        var $elm = this.$element;
        var leadApiUrl = this.getLeadsSubmitApiUrl(true);
        var skey = $elm.find('input[name="skey"]').val();
        var postData = {
            'r': 'nololeadgenengine/rest/request/submit',
            'practice_area_id': $elm.find('input[name="practice_area_id"]').val(),
            'zip': $elm.find('input[name="zip"]').val(),
        };
        var getProviders = bypassZipCheck || this.canGetProviders();
        var process = this;
        var wait, timer;
        var cachedData = $elm.data('providersData');
        var hiddenData = $elm.find('input[name="nolopath_providers"]').val();
        var jsonData = hiddenData ? JSON.parse(decodeURIComponent(hiddenData)) : {};
        var zipCachedData = $elm.data('zipCodeData');
        // add skey if available
        if(skey){
            postData.skey = skey;
        }

        // waiting function
        function waiting(){
            var deferred = $.Deferred();
            // check every second for cached data
            timer = setInterval(function() {
                if(!$elm.data('providersData').cached) {
                    // notify the 'deferred' object in-case we want to do a progress function call
                    deferred.notify();
                } else {
                    // resolve the 'deferred' object once cached data is available
                    clearInterval(timer);
                    deferred.resolve();
                }
            }, 1000);

            return deferred.promise();
        }

        // processData function
        function processData(){
            var providersData = $elm.data('providersData');
            var providers = providersData.providers || [];
            var show_profile = providersData.showProfile || false;
            var providers_length = providers.length;
            var practice_area = providersData.practiceAreaName || null;
            if (!bypassZipCheck) {
                process.setProviders(providers, show_profile);
            } else {
                process.setProvidersText(providers_length, practice_area);
            }
        }

        // sync cached data from previous step
        if(jsonData.cached && !cachedData.cached){
            cachedData = jsonData;
            $elm.data('providersData', jsonData);
        }

        // check for cached data **NOTE** Disabled because it doesn't show the AOP message upon change with it enabled.
        //if (cachedData.cached){
            // check if 'zip' and 'practice_area_id' changed since the last check
            if(postData.zip === cachedData.zip && postData.practice_area_id === cachedData.practiceAreaId){
                // use existing cached data
                processData();
            } else {
                //check if a session has already started before resetting
                if(!process.reset){
                    // reset the data so it can be updated with the new zipcode and practice area
                    cachedData = {};

                    // flag this current request session as 'reset' so we can grab new data
                    process.reset = true;
                } else {
                    // a request session is detected
                    // flag this current request session as 'queued' so we can wait for new data
                    process.queued = true;
                }
            }
        //}

        // when the data is both 'reset' and 'queued', begin waiting
        // if (process.reset && process.queued){
        //     // an existing queued request is happening
        //     // wait until data('providersData') is populated
        //     wait = waiting();

        //     // when finished, use the cached data
        //     wait.done(function(){
        //         processData();
        //     });

        //     // just get out of this handler, now that it's done processing cached data
        //     return;
        // }


        // cached data is not found, try to grab it from LEADS API
        if (!cachedData.cached){

            // get data if allowed to do so
            if(zipCachedData.status === 'error'){
                // the zip-code is not valid, as flagged by GEOC API or LEADS API
                getProviders = false;

                // reset the both memory and json cache
                $elm.data('providersData', {});
                $elm.find('input[name="nolopath_providers"]').val('{}');

                // no providers request will run for an invalid zip, so clear the session flags;
                // otherwise the next valid zip is queued forever and submit never fires
                process.reset = false;
                process.queued = false;

                // update components after reset
                processData();
            } else {
                // data is not cached, flag the 'providersData' object to queue
                process.reset = true;
                process.queued = true;
            }

            getProviders = true;
            if (getProviders){
                // create the promise
                var promise = $.ajax({
                    type: 'POST',
                    crossDomain: true,
                    url: leadApiUrl,
                    data: $.param(postData),
                    dataType: 'json',
                });

                // on success, clean the data and cache it
                promise.done(function(data, status, xhr){
                    // set the skey hidden field to store the session id
                    var skey = process.setSkey(data.skey);
                    var isMichigan = process.isInMichigan(postData.zip);
                    var isOrganic = (process.options.type === 'organic');
                    var showProfile = (isMichigan && isOrganic);

                    // presubmit providers
                    if(data.providers){
                        var providers = [];
                        var provider;
                        for (var i in data.providers){
                            provider = new noloPathProviderItem(data.providers[i], process.options);
                            providers.push(data.providers[i]);
                        }

                        var providersData = {
                            'zip': postData.zip,
                            'practiceAreaId': postData.practice_area_id,
                            'practiceAreaName': data.practice_area_name,
                            'providers': providers,
                            'providersCount': providers.length,
                            'cached': true,
                            'showProfile': showProfile,
                        };

                        // cache the data into memory
                        $elm.data('providersData', providersData);

                        // reset the session flags so new requests can be processed properly
                        process.reset = false;
                        process.queued = false;

                        // encode the JSON string it can be properly stored and passed to the next step
                        // since setHiddenField() 'decodes' URI Components by default, also set the hidden field to accept the value as-is
                        process.setHiddenField('nolopath_providers', encodeURIComponent(JSON.stringify(providersData)), false);
                    }

                    return;
                });

                // do something with the data
                promise.done(function(){
                    processData();
                });

                promise.done(function(data) {
                    var provider_count = Object.keys(data.providers).length;
                    var provider_string = provider_count + " SSDI " + (provider_count == 1 ? "Lawyer" : "Lawyers"); 
                    document.querySelector(".presubmit-providers-count strong").innerText = provider_string;
                    if (provider_count > 0) {
                        document.querySelector(".sem-presubmit-providers-summary.sem-providers-summary").style = "";
                    }
                })

                // catch ajax errors
                promise.fail(function(xhr, status, error){
                    return process.onAjaxErrorSubmit(xhr, status, error, null, leadApiUrl);
                });
            }
        }

        return;
    }

    /*
     * EHCS-1645 - custom error message
     * add fieldName for missing error
     * fieldName is optional
     */
    noloPath.prototype.getErrorMessage = function(category, type, fieldName){
        var is_status_code = (typeof category === 'number');
        var errors = noloPath.CONSTANTS.inlineErrorMessages[this.options.lang];
        var c = is_status_code ? category : category.toLowerCase();
        var t = (typeof fieldName !== 'undefined') ? fieldName : (typeof type === 'string') ? type.toLowerCase() : 'undefined';
        var defaultError = errors.default + ' (' + c + ', ' + t + ')';
        var errorMessage = defaultError;

        // check if the desired error message is configured
        // -----
        // @note:
        // + resolves according to:
        //   + desired error message matching 'category' and 'type'
        //   + desired error message matching 'category' default
        //   + the 'default' error message
        // + the 'default' error should not displayed, by any normal circumstances,
        //   as it is indicative of an error somewhere in the code
        if(errors[c]){
            if ($.isPlainObject(errors[c])){
                errorMessage = errors[c][t] || errors[c]['default'] || defaultError;
            } else {
                errorMessage = errors[c] || defaultError;
            }
        }

        return errorMessage;
    };

    noloPath.prototype.getInlineErrorMessage = function($field, error){
        var errorMessage;
        var fieldType = $field.prop('tagName');
        var fieldName = $field.attr('name');
        var process = this;

        if ($field.attr('type') == 'checkbox'){
            fieldType = 'CHECKBOX';
        } else if ($field.hasClass('radio')) {
            if ($field.hasClass('custom-radio-input')){
                fieldType = 'CUSTOM_RADIO_INPUT';
                fieldName='custom_radio_input';
            }else{
                fieldType = 'RADIO';
            }
        }

        /*
         * EHCS-1645 - custom error message
         * add fieldName for missing error
         */
        switch(error){
            case 'missing':
            errorMessage = this.getErrorMessage(error, fieldType, fieldName);
            break;

            case 'invalid':
                if(process.options.type === 'organic' && fieldName == 'phone') {
                    errorMessage = this.getErrorMessage(error, fieldType, fieldName);
                } else if(fieldName == 'case_description') { // EHCS-3365 - Implement validation on the Case Description Field for SEO and SEM
                    errorMessage = this.getErrorMessage(error, fieldType, fieldName);
                } else {
                    errorMessage = this.getErrorMessage(error, fieldName);
                }
            break;

            case 'empty':
                errorMessage = '';
                break;

            default:
                if(process.options.type === 'organic' && typeof error === 'number' && fieldName == 'phone') {
                    errorMessage = this.getErrorMessage(error, fieldType, fieldName);
                } else {
                    errorMessage = (typeof error === 'number') ? this.getErrorMessage(error,fieldName) : error;
                }
        }

        return errorMessage;
    }

    noloPath.prototype.bindPracticeAreaSelect = function(){
        var $elm = this.$element;
        var $select = $elm.find('select[name="practice_area_select"]');
        var options = this.options;
        var mst_main = this.mst_main;
        var mst_title = this.mst_title;
        var mst_breadcrumb = this.mst_breadcrumb;
        var mst_partials = this.mst_partials;
        var mst_breadcrumb_steps = this.mst_breadcrumb_steps;
        var mst_breadcrumb_bar = this.mst_form_progress_bar;
        var query = this.query;
        var isOnFirstStep = this.isOnFirstStep();
        var serviceUrl = this.getServiceUrl(noloPath.CONSTANTS.getFormQuestionsDataUrl);
        var process = this;
        var $tooltipSpan =  $elm.find('#practice-area-tooltip');
        var $tooltipUl =  $elm.find('#pid_router_tooltip');
        //LLPLAT-1902: top lead tooltip, modal
        var $helperBody =  $elm.find('ul.pid-router-helper-body');//Desktop Helper Body(for dropdown select)
        var $tooltipHandler =  $elm.find('#pid_router_tooltip_handler');
        var $tooltopSelectHelper = $elm.find('#pid-router-helper');
        var fetchAOPContentFlag = true;
        var selectBox = null;
        // EHCS-2346 : Design / UI inconsistencies for drop down of routing question of TA SEM path
        if( $("body.nolopath-domain-leads-totalcriminaldefense").length == 1 && $("#nolopath-practice-area-select").length == 1 && this.options.type == 'sem' && this.options.pathId == 'cd-api2') {
            $("#nolopath-practice-area-select").selectBoxIt({
                theme: "default",
                //defaultText: "Please select from the following choices",
                autoWidth: false
            });
            selectBox = $("select#nolopath-practice-area-select").data("selectBox-selectBoxIt");
            selectBox.refresh();
            var selectSelectBoxItTextSize = $('body.media-range-mobile').length == 1 ? '250px' : '325px';
            $("#nolopath-practice-area-selectSelectBoxItText").css({"max-width": selectSelectBoxItTextSize, "font-size":"18px", "font-family":"Proxima Nova Rg Regular"});
        }
        if($select.length <= 1 && ($elm.hasClass('nolopath-pid-125') || $elm.attr('data-practice-area-id') == '125') && $elm.attr('data-step') == 'step-1' && $("body.nolopath-domain-leads-lawyers").length !== 1 && $("body").attr('data-type') !== 'sem'){
            var postData = query;
            postData['pid'] = 125;
            postData['practice_area_id'] = 125;
            postData['practice_area'] = 125;
            postData['location'] = $elm.find('input[name="zip"]').val() || postData['location'];
            postData['qset'] = process.getPathQuestionSet();
            postData['path'] = process.getPathID();
            postData['path_type'] = options.type;
            postData['domain'] = postData['domain'] || $elm.parent('#nolopath-insert').attr('data-domain');
            postData['routing'] = postData['routing'] || $elm.parent('#nolopath-insert').attr('data-routing');
            var promise = $.ajax({
                type: 'POST',
                url: serviceUrl,
                dataType: 'json',
                data: postData,
            });

            promise.done(function(data, status, xhr){
                process.appendRouting(data['aop_routing_q']);
            });
            promise.fail(function(xhr, status, error){
                return process.onAjaxErrorSubmit(xhr, status, error, $select, serviceUrl);
            });
        } else if (($("body").attr('data-type') == 'sem' ||  $("body.nolopath-domain-leads-lawyers").length == 1) && $('.form-container').is(':hidden')){
            $('.form-container').show();
        }

        //EHCS-3280
        // var urlParams = new URLSearchParams(window.location.search);
        // var routing = urlParams.get('routing');

        // if( $("body.nolopath-domain-leads-totalinjury").length == 1 && $("#nolopath-practice-area-select").length == 1 && this.options.type == 'sem' && this.options.pathId == 'pi-api9' &&  routing !== null) {

        //     var postData = query;
        //     postData['pid'] = 30;
        //     postData['practice_area_id'] = 30;
        //     postData['practice_area'] = 30;
        //     postData['location'] = $elm.find('input[name="zip"]').val() || postData['location'];
        //     postData['qset'] = process.getPathQuestionSet();
        //     postData['path'] = process.getPathID();
        //     postData['path_type'] = options.type;
        //     postData['domain'] = postData['domain'] || $elm.parent('#nolopath-insert').attr('data-domain');
        //     postData['routing'] = postData['routing'] || $elm.parent('#nolopath-insert').attr('data-routing');

        //     var promise = $.ajax({
        //         type: 'POST',
        //         url: serviceUrl,
        //         dataType: 'json',
        //         data: postData,
        //     });

        //     var url =  window.location.href;
        //     var step =    url.split('/').pop().split('#')[0].split('?')[0];

        //     promise.done(function(data, status, xhr) {
        //         if (step === 'step-2') {
        //             data["is_step-2"] = true;
        //         } else if (step === 'step-3')
        //         {
        //             data["is_step-3"] = true;
        //         }else if(step === 'step-4'){
        //             data["is_step-4"] = true;
        //         }else{
        //             data["is_step-1"] = true;
        //         }
        //         process.render(mst_breadcrumb_bar, '.form-breadcrumb-bar', data);
        //     });

        // }

        $select.off('change').on('change', function(event){
            var self = $(this);
            var val = self.val();
            var flatVal = val;
            var fieldIdxField = self.attr('data-update-field-index');
            var fieldIdx = null;
            if(fieldIdxField) fieldIdx = fieldIdxField.slice(-1);
            // EHCS-2346 : Design / UI inconsistencies for drop down of routing question of TA SEM path
            if( $("body.nolopath-domain-leads-totalcriminaldefense").length == 1 && $("#nolopath-practice-area-select").length == 1 && val) {
                val = val.split('_')[0];
            }
            // EHCS-2224: MVA path routing
            var hasGenericDropdown = $('body').find('[data-practice-area-id="1"]').length !== 0;
            if(val == "generic" &&  
            ($(document).find('#nolopath-insert').attr('data-domain') == 'lawyers.com' &&
            $(document).find('#nolopath-insert').attr('data-path') == 'min-path7')) {
                // top lead on LDC
                // hide the routing question and roll the dropdown back to new
                location.href = location.origin + '/path2/min-path4'
            } else if(val == "generic" && hasGenericDropdown) {

            } else if(val == 125 && $("body.nolopath-domain-leads-lawyers").length !== 1 && $('body').attr('data-type') !== 'sem') {
                window.appendAopRoutingDropdown = hasGenericDropdown;
                $('.form-container').show();
            } 
            var postData = query;
            var optionIndexValue = self.find(":selected").index();
            // this postData will also be set as hidden fields when the data is retrieved
            postData['pid'] = val;
            postData['practice_area_id'] = val;
            postData['practice_area'] = val;
            postData['location'] = $elm.find('input[name="zip"]').val() || postData['location'];
            postData['qset'] = process.getPathQuestionSet();
            postData['path'] = process.getPathID();
            postData['path_type'] = options.type;
            postData['domain'] = postData['domain'] || $elm.parent('#nolopath-insert').attr('data-domain');
            postData['routing'] = postData['routing'] || $elm.parent('#nolopath-insert').attr('data-routing');

            //EHCS-5307: seo leads with potential ?pid routing 
            var queryParam = new URLSearchParams(window.location.search);
            if ($('body').attr('data-type') !== 'sem' && 
                (queryParam.has('pid') &&  ['14', '74'].includes(queryParam.get('pid')))) {
                    if(val == 8937) {
                        postData['routing_question'] = document.querySelector('#nolopath .form-practice-area-select label').innerText;
                        postData['routing_answer'] = document.querySelector('#nolopath .form-practice-area-select select option[value="' + val + '"]').innerText;
                        postData['routing_value'] = val;
                    }  else {
                        delete postData.routing_question;
                        delete postData.routing_answer;
                        delete postData.routing_value;
                    }
            }
            //switch postdata pid to PI for a/b test pids to pull proper QA
            if(postData['pid'] == '30a' || postData['pid'] == '30b' || postData['pid'] == '30c'){
                postData['pid'] = 30;
            }
            // LLPLAT-2716: Adding Voice CTA on DUI Drivinglaws form paths update pid
            $('body').attr('data-pid', val);

            // LLPLAT-2740: Adding Voice CTA on Nolo SEM path for MVA (Desktop and Mobile)
            if( Object.keys( $.NOLO_PATH_CONSTANTS.aopDomainContact ).length > 0 ) {
                var selected_pid = parseInt(val);
                if( selected_pid in $.NOLO_PATH_CONSTANTS.aopDomainContact.aop_phone_numbers ) {
                    var aop_phone_numbers = $.NOLO_PATH_CONSTANTS.aopDomainContact.aop_phone_numbers[selected_pid];
                    $('a.voice_cta_tel').attr('href', 'tel:' + aop_phone_numbers.raw);
                    $('a.voice_cta_tel').find('span:first').html(aop_phone_numbers.formatted);
                    $('.voice-cta-float').find('.call-help-text').html(aop_phone_numbers.phone_title);
                    $('.voice-cta-float').find('.call-help-content').html(aop_phone_numbers.phone_subtitle);
                    if( $('div.liveChatFloatingButtonSpacer').length == 0 && $('div.sem-chat-block').length ) {
                        $('div.sem-chat-block').css('display', 'none');
                    }
                }
            }

            /*
            if($elm.find('input[name="direct_guid"]').val()){
                postData['direct_guid'] = $elm.find('input[name="direct_guid"]').val();
            }
            */            

            //LLPLAT-1902: tooltip + modal solution 2, using active-pid to track visible tooltip
            $helperBody.find("[data-pid-active=true]").attr( 'data-pid-active', "false")//hide all visible pid helper text
            //data-pid-active attribute as true, the css will show the pid text
            if (val > 0 && fieldIdx){
                $helperBody.children().eq(fieldIdx).attr('data-pid-active', "true");
            }
            else if(val > 0) {
                $helperBody.children().eq(optionIndexValue-1).attr('data-pid-active', "true");//update tooltip helper list
            }
            $tooltopSelectHelper.attr( 'data-pid-router', val);
            $select.attr( 'data-pid-router', val);

            // a set of required fields to pass to the API
            var fields = [
                'direct_guid',
                'region_id',
                'block_id',
                'path_url',
                'domain',
                'source',
                'data',
                'surl',
                'referer'
            ];

            // retrieve values from hidden fields, if present
            for (var i in fields){
                if($elm.find('input[name="' + fields[i] + '"]').val()){
                    postData[fields[i]] = $elm.find('input[name="' + fields[i] + '"]').val();
                }
            }

            if(fetchAOPContentFlag) {
                fetchAOPContentFlag = false;
                if( selectBox != null ) {
                    selectBox.refresh();
                    selectBox.selectOption(flatVal);
                    var selectSelectBoxItTextSize = $('body.media-range-mobile').length == 1 ? '250px' : '325px';
                    $("#nolopath-practice-area-selectSelectBoxItText").css({"max-width":selectSelectBoxItTextSize, "font-size":"18px", "font-family":"Proxima Nova Rg Regular"});
                }
                // promise setup
                var promise = $.ajax({
                    type: 'POST',
                    url: serviceUrl,
                    dataType: 'json',
                    data: postData,
                });
                // on success, clean the data and cache it
                promise.done(function(data, status, xhr){
                    var dp_title_applied = $('.form-heading').find('.dp-vars-title').length>0;

                    // EHCS-4502 - legacy paths auto accident routing bug fix
                    var query1 = window.location.search;
                    var params1 = new URLSearchParams(query1);
                    var pathList = ['min-path2', 'min-path7'];
                    if(pathList.includes(postData['path']) && postData['pid'] == 'generic2' && params1.size == 0) {
                        $("#nolopath-practice-area-select").closest('.form-item').hide();
                    }

                    // render into the page
                    process.render(mst_main, '.form-questions', data, mst_partials);

                    if(data['aop_routing_q'] !== undefined && window.appendAopRoutingDropdown) {
                        delete window.appendAopRoutingDropdown;
                        process.pendingRoutingDropDown(data['aop_routing_q']);
                    }
                    if(postData['pid'] == 'generic') {
                        process.removeRoutingDropDown();
                    }
                    if(postData['pid'] == 'generic2') {
                        process.redirectMainPath();
                    }

                    if(postData['pid'] != 125 && postData['pid'] != 'generic2'){
                        window.aopRoutingSet = false;
                        $(".aop-routing").remove();
                        $('.form-container').show();
                    }
                    //EHCS-1896: if dynamic variabl:title is applied, do not render the title from pre-defined data.
                    if(!dp_title_applied) {
                        process.render(mst_title, '.form-heading', data);
                    }
                    process.render(mst_breadcrumb, '.form-breadcrumb', data);

                    //LLPLAT-1251:if the form config has a min_path4_title_pa, update the title:
                    //EHCS-1896: if dynamic variabl:title is applied, do not render the title from pre-defined data.
                    if(data.min_path4_title_pa && !dp_title_applied){
                        process.render(mst_title, '.panel-title', {min_path_title:data.min_path4_title_pa});
                    }

                    // clear any existing errors
                    var isMinPath3RefreshRecaptcha = location.pathname.includes('min-path3') && sessionStorage.getItem('refreshRecaptcha');
                    if(!isMinPath3RefreshRecaptcha){
                        process.clearErrors();
                    } else if(isMinPath3RefreshRecaptcha) {
                        sessionStorage.removeItem('refreshRecaptcha');
                    }

                    // @note:
                    // + the path element can initially start with 'no-questions' class attached
                    // + this will only happen when the path is loaded with an invalid practice area as a default
                    // + we will use this class to help show/hide elements in the path
                    if($elm.hasClass('no-questions')){
                        // remove 'no-questions' to help identify that the path now has a valid practice area loaded
                        $elm.removeClass('no-questions');
                    }

                    // if, for some reason, the user makes a different selection
                    // when they have already advanced on the current practice area,
                    // reset the current step so they are directed back correctly
                    if(!isOnFirstStep){
                        process.setCurrentStep('step-1');
                    }

                    // update path practice area data
                    process.setPathData('practiceAreaName', data.practice_area_name);
                    process.setPathData('practiceAreaId', data.practice_area_id);

                    if(data.practice_area_id == undefined && data.pid != undefined){
                        process.setPathData('practiceAreaId', data.pid);
                    }

                    // EHCS-2080 - GA4: Setting up Content Grouping by AOP and Directory
                    process.setGa4ContentGroup( data.pid, data.practice_area_name );

                    // EHCS-2105 - GA4: DUI/DWI path: first question event is not triggered
                    if( postData['region_id'] != 'none') {
                        var question_no = 'q' + data.pid;
                        process.triggerGa4Event('questionAnswered', question_no);
                    }

                    // the process of rendering destroys any existing behavior from the previous form
                    // initialize the steps again to regain what was lost
                    process.initSteps(data);

                    // Emit event to signal practice area change has completed
                    $select.trigger('changed-practice-area');
                    process.getProvidersData(true);
                    if (postData['path'] === 'find-a-lawyer') {
                        gtag('event', 'AoP Selected', {
                            'event_category': 'SEM Generic Page AoP',
                            'event_label': data.practice_area_name,
                            'value': data.pid
                        });
                    }

                    // update confirmRoute when AOP is selected from dropdown
                    if(data.confirmRoute) {
                        process.options.confirmRoute = data.confirmRoute;
                    }

                    // LLPLAT-2029: check if the zip code is answered before aop selected:
                    if (postData['path'] === 'pi-api5pp') {
                        var $nolopath = $('#nolopath');
                        var zip = $nolopath.find('input[name="zip"]');
                        var zipInput = $nolopath.find('input[name="zipInput"]');
                        if(zipInput && zipInput.val() && zip && !zip.val()){
                            zip.val(zipInput.val());
                        }
                    }
                    fetchAOPContentFlag = true;

                    //EHCS-3794: handle cd-api1 cd-api2 routing q for replacing q801
                    if ((options.pathId == 'cd-api1' || options.pathId == 'cd-api1pp' || options.pathId == 'cd-api2') && 
                    document.querySelector("#form-item-q801") != null) {
                        if (options.pathId == 'cd-api1pp') {
                            if (document.querySelector('label[for="nolopath-practice-area-select"]').innerHTML.includes("pending charge") &&
                                document.querySelector("#nolopath-practice-area-select").value == '14') {
                                document.querySelector("#nolopath-q801").selectedIndex = 1;
                                document.querySelector("#form-item-q801").style = "display: none";
                            }
                        } else {
                            if (document.querySelector('#form-practice-area-select label').innerHTML.includes("pending charge") && 
                                document.querySelector('#form-practice-area-select select').value == '14') {
                                document.querySelector("#form-item-q801 select").selectedIndex = 1;
                                document.querySelector("#form-item-q801").style = "display: none";
                            }
                        }
                    }
                    

                    if(typeof $tooltipSpan != 'undefined' && $tooltipUl.children().length > 0){
                        if( val > 0 && $.trim($tooltipUl.children().eq(optionIndexValue-1).text()).length > 0 ) {
                            $tooltipSpan.removeClass('hide');
                            $tooltipHandler.removeClass('hide');
                            $tooltipSpan.attr( 'title', $tooltipUl.children().eq(optionIndexValue-1).text() );
                        } else {
                            $tooltipSpan.addClass('hide');
                            $tooltipHandler.addClass('hide');
                            $tooltipSpan.attr('title','');
                        }

                        //EHCS-2223: Criminal Defense - Changes in Routing Logic - SEO Paths
                        var custom_routing_option = self.find(":selected").attr('custom_routing');
                        var targetAttr = self.find(":selected").attr('target');
                        
                        if(typeof custom_routing_option === 'undefined' && window.routingTarget) {
                            custom_routing_option = $select.find('option[index="'+ window.fieldIndexValue +'"]').attr('custom_routing');
                            targetAttr =  window.routingTarget;
                        }

                        if(typeof custom_routing_option != 'undefined') {
                            // EHCS-2268: Top Article Path Unrouted TYP Redirects To Min Path 4 When Going Back
                            $('#page-container').append('<input type="hidden" name="routing_confirm_unrouted" value="true"/>');
                            $(".form-container .form-questions").hide();
                            window.routingTarget = targetAttr;
                            var pid = process.getPathPracticeAreaId();
                            var routingTarget = window.routingTarget?window.routingTarget:'998';
                            var unroutedData = {
                                show_message: "message",
                                nolopath: {
                                    nolopath_providers: "nolopath_providers",
                                },
                                practice_area_id: pid,
                                qa: {
                                    8: {
                                        type: "select",
                                        value: (routingTarget+": Victim of a crime"),
                                        answer: "N/A",
                                        question_id: "8",
                                        answer_id: routingTarget
                                    }
                                },
                                unrouted: true,
                                is_unrouted: true,
                                routing_unrouted:true,
                                confirm_route: 'confirm/unrouted'
                            };
                            process.loadConfirmationStep(unroutedData);
                            return false;
                        } else {
                            $('#page-container').find("input[type='hidden'][name='routing_confirm_unrouted']").remove();
                            $('#page-container').find("input[type='hidden'][name='routing_confirm_unrouted_mobile']").remove();
                            $(".form-container").show();
                            $(".form-container .form-questions").show();
                            $("#toggle-question-content").show();
                            $(".form-container .form-actions .form-actions-btn-group").show();
                        }
                        
                    }
                    nonInjuryFreeRemoval();

                    handleTrustedForm();

                    var urlParams = new URLSearchParams(window.location.search);

                    if (urlParams.get('routing') == 'pi5' || urlParams.get('routing') == 'cd1' /* || urlParams.get('routing') == 'pi5b' og-pi5b*/ || ['cd-api1d', 'cd-api1dpp'].includes(options.pathId)) {
                        var $cElm = $('#nolopath-form');
                        var $hidden = $cElm.find('.form-hidden-questions');
                        var $field  = $cElm.find('input[name="'+name+'"]');
                        var name = 'routing_answer';
                        var value = event.target.children[event.target.selectedIndex].innerText;
                        
                        // add the field
                        $field = '<input type="hidden" name="'+name+'" value="'+value+'" />';
                        $hidden.append($field);
                    }
                    
                });

                // catch ajax errors
                promise.fail(function(xhr, status, error){
                    fetchAOPContentFlag = true;
                    return process.onAjaxErrorSubmit(xhr, status, error, $select, serviceUrl);
                });
            }

        });

        // extract the 'direct_guid' only if configured
        if(options.setDirectGuid){
            var guid = this.extractDirectGUID();
            if (guid) this.setDefaultAOP();
        }

        // fire an initial change event if a value is detected
        if($select.val() > 0) {
            $select.trigger('change');
            
            // EHCS-2411: the routing button isn't pre selected
            if ($select.context.classList.contains("sem-ajax-form","routing")) {
                $('#form-practice-area-select .input-box .btn-group button[data-update-field-value="'+$select.val()+'"]').click();
            }
        }

        //LLPLAT-1902 simple tooltip hover method
        $tooltipHandler.on('mouseenter',function(){
            var self = $(this);
            var tooltipWindow = $(self.attr("data-target"));
            tooltipWindow.show();
        });
        $tooltipHandler.on('mouseleave',function(){
            var self = $(this);
            var tooltipWindow = $(self.attr("data-target"));
            if(tooltipWindow.find('a').length == 0){
                tooltipWindow.hide();
            }
        });

        $('.tooltip-container').on('mouseenter',function(){
            var self = $(this).find('.tooltip-handler');;
            var tooltipWindow = $(self.attr("data-target"));
            tooltipWindow.addClass("show");
            tooltipWindow.show();
        });
        $('.tooltip-container').on('mouseleave',function(){
            var self = $(this).find('.tooltip-handler');
            var tooltipWindow = $(self.attr("data-target"));
            if(tooltipWindow.find('a').length == 0){
                tooltipWindow.removeClass("show");
                tooltipWindow.hide();
            }
        });

        if (window.innerWidth < 1199) {
            $('.tooltip-container').on('click',function(){
                var self = $(this).find('.tooltip-handler');;
                var tooltipWindow = $(self.attr("data-target"));
                if (tooltipWindow.hasClass("show")) {
                    tooltipWindow.removeClass("show");
                    tooltipWindow.hide();   
                } else {
                    $(".tooltip-helper-body.show").hide()
                    $(".tooltip-helper-body.show").removeClass("show");
                    tooltipWindow.addClass("show");
                    tooltipWindow.show();
                }
            });
        }

        //EHCS-2223: Criminal Defense - Changes in Routing Logic - SEO Paths
        $helperBody.on('mouseenter',function(){
            $(this).show();
        });
        $helperBody.on('mouseleave',function(){
            $(this).hide();
        });

        // Check if it's LDC top lead:
        var isLDCTop = $(document).find('#nolopath-insert').attr('data-domain') == 'lawyers.com' &&
        $(document).find('#nolopath-insert').attr('data-path') == 'min-path7';
        if(isLDCTop){
            $elm.find(".form-practice-area-select.pid-helper-wrap .mobile-modal .question-mark-icon").each(function(){
                $(this).on('mousedown',function(){
                    $elm.find($(this).attr("data-target")).show();
                    $(".modal-backdrop").show();
                })
            });
            
            $elm.find(".form-practice-area-select.pid-helper-wrap .mobile-modal .btn-dismiss").each(function(){
                $(this).on('mousedown',function(){
                    $(this).parents(".modal.router-helper-bd-wrap").hide();
                    $(".modal-backdrop").hide();
                })
            });

            $("body").append('<div class="modal-backdrop" style="display:none;"></div>');

            $(".modal-backdrop").on("mousedown",function(){
                $elm.find(".form-practice-area-select.pid-helper-wrap .mobile-modal .modal.router-helper-bd-wrap").hide();
                $(".modal-backdrop").hide();
            });

        }
    }

    noloPath.prototype.bindZipCodeField = function(){
        var $elm  = this.$element;
        var $zip = $elm.find('input[name="zipInput"]').length > 0 ? $elm.find('input[name="zipInput"]') : $elm.find('input[name="zip"]');
        var process = this;
        var $loc  = $elm.find('input[name="location"]').val() || $zip.val();
        var cachedData = $elm.data('zipCodeData');
        var getZipCodeFromLocation = (this.getCurrentStepIndex() === 1);

        // For pi5b
        var pi5bRouting = false;
        var urlParams = new URLSearchParams(window.location.search);
        if((this.pathData.pathId == 'pi-api5' || this.pathData.pathId == 'pi-api5pp') && urlParams.has('routing')){
            pi5bRouting = urlParams.get('routing');
        }
    

        if($zip.is('[readonly]')) $zip.attr('readonly', false);

        if($zip.length > 0){
            // bind the blur event to the zipcode field
            if (!pi5bRouting) {                    
                
                if ($.find('input[name="practice_area_id"]').length === 0) {
                    // EHCS-4738
                    // cd-api1pp or other routing questions on mobile display with the "pp" styling, the zip code iss the first Q
                    // checks if zip code is available at $elm.find('input[name="practice_area_id"]').val() <- it's a hidden input
                    // if not then don't do this or else we get thrown into a loop
                } else {
                    this.configureBlurWorkaround($zip, function (event) {
                        var self = $(this);
                        // console.log(event);
                        process.validateZipCode(self.val(), event);
                        return;
                    });
                }
            }

            $zip.on('input', function(){
                var self = $(this);
                // EHCS-5688: allow free-text (city/location) entry on the geo-autocomplete DUI
                // variant. Gated on the server-rendered container class so it holds regardless
                // of Google Maps load timing or AJAX question re-renders.
                if (self.closest('#nolopath').hasClass('np-loc-geo')) { return true; }
                self.val(self.val().replace(/[^0-9]/g, ""));
                var maxCount = 5;
                if(self.val().length >= maxCount){
                    self.val(self.val().substring(0,maxCount));
                    return false;
                }
                return true;
            });

            // assign the passed location parameter to the zipcode field and trigger validation
            if($loc){
                // perform this only if in the first step
                if (getZipCodeFromLocation){
                    $zip.val($loc).trigger('blur').trigger('input');
                }
            } else {
                // grab zip-code from IP only if it has not run before
                if($.isEmptyObject(cachedData)){
                    this.getZipCodeFromIp($zip);
                } else {
                    $zip.val(cachedData.zipCode).trigger('blur').trigger('input');
                }
            }
        } else {
            // grab zip-code from IP so we can cache it
            this.getZipCodeFromIp();
        }
    }

    noloPath.prototype.bindSubmitForm = function(method){
        var $backtrack = this.getElement('.form-action-backtrack');
        var $submit = this.getElement('.form-actions .form-action-submit');
        var backtrackForm = $.proxy(this, 'backtrackForm');
        var submitForm = $.proxy(this, 'submitForm');

        // bind sibmit handler
        $submit.on('click', submitForm);

        // bind backtrack handler
        $backtrack.on('click', backtrackForm);

        return false;
    }

    noloPath.prototype.bindRemoteUpdate = function(){
        var options = this.options;
        var $elm = this.$element
        var $btn = $elm.find('button[data-toggle="remoteUpdate"]');
        var $field = $elm.find('textarea[data-toggle="remoteUpdate"]');
        var $txt = $elm.find('input[type="tel"][data-toggle="remoteUpdate"]');
        var $select = $elm.find('select[data-toggle="remoteUpdate"]');
        var $input = $elm.find('input[data-toggle="remoteUpdate"]').not('input[type="tel"][data-toggle="remoteUpdate"]');
        var process = this;

        $txt.on('input', function(){
            var self = $(this);

            var fieldTag = self.data('updateField');
            var fieldName = self.data('updateFieldName');
            var $field = $elm.find('[name="'+fieldName+'"]');
            var selfValue = self.val();
            var numbersRegex = /^\d+$/;
            var numbers = selfValue.replace(numbersRegex, selfValue);

            switch(fieldTag){
                case 'select':
                // create a map of option text and option values
                var map = {};
                $field.find('option').each(function(){
                    var self = $(this);
                    var value = self.attr('value');
                    var txt = self.text();

                    map[txt] = value;
                });

                if(fieldName == 'questions[1066]'){
                    if(map[numbers]){
                        $field.val(map[numbers]);
                    } else if(numbers.length < 2 && !Object.hasOwn(map, numbers)){
                        return;
                    } else {
                        return;
                    }
                } else {
                    // if the typed-in value from the input field matches a property in the map
                    // set the value
                    if (map[selfValue]) {
                        $field.val(map[selfValue]);
                    } else {
                        $field.val(0);
                    }
                }
                $field.change();
                break;
            }
        });

        $field.on('input', function(){
            var self = $(this);
            var fieldTag = self.data('updateField');
            var fieldName = self.data('updateFieldName');
            var fieldValue = self.data('updateFieldValue');
            var $field = $elm.find('[name="'+fieldName+'"]');
            var selfValue = $.trim(self.val());

            if(selfValue.length > 0){
                $field.val(selfValue);
            } else {
                $field.val(fieldValue);
            }
        });

        $input.on('input', function(){
            var self = $(this);
            var fieldName = self.data('updateFieldName');
            var fieldValue = self.data('updateFieldValue');
            var $field = $elm.find('[name="'+fieldName+'"]');
            var selfValue = $.trim(self.val());

            if(selfValue.length > 0){
                $field.val(selfValue);
            } else {
                $field.val(fieldValue);
            }
        });

        $btn.off().on('click', function(event){
            var self = $(this);
            var fieldTag = self.data('updateField');
            var fieldName = self.data('updateFieldName');
            var fieldValue = self.data('updateFieldValue');
            // LLPLAT-1902: PI routing question, have duplicated value option(pid=30), using data-update-field-indexto track which option being clicked
            var fieldIndx = 0;
            if(self.attr('data-update-field-index')) fieldIndx = self.attr('data-update-field-index');
            var $field = $elm.find('[name="'+fieldName+'"]');

            self.addClass('active');
            self.parent().siblings('.btn-group').find('button').removeClass('active');           

            switch(fieldTag){
                case 'select':
                $field.val(fieldValue);   
                // LLPLAT-1902: PI routing question, have duplicated value option(pid=30), using data-update-field-indexto track which option being clicked
                if(fieldIndx!==0) $field.attr('data-update-field-index',fieldIndx)
                $field.change();
                break;
            }                  

            //EHCS-2223: Criminal Defense - Changes in Routing Logic - SEO Paths (Mobile Radio Buttons)
            var data_field_name = self.attr('data-update-field-name');
            if(data_field_name === 'practice_area_select'){
                var custom_routing_option = self.attr('custom_routing');
                if(typeof custom_routing_option != 'undefined') {
                    $('#page-container').append('<input type="hidden" name="routing_confirm_unrouted_mobile" value="true"/>');
                    $(".form-container .form-questions").hide();
                    window.routingTarget = self.attr('target');
                    window.fieldIndexValue = self.attr('data-update-field-index');
                    $select.find('option').removeAttr('selected');
                    $select.find('option[target="'+ (self.attr('target')) +'"]').attr('selected','selected');
                } else {
                    $(".form-container").show();
                    $(".form-container .form-questions").show();
                    $("#toggle-question-content").show();
                    $(".form-container .form-actions .form-actions-btn-group").show();
                    $('#page-container').find("input[type='hidden'][name='routing_confirm_unrouted']").remove();
                    $('#page-container').find("input[type='hidden'][name='routing_confirm_unrouted_mobile']").remove();
                }
            } 
        });

        $select.on('change', function(){
            var self = $(this);
            var fieldValue = self.val();
            var fieldName = self.attr('name');
            var buttonSearchStr ='button[data-update-field-name="'+fieldName+'"][data-update-field-value="'+fieldValue+'"]';
            // LLPLAT-1902: PI routing question, have duplicated value option(pid=30), using data-update-field-indexto track which option being clicked
            if(self.attr('data-update-field-index')) buttonSearchStr += '[data-update-field-index="'+self.attr('data-update-field-index')+'"]';
            var $button = $elm.find(buttonSearchStr);
            var $input = $elm.find('input[name="remote_'+fieldName+'"]');

            // set button group state
            // -----
            // @note:
            // + select remote updates can be referencing a button group component
            // + that component serves as a proxy to answering the select field
            // + set/remove the 'active' class to match the select field's answer
            if($button.length > 0) {
                $button.addClass('active');
                $button.parent().siblings('.btn-group').find('button').removeClass('active');
            }

            // set input field value
            // -----
            // @note:
            // + select remote updates can be referencing an input field
            // + that component serves as a proxy to answering the select field
            // + set the field value to match the select field's answer
            
            // apply only to age question in SSDI. 
            if($input.length > 0 && fieldName == 'questions[1066]'){
                // reduce to actual field value
                // -----
                // @note:
                // + select field option values follow this format, '[index][separator][value]', where:
                //   + index: a numerical index for LEADS API
                //   + separator: a string separtor composed of a comma and a space (': ')
                //   + value: the actual value of the field
                // + this pattern is required by LEADS API for consumption
                // + reduce to just the field value so the validators can function properly
                $input.val(fieldValue.replace(/\d+: +/g, ''));
            }
        });

        return false;
    }

    noloPath.prototype.bindNavigateButtons = function() {
        var process = this;
        var $elm = this.$element;
        var $forward = $elm.find('a.forward-link');
        var $back = $elm.find('a.back-link');

        $forward.off().on('click', function() {
            process.navigateLogic($elm.find('.form-step-1 .form-item.active'), 'forward');
            process.triggerEvent('semButtonClick','next');
        });

        $back.off().on('click', function() {
            process.navigateLogic($elm.find('.form-step-1 .form-item.active'), 'back');
            process.triggerEvent('semButtonClick','back');
        });
    }

    noloPath.prototype.bindOverlay = function() {
        var $elm = this.getElement();
        var $overlay = this.getElement('.button-overlay');
        var $overlayDisable = this.getElement('.overlay-disable');

        // bind overlay handler
        $overlay.click(function(){
            $elm.addClass('overlay-disabled');
            $overlay.hide();
            $overlayDisable.hide();
        });
    }

    noloPath.prototype.isGatekeeper = function($self) {
        var fieldType = $self.prop('tagName') || null;
        switch(fieldType) {
            case 'DIV':
                return $self.hasClass('validate-gatekeeper');
            case 'SELECT':
                var selectedIndex = $self[0].options.selectedIndex;
                if ($self[0].options[selectedIndex].dataset) {
                    return Boolean($self[0].options[selectedIndex].dataset.fieldGatekeeper);
                }
            default:
                return false;
        }
    }

    noloPath.prototype.mapAnswer = function(dataIn) {
        var qExp = /questions%5B671%5D=[4567]/;
        var data = dataIn.replace(qExp, "questions%5B671%5D=1");
        return data;
    };

    noloPath.prototype.navigateLogic = function($self, direction) {
        var $elm = this.$element;
        var questionData = this.getQuestionData();
        var $nextQuestion;
        var $nextToNextQuestion;
        var $container = $elm.find('.navigate-links');
        var $backLink = $elm.find('.back-link');
        var $forwardLink = $elm.find('.forward-link');
        var $panelHeading = $elm.find('.panel-heading');
        var $formSelect = $self.find('.form-select');
        var $practice_area_router = $elm.find('.form-practice-area-select .form-item');
        var searchParamsData = new URLSearchParams(window.location.search);
        var isQuestionnaireTest = false;
        if (window.NCMS != undefined) {
            isQuestionnaireTest = [81, 84, 5016].includes(parseInt(window.NCMS.aopId)) ? true : false;

            //LDC also has this NCMS global var, check again
            if (window.location.hostname.includes('legal-info') && (window.location.hostname.includes('lawyers.com') || window.location.hostname.includes('mhdev.tech'))) {
                isQuestionnaireTest = [81, 84, 5016].includes(parseInt(document.querySelector('#nolopath[data-practice-area-id]').getAttribute('data-practice-area-id'))) ? true : false;
            }

        } else if(document.querySelector('body').getAttribute('data-type') == 'organic'){
            isQuestionnaireTest = [81, 84, 5016].includes(parseInt(document.querySelector('body').getAttribute('data-pid'))) ? true : false;
        }

        // Get next question (can be next or prev) and update active question data
        if(direction === 'forward') {
            if(this.isGatekeeper($formSelect)) {
                $forwardLink.addClass('disabled');
                $elm.find("[type='submit'].form-action-submit").addClass('form-incomplete');
                return;
            }

            $nextQuestion = $self.next();
            var nextChosen = false;
            var i = 0;
            do {
                i = i + 1;
                if (i > 12) { nextChosen = true; }
                if ($nextQuestion.hasClass("disabled")) {
                    $nextQuestion.removeClass('active');
                    $nextQuestion = $nextQuestion.next();
                } else {
                    nextChosen = true;
                }
            } while (nextChosen === false);

            if(questionData.active + 1 <= questionData.step_1_total) {
                questionData.active += 1;
            }

            // Check for the Get Free Evaluation should be enabled(weird behavior the desc question not being considered as answered for top lead mobile)
            if(document.getElementById("nolopath-insert")){
                var notAnswered = $('.form-step.form-step-1.active').find('.not-answered.required').length;
                if( notAnswered < 1 && (questionData.active == questionData.step_1_total)) {
                    // make sure we're on the last step before allowing submission
                    if (document.querySelector(".navigate-links.last") != null) {
                        $('.form-actions').addClass('valid').removeClass('not-valid');
                    }

                    var $nextToNetQuestion = $nextQuestion.next();
                    if(direction == 'forward' && $nextQuestion && $nextQuestion.attr('id') == 'form-item-zip' && $nextQuestion.hasClass("answered") && $nextToNetQuestion && $nextToNetQuestion.attr('id') == 'form-item-case_description') {
                        $('.form-actions').addClass('valid').removeClass('not-valid');
                    }
                }

                if(questionData.progressBarCount < questionData.step_1_total && questionData.progressBarCount < questionData.answered) {
                    questionData.progressBarCount++;
                }
            }
            this.updateProgress();
        } else if (direction === 'back'){
            $nextQuestion = $self.prev();
            // EHCS-4041 - Wrongful Termination navigation back optional question
            if (isQuestionnaireTest && this.isMobile() && $nextQuestion.hasClass("disabled")) {
                $self.removeClass('active');
                $self = $nextQuestion;
                $self.removeClass('active');
                $nextQuestion = $self.prev();        
            } else if (window.location.hostname.includes('legal-info') && (window.location.hostname.includes('lawyers.com') || window.location.hostname.includes('mhdev.tech'))) {
                if (isQuestionnaireTest && window.innerWidth < 599 && $nextQuestion.hasClass("disabled")) {
                    $self.removeClass('active');
                    $self = $nextQuestion;
                    $self.removeClass('active');
                    $nextQuestion = $self.prev();  
                }
            }
            $forwardLink.show();
            $container.removeClass('last');
            if(questionData.active - 1 >= 1){
                questionData.active -= 1;
            }
            $elm.find('.form-actions').removeClass('valid').addClass('not-valid');

            if(questionData.progressBarCount > 0) {
                questionData.progressBarCount--;
            }
            this.updateProgress();
        } else {
            if(this.isGatekeeper($formSelect)) {
                $forwardLink.addClass('disabled');
                $elm.find("[type='submit'].form-action-submit").addClass('form-incomplete');
                return;
            }
        }

        // If the parent is a practice area, revert previous increment
        if($self.parent().hasClass('form-practice-area-select')) {
            questionData.active -= 1;
        }

        // Update active question
        if (direction && $nextQuestion) {
            $self.removeClass('active');
            $nextQuestion.addClass('active');
        }

        if(questionData.active != 1) {
            $backLink.show();
            $panelHeading.addClass('mobile-hide');
            $elm.addClass('hide-instructions');
            $elm.find('.progress-container').show();
            if(questionData.active == questionData.step_1_total) {
                $forwardLink.hide();
                $forwardLink.removeClass('disabled');
                $container.addClass('last');
                if(window.NCMS && [81, 84, 5016].includes(window.NCMS.aopId) && $('#form-item-case_description').hasClass("active") && $('#nolopath-qcase_description').is(":visible") && $('#nolopath-qcase_description').val() != '') {
                    $('.form-actions').addClass('valid').removeClass('not-valid');
                    $('.form-actions').addClass('test-class');
                }
                if($practice_area_router.length==1){
                    var isRouterAnswered = $practice_area_router.hasClass('answered');
                    $practice_area_router.removeClass('active');
                    if(!isRouterAnswered) {
                        $practice_area_router.addClass('answered');
                    }
                }
            }else{
                // EHCS-1848: if there's a form-practice-area-select question for aop routing, hide it with panelHeading
                if($practice_area_router.length==1){
                    var wasRouterActive = $practice_area_router.hasClass('active');
                    $practice_area_router.removeClass('active');
                    var isRouterAnswered = $practice_area_router.hasClass('answered');
                    if(!isRouterAnswered) {
                        $practice_area_router.addClass('answered');
                    }
                    $elm.find('.progress-container').show();
                    // EHCS-2225
                    var isTopLead = document.getElementById("nolopath-insert");
                    if( isTopLead && 
                        (wasRouterActive || (!wasRouterActive && !isRouterAnswered) &&
                        window.innerWidth <= 600) 
                        ) {
                            if(!isQuestionnaireTest && this.isMobile()){
                                if($(".progress-container").length && $(".progress-container").offset().top) {
                                    window.scroll($(".progress-container").offset().left, $(".progress-container").offset().top - ($(".progress-container").height() + 20));
                                }
                            }
                    }
                }
            }
        } else {
            $backLink.hide();
            $panelHeading.removeClass('mobile-hide');
            $elm.removeClass('hide-instructions');
            // EHCS-1848: if there's form-practice-area-select question for aop routing, show it with panelHeading
            if($practice_area_router.length==1){
                $practice_area_router.addClass('active');
                $elm.find('.progress-container').hide();
            }

            if($self.attr('id') == 'form-item-q6' && questionData.active == 1 && questionData.step_1_total == questionData.answered) {
                $panelHeading.addClass('mobile-hide');
                $elm.addClass('hide-instructions');
                $elm.find('.progress-container').show();
            }

            var $preQues = $self.prev();
            if(isQuestionnaireTest && $preQues.length > 0) {
                $backLink.show();
                $backLink.removeClass('disabled');
            }
        }

        // If the back or next link was clicked, update visibility of links.
        if (direction) {
            if(this.isGatekeeper($nextQuestion.find('.form-select'))){
                $forwardLink.addClass('disabled');
                $elm.find("[type='submit'].form-action-submit").addClass('form-incomplete');
            } else if(($nextQuestion.hasClass('answered') || !($nextQuestion.hasClass('required'))) && $nextQuestion.attr('id') !== 'form-item-zip') {
                $forwardLink.removeClass('disabled');
                $elm.find("[type='submit'].form-action-submit").removeClass('form-incomplete');
            } else {
                $forwardLink.addClass('disabled');
                $elm.find("[type='submit'].form-action-submit").addClass('form-incomplete');
                if(questionData.active == questionData.step_1_total) {
                    $forwardLink.removeClass('disabled');
                }
            }
            //If answer is changed on 1st step
            if(direction == 'forward') {
                if($self.hasClass('answered') && $nextQuestion.hasClass('answered')) {
                    var parentNode = $self.parent();
                    var nextQuestionId = $nextQuestion.attr('id');
                    parentNode.children().not('#' + nextQuestionId).removeClass('active');
                    var $lastQuestion = $nextQuestion.next();
                    if(isQuestionnaireTest && $lastQuestion.length > 0) {
                        $forwardLink.show();
                        $forwardLink.removeClass('disabled');
                    }
                }
                // If a question is of type conditional-question and we switch between conditional-option questions
                if(isQuestionnaireTest && $self.hasClass('answered') && $self.hasClass('conditional-question')) {
                    $nextToNextQuestion = $nextQuestion.next();
                    if($nextToNextQuestion.hasClass('conditional-option') && $nextToNextQuestion.hasClass('disabled')) {
                        $nextToNextQuestion = $nextToNextQuestion.next();
                    }
                    if($nextToNextQuestion) {
                        $nextToNextQuestion.removeClass('active');
                    }
                }

                var $preQuestion = $self.prev();
                if(isQuestionnaireTest && $self.attr('id') == 'form-item-zip' && $self.hasClass('answered') && $preQuestion.length == 0) {
                    $backLink.show();
                    $backLink.removeClass('disabled');
                }
            }

            // If zip code is 1st input and back navigation to 1st question display forward link
            if(direction == 'back') {
                if(isQuestionnaireTest && $nextQuestion.attr('id') == 'form-item-zip' && $nextQuestion.hasClass('answered')) {
                    $forwardLink.removeClass('disabled');
                    $forwardLink.show();

                    var $prevQuestionExists = $nextQuestion.prev();
                    if($prevQuestionExists.length == 0) {
                        $backLink.hide();
                        $backLink.addClass('disabled');
                    }
                }
            }
        } else {
            if($self.hasClass('answered')) {
                $forwardLink.removeClass('disabled');
                $forwardLink.show();
                $elm.find("[type='submit'].form-action-submit").removeClass('form-incomplete');
            } else {
                $forwardLink.addClass('disabled');
                $elm.find("[type='submit'].form-action-submit").addClass('form-incomplete');
            }

            var $preQuestion = $self.prev();
            if(isQuestionnaireTest && $self.attr('id') == 'form-item-zip' && $self.hasClass('answered') && $preQuestion.length == 0) {
                $backLink.hide();
                $backLink.addClass('disabled');
            }
        }

        // EHCS-2226: Mobile: Get Free Evaluation and Forward buttons are disabled when toggling between back and next buttons
        var regionId = this.getRegionId();
        var urlParams = new URLSearchParams(window.location.search);
        if( this.getRegionGeneral(regionId) == 'top' && urlParams.has('pathUI') && this.isMobile() ) {
            $nextQuestion = $self.next();
            $nextToNextQuestion = $nextQuestion.next();
            if( ($nextQuestion.attr('id') === 'form-item-zip' && $nextQuestion.find('#nolopath-qzip').val() !== '')
                && ($nextToNextQuestion.attr('id') === 'form-item-case_description' && $nextToNextQuestion.find('#nolopath-qcase_description').val() !== '') ) {
                $forwardLink.removeClass('disabled');
                $elm.find("[type='submit'].form-action-submit").removeClass('form-incomplete');
            }

            // EHCS-2238: Questions 2 &3 looks misaligned on back button scroll answers
            if(direction== 'forward') {
                var $nextQuestion = $self.next();
                if($self.find('.btn-group-justified > div').length > 6 || $nextQuestion.find('.btn-group-justified > div').length > 6) {
                    $('html').animate({scrollTop: ( $('#page-container').offset().top + $('#nolopath').offset().top )}, 500);
                }
            } else if(direction== 'back') {
                var $prevQuestion = $self.prev();
                if($self.find('.btn-group-justified > div').length > 6 || $prevQuestion.find('.btn-group-justified > div').length > 6) {
                    $('html').animate({scrollTop: ( $('#page-container').offset().top + $('#nolopath').offset().top )}, 500);
                }
            }
        }

        // EHCS-3716 - Mobile - Inconsistent behavior of top path of Tax article page
        if( this.getRegionGeneral(regionId) == 'top' && this.isMobile() ) {
            if(!direction) {
                $nextQuestion = $self.next();
                var nextChosen = false;
                var i = 0;
                do {
                    i = i + 1;
                    if (i > 12) { nextChosen = true; }
                    if ($nextQuestion.hasClass("answered")) {
                        $nextQuestion.removeClass('active');
                        $nextQuestion = $nextQuestion.next();
                    } else {
                        nextChosen = true;
                    }
                } while (nextChosen === false);

            }
        }

        var formStep = $elm.find('.form-step.active');
        var notAnswered = formStep.find('.not-answered.required').length;
        if(notAnswered > 0){
           $elm.find('.form-actions').removeClass('valid').addClass('not-valid');
        }
    }

    noloPath.prototype.updateProgress = function() {
        var $elm = this.$element;
        var questionData = this.getQuestionData();
        var totalSteps = questionData.step_1_total;
        var progressPoint = questionData.active >= questionData.answered ? questionData.answered : questionData.active;
        var questionnaireAOPs = [81, 84, 5016];
        if (window.NCMS != undefined && questionnaireAOPs.includes(window.NCMS.aopId)) {
            progressPoint = questionData.progressBarCount;
        }

        $elm.find('.breadcrumb-steps li').removeClass('current-step');
        $elm.find('.breadcrumb-steps li.step-' + progressPoint).addClass('current-step');

        var progress = Math.floor((progressPoint/totalSteps)*100).toString();
        $elm.find('.progress-container .progress-bar').width(progress+'%');
    }

    noloPath.prototype.bindShowMore = function() {
        var $elm = this.$element;
        var $expandable = $elm.find('[data-toggle="showMore"]');

        $expandable.on('click', function() {
            var self = $(this);
            var content = self.prev();
            var textExpanded = self.data('textExpanded');
            var textCollapsed = self.data('textCollapsed');

            if (self.data('truncating')) {
                self.data('truncating', false);
                self.text(textExpanded);
                content.html(self.data('fullValue'));
            } else {
                self.data('truncating', true);
                self.text(textCollapsed);
                content.html(self.data('value'));
            }
        });
    }

    noloPath.prototype.bindVoiceCta = function() {
        var $linkSemCta = 'a.sem-business-phone';
        var $linkNavCallUs = '.navbar__call-us';
        // var $link = $('body').find('a.voice_cta_tel');
        var self = this;
        [$linkSemCta,$linkNavCallUs].forEach(function($link_identifier,idx){
            var $link = $('body').find($link_identifier);
            if($link){
                $link.on('click', function(e) {
                    self.triggerEvent('semVoiceCTA','tel');
                });
                $("body").addClass("voice-cta");
            }
        });
    }

    noloPath.prototype.bindNgageClick = function() {
        var script = document.getElementById( 'ngagesrc' );
        var self = this;
        if(script) {
            function triggerNgageEvent(){
                self.triggerEvent('semNgageChat','click');
            }
            var $ngage1 ='.ngageMobileFloat',
                $ngage2 = '#bottom-right-black-bubble-invite-container',
                $ngage3 = '.semi-round-invite-container',
                $ngage4 = '.liveChatFloatingButtonMobile',
                $ngage5 = '#nGageLH',
                $ngage6 = '.liveChatFloatingButton',
                $ngage7 = '.chat-bottom-cta',
                $ngage8 = '.chat-container.chat-cta',
                $ngage9 = '.chat-cta-round-logo-open';
            [$ngage1,$ngage2,$ngage3,$ngage4,$ngage5,$ngage6,$ngage7,$ngage8,$ngage9].forEach(function($ngageCls,idx){
                var loopIdx = 0;
                window['nGageWatcher_'+idx] = setInterval(function(){
                    if($('body').find($ngageCls).length>0) {
                        var $ngage = $('body').find($ngageCls);
                        // console.log($ngageCls,' registered');
                        $ngage.on('click', function(e) {
                            triggerNgageEvent()
                        });
                        clearInterval(window['nGageWatcher_'+idx]);
                    }else if(loopIdx == 10){
                        // console.log($ngageCls,' cannot find, remove the interval');
                        clearInterval(window['nGageWatcher_'+idx]);
                    } else {
                        loopIdx++;
                    }
                }, 500);
            });
        }
    }

    noloPath.prototype.bindPathUrlData = function() {
        var divNoloPathInsert = $('body').find('#nolopath-insert');
        var regionId = this.getRegionId();
        var regionGeneral = this.getRegionGeneral(regionId);
        if( regionGeneral == 'top' && divNoloPathInsert.length == 1 ) {
            var urlParams = new URLSearchParams(window.location.search);
            if( urlParams.has('pathUI') ) {
                divNoloPathInsert.attr('data-path-ui', urlParams.get('pathUI'));
                // EHCS-2142 - Form Lead path optimization for Employment Law on Nolo.com (Desktop and Mobile)
                $(".show-more").click(function () {
                    if($(this).siblings("div.input-box:first").hasClass("show-more-height")) {
                        $(this).text("Show Less");
                    } else {
                        $(this).text("Show More");
                    }
                    $(this).siblings("div.input-box:first").toggleClass("show-more-height");

                    var inputbox = $(this).siblings("div.input-box:first");
                    if(inputbox.length) {
                        inputbox.find('.btn-default').not('.visible-option').toggleClass("hide-option");
                        inputbox.find('.btn-group').not('.visible-btn-group').toggleClass("hide-btn-group");
                    }
                });
                divNoloPathInsert.find('a.back-link').html('Back');
                divNoloPathInsert.find('a.forward-link').html('Next');
            }
        }
    }

    noloPath.prototype.bindSummaryEdit = function() {
        var $elm = this.$element;
        var $edit = $elm.find('.form-summary-edit');
        var $form = $elm.find('form');
        var $hiddenQuestions = $elm.find('.form-hidden-questions');
        var action = this.getServiceUrl() + this.getPathID();
        var self = this;

        $edit.on('click', function(e) {
            // trigger 'semFormEdit' custom event
            self.triggerEvent('semFormEdit', self.getCurrentStep());

            // prevent the 'routing questions' feature from triggering when editing past answers
            self.setHiddenField('routing', false);

            // clear layoutId to preserve path theme
            $form.find('input[name="layoutId"]').remove();

            // clear questions on current page to avoid validation issues
            $form.find('.form-step.active input').val('');

            $hiddenQuestions.append("<input type='hidden' name='aop_routing' value='set' />");

            // set a new form action url to POST to the next step
            $form.attr('action', action).submit();
        });
    }

    noloPath.prototype.canGetProviders = function(){
        var options = this.options;
        var showProviders = options.showProviders;
        var validZipCodes = options.providersValidZipCodes;
        var zip = $('input[name="zip"]').val();
        var getProviders = false;

        switch (typeof showProviders){
            case 'boolean':
            // set 'getProviders' based on a hard boolean toggle
            getProviders = showProviders;
            break;

            // set 'getProviders' based valid zip codes
            case 'string':
            if(showProviders === 'onValidZipCodes'){
                getProviders = this.isInZipCodeRange(zip, validZipCodes);
            }
            break;

            default:
            getProviders = false;
        }

        return getProviders;
    }

    noloPath.prototype.getNumberRangeFromClass = function(validationClass){
        // use positive and negative Infinity for the initial values
        var range = {
            'min'     : -Infinity,
            'max'     : Infinity,
            'minOnly' : false,
            'maxOnly' : false,
            'minMax'  : false,
        }

        // to use a min-value, the validationClass should have a class in this format: min-value-[any integer]
        var patternMin = /^(.*)min-value-([0-9]+)(.*)$/;

        // to use a max-value, the validationClass should have a class in this format: max-value-[any integer]
        var patternMax = /^(.*)max-value-([0-9]+)(.*)$/;

        // test for the min/max value classes
        var testMin = patternMin.test(validationClass);
        var testMax = patternMax.test(validationClass);

        // assign the correct values
        range.min = testMin ? Number(validationClass.replace(patternMin, '$2')) : range.min;
        range.max = testMax ? Number(validationClass.replace(patternMax, '$2')) : range.max;

        // basic tests
        range.minOnly = (range.min !== -Infinity) && (range.max === Infinity);
        range.maxOnly = (range.min === -Infinity) && (range.max !== Infinity);
        range.minMax  = (range.min !== -Infinity) && (range.max !== Infinity);

        // return resolved range
        return range;
    }

    noloPath.prototype.isNumeric = function(num, testInteger){
        var x = isNaN(num) ? false : Number(num);
        var isNumeric = (typeof x === 'number');

        if (typeof testInteger === 'boolean' && testInteger){
            return isNumeric && (x % 1 === 0);
        }

        return isNumeric;
    }

    noloPath.prototype.isInteger = function(num){
        return this.isNumeric(num, true);
    }

    // isNumberInRange function: Tests provided number is within provided range
    // @params
    // + range: objects in the following format: {'min': 00001, 'max': 10000}
    noloPath.prototype.isNumberInRange = function(num, range){
        var x = isNaN(num) ? false : Number(num);
        var min = range.min;
        var max = range.max;

        return (x >= min && x <= max);
    }

    noloPath.prototype.isEmail = function(email){
        var pattern = /^[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
        return pattern.test(email);
    }

    noloPath.prototype.isZip = function(zip){
        var pattern = /^[0-9]{5}$/;
        return pattern.test(zip);
    }

    noloPath.prototype.parseDate = function(date) {
        var pattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;

        if (pattern.test(date)) {
            return new Date(date + "T00:00:00");
        } else {
            return false;
        }

    }

    noloPath.prototype.isValidDate = function(date) {
        // Appointment year cannot be earlier than the current date
        if (date.getTime() < Date.now()) {
            return false;
        }

        return true;
    }

    // isInZipCodeRange function: Tests provided zip is within provided range
    // @params
    // + range: array of objects in the following format
    //   [{'min': 00001, 'max': 10000}, {'min': 20001, 'max': 29999}, {'min': 30001, 'max': 39999}, ...]
    noloPath.prototype.isInZipCodeRange = function(zip, range){
        if(range.length > 0){
            for (var i in range){
                if (this.isNumberInRange(zip, range[i])){
                    return true;
                }
            }
        }
        return false;
    }

    noloPath.prototype.isInMichigan = function(zip){
        var range = [{'min': 48001, 'max': 49971}];
        return this.isInZipCodeRange(zip, range);
    }

    noloPath.prototype.isPhoneType = function(phone, format, type){
        var pStandard = /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        var pExtended = /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension|X\.?|EXT\.?|EXTENSION)\s*(\d+))$/;
        var pStandardAlpha = /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([a-zA-Z0-9]{3})[-. ]?([a-zA-Z0-9]{4})$/;
        var pExtendedAlpha = /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([a-zA-Z0-9]{3})[-. ]?([a-zA-Z0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension|X\.?|EXT\.?|EXTENSION)\s*(\d+))$/;
        var pStandardLoose = /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})(.*)$/;
        var pExtendedLoose = /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension|X\.?|EXT\.?|EXTENSION)\s*(\d+))(.*)$/;

        var pattern;
        var patternTest;

        switch(type){
            case 'alphaPhone':
            pattern = pStandardAlpha;
            break;

            case 'phoneExtension':
            pattern = pExtended;
            break;

            case 'alphaPhoneExtension':
            pattern = pExtendedAlpha;
            break;

            case 'loosePhone':
            pattern = pStandardLoose;
            break;

            case 'loosePhoneExtension':
            pattern = pExtendedLoose;
            break;

            case 'phone':
            default:
            pattern = pStandard;
            break;
        }

        patternTest = pattern.test(phone);

        if(format && patternTest){
            return phone.replace(pattern, format);
        } else {
            return patternTest;
        }
    }

    noloPath.prototype.addPhoneDashes = function(inputVal)
    {
        inputVal = inputVal.replace(/[^0-9()-]/g, "");

        if( inputVal.length > 6){
            inputVal = inputVal.replaceAll("-","");
            if(inputVal[0] == 1 && inputVal[1] == "("){
                inputVal = inputVal.replaceAll("(","")
                inputVal = inputVal.replaceAll(")","")
                if(inputVal.length > 6) {
                    inputVal = inputVal.slice(0,1)+"("+inputVal.slice(1,4)+") "+inputVal.slice(4,7)+"-"+inputVal.slice(7);
                } else {
                    inputVal = inputVal.slice(0,1)+"("+inputVal.slice(1,4)+") " + inputVal.slice(4);
                }                
            }else if(inputVal[0] == "("){
                inputVal = inputVal.replaceAll("(","")
                inputVal = inputVal.replaceAll(")","")
                inputVal = "("+inputVal.slice(0,3)+") "+inputVal.slice(3,6)+"-"+inputVal.slice(6);
            }else if(inputVal[0] == 1){
                if(inputVal.length > 6) {
                    inputVal = inputVal.slice(0,1)+"-"+inputVal.slice(1,4)+"-"+inputVal.slice(4,7)+"-"+inputVal.slice(7);
                } else {
                    inputVal = inputVal.slice(0,1)+"-"+inputVal.slice(1,4)+"-"+inputVal.slice(4);
                }
            }else{
                inputVal = inputVal.slice(0,3)+"-"+inputVal.slice(3,6)+"-"+inputVal.slice(6);
            }
        } else if(inputVal.length > 3){
            inputVal = inputVal.replaceAll("-","");
            if(inputVal[0] == 1 && inputVal[1] == "("){
                inputVal = inputVal.replaceAll("(","")
                inputVal = inputVal.replaceAll(")","")
                if(inputVal.length > 3) {
                    inputVal = inputVal.slice(0,1)+"("+inputVal.slice(1,4)+") " + inputVal.slice(4);
                } else {
                    inputVal = inputVal.slice(0,1)+"("+ inputVal.slice(1,4);
                } 
            }else if(inputVal[0] == "("){
                inputVal = inputVal.replaceAll("(","")
                inputVal = inputVal.replaceAll(")","")
                inputVal = "("+inputVal.slice(0,3)+") "+inputVal.slice(3);
            }else if(inputVal[0] == 1){
                if(inputVal.length > 3) {
                    inputVal = inputVal.slice(0,1)+"-"+inputVal.slice(1,4)+"-"+inputVal.slice(4);
                } else {
                    inputVal = inputVal.slice(0,1)+"-"+ inputVal.slice(1);
                }
            }else{
                inputVal = inputVal.slice(0,3)+"-"+inputVal.slice(3);
            }
        } else if(inputVal.length <= 3){
            if(inputVal[0] != 1) {
                inputVal = inputVal.replaceAll("-","");
                if(inputVal[0] != '(') {
                    inputVal = inputVal.replaceAll("(","");
                    inputVal = inputVal.replaceAll(")","");
                    if(inputVal.length == 3) {
                        inputVal = inputVal.slice(0,3)+"-"+inputVal.slice(3);
                    }
                } 
            } else if(inputVal[0] == 1){
                if(inputVal[1] == '-') {
                    inputVal = inputVal.replaceAll("(","");
                    inputVal = inputVal.slice(0,1)+"-"+ inputVal.slice(2);
                } else if(inputVal[1] == '(') {
                    inputVal = inputVal.replaceAll("-","");
                    inputVal = inputVal.slice(0,1)+"("+ inputVal.slice(2);
                }
            }
        }
        return inputVal;
    }

    noloPath.prototype.isPhone = function(phone, format){
        return this.isPhoneType(phone, format, 'phone');
    }

    noloPath.prototype.isPhoneExtension = function(phone, format){
        return this.isPhoneType(phone, format, 'phoneExtension');
    }

    noloPath.prototype.isAlphaPhone = function(phone, format){
        return this.isPhoneType(phone.toUpperCase(), format, 'alphaPhone');
    }

    noloPath.prototype.isAlphaPhoneExtension = function(phone, format){
        return this.isPhoneType(phone.toUpperCase(), format, 'alphaPhoneExtension');
    }

    noloPath.prototype.isLoosePhone = function(phone, format){
        return this.isPhoneType(phone, format, 'loosePhone');
    }

    noloPath.prototype.isLoosePhoneExtension = function(phone, format){
        return this.isPhoneType(phone, format, 'loosePhoneExtension');
    }

    noloPath.prototype.isOnFirstStep = function(){
        return this.getStepsData('isOnFirstStep');
    }

    noloPath.prototype.isOnBeforeLastStep = function(){
        return this.getStepsData('isOnBeforeLastStep');
    }

    noloPath.prototype.isOnLastStep = function(){
        return this.getStepsData('isOnLastStep');
    }

    noloPath.prototype.isUserEngaged = function(){
        return this.setUserEngaged();
    }

    noloPath.prototype.isInitDone = function(){
        return this.initDone;
    }

    noloPath.prototype.isFormLoaded = function(){
        return this.formLoaded;
    }

    noloPath.prototype.isAjaxForm = function(submitBehavior){
        return $.inArray(submitBehavior, [noloPath.CONSTANTS.submitBehaviorAjax, noloPath.CONSTANTS.submitBehaviorHybrid]);

    }

    noloPath.prototype.getNRH = function(){
        // in cases where the 'noloResponsiveHelper' plugin is not available, define these fallback functions
        var fallback = {
            isMobile: function(){return false;},
            isTablet: function(){return false;},
            isDesktop: function(){return false;},
            isWide: function(){return false;}
        };

        // retrieve the configured 'noloResponsiveHelper' plugin instance, or use 'fallback'
        var $nRH = $('body').data('nolo.noloResponsiveHelper') || fallback;

        return $nRH;
    }

    noloPath.prototype.isMobile = function(){
        return this.getNRH().isMobile();
    }

    noloPath.prototype.isTablet = function(){
        return this.getNRH().isTablet();
    }

    noloPath.prototype.isDesktop = function(){
        return this.getNRH().isDesktop();
    }

    noloPath.prototype.isWide = function(){
        return this.getNRH().isWide();
    }

    noloPath.prototype.stripHtmlTag = function(text, replacement){
        var pattern = /(<([^>]+)>)/ig;
        var value = replacement || '';
        return text.replace(pattern, value);
    }

    // toggleSubmitButton function
    noloPath.prototype.toggleSubmitButton = function(method, loadbar){
        var $elm = this.$element;
        var $submit = $elm.find('.form-action-submit, .form-action-backtrack');
        var $loader = $elm.find('.form-loader.progress');
        if (typeof loadbar === "undefined" || loadbar === null) { 
            loadbar = true; 
        }

        switch(method){
            case 'enable':
            // enable the submit button
            if($submit.hasClass('disabled')){
                $submit.removeClass('disabled');
                $submit.removeAttr('disabled');
            }
            // hide the loader bar
            if($loader.length > 0){
                $loader.css('display', 'none');
            }
            break;

            case 'disable':
            // disable the submit button
            if(!$submit.hasClass('disabled')){
                $submit.addClass('disabled');
                $submit.attr('disabled','disabled');
            }
            // show the loader bar
            if(loadbar){
                if($loader.length > 0){
                    $loader.css('display', 'block');
                    $loader.css('visibility', 'visible');
                }
            } else {
                if($loader.length > 0){
                    $loader.css('display', 'none');
                }
            }
            
            break;

            default:
            // do nothing
        }

        return false;
    } //end toggleSubmitButton function

    noloPath.prototype.submitForm = function(event){

        var process  = this;
        var $elm     = this.$element;

        // EHCS: if the zip-code was just entered and the providers lookup it triggers
        // (getProvidersData) hasn't finished yet, hold off on submitting until it does.
        // Otherwise a user who fills the zip and immediately clicks next/submit can
        // advance before the provider data/count is ready.
        var providersDataPromise = $elm.data('providersDataPromise');
        if (providersDataPromise && providersDataPromise.state() === 'pending') {
            if (event) event.preventDefault();
            providersDataPromise.always(function(){
                process.submitForm(event);
            });
            return false;
        }

        /*
        var $backtrack = $elm.find('.back-link');
        */
        var $select  = $elm.find('select[name="practice_area_select"]');
        var step = this.getCurrentStep();
        var isThreeSteps = $('.page-nolosem-talcumpowder-form2a').length
            || $('.page-nolosem-talcumpowder-form2app').length;
        var isLastStep = $('#nolopath').hasClass('nolopath-step-last');

        var semDropQuestions = $("#nolopath").data('nolo.noloPathAnalytics').options.events.semDropQuestions;
        for (var dropIdx in semDropQuestions) {
            var dropQ = semDropQuestions[dropIdx];
            var questionData = this.getQuestionData();
            var dropQuestion = $('#nolopath #form-item-' + dropIdx).find('select');
            // EHCS-2278: A/B test: Criminal Defense - Changes in Routing Logic - SEM Paths
            if(typeof dropQuestion != 'undefined' && dropQuestion.length > 0) {
                var dropAnswerId = this.getAnswerId(dropQuestion.val());
                var unroutedAnswerIds = dropQ.answerIds[0].split(',');

                // Drop form and show drop hard disqualify page /unrouted
                if (unroutedAnswerIds.indexOf(dropAnswerId) > -1) {
                    var unroutedData = {
                        show_message: "message",
                        nolopath: {
                            nolopath_providers: "nolopath_providers",
                        },
                        practice_area_id: questionData.practice_area_id,
                        qa: {
                            8: {
                                type: "select",
                                value: dropQuestion.val()
                            }
                        },
                        unrouted: true,
                    };
                    this.loadConfirmationStep(unroutedData);
                    return false;
                }
            }
        }
        
        //EHCS-2223: Criminal Defense - Changes in Routing Logic - SEO Paths
        var custom_routing_inupt = $('#page-container').find("input[type='hidden'][name='routing_confirm_unrouted']").length;
        var custom_routing_inupt_mobile = $('#page-container').find("input[type='hidden'][name='routing_confirm_unrouted_mobile']").length;
        var pid = this.getPathPracticeAreaId();

        if($select && $select.val() !== '0') {
            pid = $select.val();
        }

        if( custom_routing_inupt > 0 || custom_routing_inupt_mobile > 0 ) {
            var routingTarget = window.routingTarget?window.routingTarget:'998';
            var unroutedData = {
                show_message: "message",
                nolopath: {
                    nolopath_providers: "nolopath_providers",
                },
                practice_area_id: pid,
                qa: {
                    8: {
                        type: "select",
                        value: (routingTarget+": Victim of a crime"),
                        answer: "N/A",
                        question_id: "8",
                        answer_id: routingTarget
                    }
                },
                unrouted: true,
                is_unrouted: true,
                routing_unrouted:true,
                confirm_route: 'confirm/unrouted'
            };
            this.loadConfirmationStep(unroutedData);
            return false;
        }


        // /sem/spanish (SSDI Premier): on the final (PII) step submit, if the answers don't
        // qualify, skip the leads.nolo.com submission entirely and go straight to confirm/unrouted
        if (isLastStep && this.pathData.pathId === 'spanish' && !this.isSsdiApi4PremierLead()) {
            // build the case-summary data ourselves from the live DOM, since there's no
            // leads API response to source it from (we never submitted)
            var premierQids = [1066, 1067, 1068, 1069, 1070, 1071];
            var unroutedQa = {};
            premierQids.forEach(function(qid){
                var $select = $('#nolopath-q' + qid);
                var answerText = $select.find('option:selected').text();
                unroutedQa[qid] = {
                    type: 'select',
                    value: answerText,
                    answer: answerText,
                    question_short: $select.closest('.form-item').data('shortQuestion') || ''
                };
            });
            var unroutedData = {
                show_message: "message",
                show_case: true,
                nolopath: {
                    nolopath_providers: "nolopath_providers",
                },
                practice_area_id: pid,
                practice_area_name: this.getPathPracticeAreaName(),
                zip: $elm.find('input[name="zip"]').val(),
                case_description: $elm.find('textarea[name="case_description"], input[name="case_description"]').val(),
                qa: unroutedQa,
                unrouted: true,
                is_unrouted: true,
                routing_unrouted: true,
            };
            this.loadConfirmationStep(unroutedData);
            return false;
        }

        // trigger 'semConversionFunnel' custom event for EHCS-1113 requirements
        if (isThreeSteps) {
            if (step === 'step-2') {
                this.triggerEvent('semConversionFunnel', 'evaluation');
            } else if (step === 'step-3') {
                this.triggerEvent('semConversionFunnel', 'submit');
            }
        } else {
            if (step === 'step-1') {
                this.triggerEvent('semConversionFunnel', 'evaluation');
            } else if (step === 'step-2') {
                this.triggerEvent('semConversionFunnel', 'submit');
            }
        }

        if (step === 'step-1') {
            this.triggerGa4Event('formSubmitted', 'stepEvaluation');
            this.triggerEvent('semButtonClick','caseEvaluation');
        } else if( isLastStep ) {
            this.triggerGa4Event('formSubmitted', 'leadSubmit');
            this.triggerGa4Event('formSubmitted', 'leadPathSubmit');
            this.triggerEvent('semButtonClick','caseSubmit');
        }

        // ensure that the submit button's default behavior is suppressed
        if(event) event.preventDefault();

        // remove back link after user submits:
        /*
        $backtrack[0].style.display = 'none';
        */

        // trigger 'semFormSubmit' custom event
        this.triggerEvent('semFormSubmit', 'submit');

        // clear errors
        this.clearErrors();

        // check if the leadpath form is loaded
        if(this.getQuestionData().questions.length === 0){
            this.setStatusError('formNotLoaded', 'error', this.getErrorMessage('no-leadpath', 'default'));

            // flag the practice area select field if visible
            if($select && $select.val() === '0') {
                this.setInlineError($select, this.getErrorMessage('missing', 'default'));
            }

            return false;
        }

        // double-check the phone fields
        // standardizes the phone fields to conform to (XXX) XXX-XXXX
        $elm.find('.validate-phone .form-control').each(function(){
            var self = $(this);
            var isPhone = process.isPhone(self.val(), '($1) $2-$3');

            if(isPhone){
                self.val(isPhone);
            }
        });

        // disable the submit button
        this.toggleSubmitButton('disable');

        // validate submission data
        if (this.validateUsingClient()){
            var process = this;
            if(step == 'step-1') sessionStorage.setItem('pid', $('#nolopath-practice-area-select').val());
            if( isLastStep )
            {
                if( process.reCaptchaPassed &&
                    (Math.abs(Math.floor((process.reCaptchaTokenTimestamp - Date.now())/1000/60)) < 2) ||
                    location.search.includes("qa_autotest") ||
                    window.pauseReCaptcha) {
                    return this.validateUsingServer();
                }else{
                    return grecaptcha.enterprise.ready(function() {
                            var recaptchaSiteKey = $("#recaptcha-api").attr("data-key");
                            var recaptchaGroupId = $("#recaptcha-api").attr("data-group-id");
                            grecaptcha.enterprise.execute(recaptchaSiteKey, {action: 'submit'}).then(function(token) {
                            // Add your logic to submit to your backend server here.
                            var postData = {'token':token, 'group':recaptchaGroupId };
                            // if(typeof ibtracker !== 'undefined')console.log(ibtracker.partyId)
                            var promise = $.ajax({
                                type: 'POST',
                                url: '/path2/service/getReCaptchaVerify',
                                data: postData
                            });

                            promise.done(function(data){
                                var validation = data.recaptcha_validation;
                                var recaptchaThreshold = data.threshold_score ? data.threshold_score : noloPath.CONSTANTS.recaptchaThreshold;
                                if(!validation.success) {
                                    return false;
                                }else if(validation.success && validation.score <= recaptchaThreshold) {
                                    process.reCaptchaTokenTimestamp = Date.now();
                                    process.reCaptchaPassed = token;
                                    var errorMsgArr = noloPath.CONSTANTS.inlineErrorMessages.recaptchaErrorMessages;
                                    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                                    var eventSnippetStr = "";
                                    var currentStepUri = location.href;
                                    if(isSafari) {
                                        eventSnippetStr = "console.log('is safari');e.preventDefault(); $('#nolopath form').attr('action','"+currentStepUri+"'); $('[name=first_name]').val('');  $('[name=last_name]').val(''); $('[name=mail]').val(''); $('[name=phone]').val('');$('#nolopath form').submit()";
                                    } else{
                                        eventSnippetStr = "e.preventDefault(); location.reload();";
                                    }
                                    var errorMsg = errorMsgArr['start']+'<a href="#" onclick="(function(e){'+eventSnippetStr+'})(arguments[0])" style="color:#0000ee;">'+errorMsgArr['link']+'</a>'+errorMsgArr['end'];
                                    process.setStatusError('formNotLoaded', 'error',errorMsg);
                                    $("body").addClass("threshold-error");
                                    sessionStorage.setItem('refreshRecaptcha',true)
                                    return false;
                                }else {
                                    process.reCaptchaTokenTimestamp = Date.now();
                                    process.reCaptchaPassed = token;
                                    return process.validateUsingServer();
                                }
                            });

                            promise.fail(function(errors){
                                console.log('reCapture failed:',errors);
                                //EHCS-3168: Allow form to continue if recaptcha fails
                                // console.log('Continuing without recaptcha...');
                                return process.validateUsingServer();
                            });
                        });
                    });
                }
            }else {
                // EHCS-5697: dv-api3-v2 doesn't need a server round-trip
                // between intermediate steps at all. validateUsingClient()
                // above already enforces required fields (this branch is
                // unreachable if it failed), and the eventual final
                // submission (submitToQueue, gated by toolsSubmitForms
                // further inside validateUsingServer) builds its payload
                // fresh from live DOM state at actual submit time —
                // completely independent of anything an intermediate
                // leads.nolo.com response would have returned (confirmed:
                // its raw payload reads specific fields via querySelector,
                // never anything sourced from a prior step's response).
                // So skip validateUsingServer() here and advance straight
                // to the next (already-rendered) step, reusing the same
                // primitives backtracking already uses via
                // loadNextStepViaAjax. The true last-step submission below
                // is completely untouched.
                if (['dv-api3', 'dv-api3-v2'].includes(this.pathData.pathId) ||
                    (['ep-api1', 'ep-api1pp'].includes(this.pathData.pathId) && new URLSearchParams(window.location.search).get('np') === 'ls')) {
                    var nextStep = this.getNextStep();
                    // Defensive: isLastStep above is read from a DOM class
                    // (`$('#nolopath').hasClass('nolopath-step-last')`) set
                    // by a PRIOR loadCurrentStep() call, not recomputed here.
                    // If that's ever stale/wrong and we're actually on the
                    // true last step, getNextStep() returns 'confirm' — in
                    // that case fall through to the real submission flow
                    // instead of silently no-op'ing (there's no '.form-confirm'
                    // fieldset for loadCurrentStep() to show, so advancing
                    // client-side would do nothing and never call
                    // validateUsingServer() at all).
                    if (nextStep !== 'confirm') {
                        this.setCurrentStep(nextStep);
                        this.setStepsData();
                        this.loadCurrentStep();
                        this.toggleSubmitButton('enable');
                        return false;
                    }
                }
                return this.validateUsingServer();
            }
        }

        if($elm.find('#nolopath-qcase_description') && $elm.find('#nolopath-qcase_description').hasClass('error')) {
            this.toggleSubmitButton('disable', false);
        } else {
            // enable the submit button to allow for corrections
            this.toggleSubmitButton('enable');
        }

        // trigger 'semError' custom event
        this.triggerEvent('semError', 'error-client-validation-failed');

        return false;
    }

    noloPath.prototype.backtrackForm = function(event){
        var $submit    = this.getElement('.form-action-submit');
        var submitBehavior = this.getOptions('submitBehavior');
        var prevStep = this.getPreviousStep();
        var isAjaxForm = this.isAjaxForm(submitBehavior);

        // ensure that the submit button's default behavior is suppressed
        event.preventDefault();

        // trigger 'semFormSubmit' custom event
        this.triggerEvent('semFormSubmit', 'backtrack');

        // limit to the ajax form only, since we can reliably
        // count on the user using the backtrack button for this
        if(prevStep && isAjaxForm > -1){
            // switch back to the previous step
            this.loadNextStep(prevStep);
        }
    }

    // validateZipCode function: ping the server for a valid zip-code
    // POST URL: http://localhost.nolo.com/ajax/expert_leadgen_ajax_validate_zip/[5-digit zip]/1
    // This will return the following information:
    // + on success: @string [City], [State_Code]
    // + on failure: @string 'Invalid Zip Code'
    noloPath.prototype.validateZipCode = function(zip, event){
        var z = $.trim(zip);
        var ev = event;
        var $field = $(ev.target);
        var postURL = this.getZipApiUrl(z);
        var process = this;
        var cachedData = this.$element.data('zipCodeData');
        var getZipCode = true;
        var postData = '';

        if(this.isZip(z)){
            if(cachedData){
                // validate only if we have not done this before
                getZipCode = (cachedData.zipCode !== z);
            }

            if(getZipCode){
                // EHCS: mark the providers fetch as pending immediately, before the zip-validation
                // ajax even starts, so submitForm can detect and wait for the whole chain to finish
                // instead of letting the user move to the next step before it resolves
                var zipDfd = $.Deferred();
                this.$element.data('providersDataPromise', zipDfd.promise());

                // validate only if we have not done this before
                var promise = $.ajax({
                    type: 'POST',
                    url: postURL,
                    data: postData
                });

                promise.done(function(data, status, xhr){
                    return process.onAjaxSuccessValidateZip(data, status, xhr);
                });

                var providersPromise;
                promise.done(function(){
                    // get providers data to show number of lawyers in area text
                    providersPromise = process.getProvidersData(true);
                    return providersPromise;
                });

                promise.done(function(data){
                    // trigger 'blur'  and 'input' to run other event handlers on this field
                    if(data !== 'Invalid Zip Code') {
                        $field.trigger('blur').trigger('input');
                        if (['ssdi-api5'].includes(document.querySelector('body').getAttribute('data-path'))) {
                            process.getProvidersData_alt(true);
                        }
                    }
                });

                promise.done(function(){
                    // don't let the user move to the next step until getProvidersData resolves
                    $.when(providersPromise).always(function(){
                        zipDfd.resolve();
                    });
                });

                promise.fail(function(xhr, status, error){
                    process.onAjaxErrorSubmit(xhr, status, error, $field, postURL);
                    zipDfd.reject();
                });

                return true;
            } else {
                // cached and detected zip-codes match
                // get providers data to show number of lawyers in area text
                // ----------
                // @note:
                // + disabling this to resolve NOLO-1320
                // + this was causing an extra ajax call for no obvious reason
                // return this.getProvidersData(true);
            }
        } else {

            // EHCS-4738: Mirroring routing=pi5 behavior for zip code error (no inline error here)
            if (['cd-api1pp'].includes(document.querySelector('body').getAttribute('data-path'))) { return false; }

            // invalid 5-digit zip code detected
            this.setInlineError($field, this.getErrorMessage('invalid', 'zip'));
            this.triggerEvent('semZipValidation', 'invalid-zip-format');
            return false;
        }
    }

    noloPath.prototype.validateUsingClient = function(){
        var errorCount = this.validateClientAnswers();
        var currentStep = this.getCurrentStep();

        // test current step for errors
        return (errorCount.steps[currentStep] === 0);
    }

    noloPath.prototype.validateUsingServer = function(){

        // For pi5b
        var pi5bRouting = false;
        var urlParams = new URLSearchParams(window.location.search);
        if((this.pathData.pathId == 'pi-api5' || this.pathData.pathId == 'pi-api5pp') && urlParams.has('routing')){
            pi5bRouting = urlParams.get('routing');
        }

        // for nq
        var nqRouting = false;
        if((this.pathData.pathId == 'wc-api2' || this.pathData.pathId == 'wc-api2pp') && urlParams.has('nq')){
            nqRouting = urlParams.get('nq');
        }

        // TCPA Consent Verbiage
        var full_tcpa = '';
        document.querySelectorAll("label[data-tcpa*=leadid_tcpa]").forEach(function($element, idx) {
            full_tcpa += $element.innerText + " ";
        });
        full_tcpa = full_tcpa.trim();
        full_tcpa = full_tcpa.replace("Terms of Use", "[Terms of Use](https://www.internetbrands.com/ibterms/)");
        full_tcpa = full_tcpa.replace("Privacy Policy", "[Privacy Policy](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace("privacy policy", "[privacy policy](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace(/\b(click here)\b/gi, function(match){return "[" + match + "](ACTION:SUBMIT_WITHOUT_CONSENT)"});

        //for spanish
        full_tcpa = full_tcpa.replace("Términos de Uso", "[Términos de Uso](https://www.internetbrands.com/es/ibterms)");
        full_tcpa = full_tcpa.replace("Política de Privacidad", "[Política de Privacidad](https://www.internetbrands.com/es/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace("política de privacidad", "[política de privacidad](https://www.internetbrands.com/es/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace('oprime aquí', function(match){return "[" + match + "](ACTION:SUBMIT_WITHOUT_CONSENT)"});

        full_tcpa = full_tcpa.replace(/(\r\n|\n|\r)/gm, "");
        try {
            document.querySelector(".form-hidden-questions input[name='tcpa_consent_verbiage']").value = full_tcpa;
        } catch (error) { /* tcpa not found yet */ }


        var $elm = this.$element;
        var $form = $elm.find('form');
        var leadApiUrl = this.getLeadApiUrl();

        // EHCS-5274
        var clp_routingQAInCD = [ 
            'cd-api1', 'cd-api1pp',
            'cd-api1d', 'cd-api1dpp',
            'cd-api2',
            'dui-api1', 'dui-api1pp',
            'dui-api2'
        ];
        
        var clp_routingQAInCD_variant = [
            'cd-api1d', 'cd-api1dpp'
        ]

        const toolsSubmitForms = [
            'dv-api3', 'dv-api3-v2',
            'cc-api2-v2'
        ];
        // auto_populate_aop_id per tools-submit path (dv-api3 = Divorce 96, cc-api2-v2 = Child Custody 94)
        const toolsSubmitAop = {
            'dv-api3': 96,
            'cc-api2-v2': 94
        };

        // Check during CLP submissions
        var queryParam = new URLSearchParams(window.location.search);
        if (clp_routingQAInCD.includes(this.pathData.pathId) && (document.querySelector("body.last-step-1") && document.querySelector("body.last-step-1").getAttribute('data-pid') == '8937') && !document.querySelector("body").classList.contains("route-append")) {
            document.querySelector("body").classList.add("route-append");
            $form.find("#form-item-case_description textarea")[0].value += "\n" + document.querySelector(".form-hidden-questions input[name='routing_question']").value + " RESPONSE: " + document.querySelector(".form-hidden-questions input[name='routing_answer']").value;
        } else if ((document.querySelector("body.last-step-1") && document.querySelector("body.last-step-1").getAttribute('data-pid') == '8937') && !document.querySelector("body").classList.contains("route-append") && $('body').attr('data-type') !== 'sem' &&  (queryParam.has('pid') &&  ['14', '74'].includes(queryParam.get('pid')))) {
                document.querySelector("body").classList.add("route-append");
                $form.find("#form-item-case_description textarea")[0].value += "\n" + document.querySelector(".form-hidden-questions input[name='routing_question']").value + " RESPONSE: " + document.querySelector(".form-hidden-questions input[name='routing_answer']").value;
        }

        var postData = $form.serialize();
        var postDataArr = $form.serializeArray();
        var postDataObj = {};
        postDataArr.forEach(function(prop,index) {  postDataObj[prop.name] = prop.value; });
//        var successUrl = "https://www.nolo.com/uform/success";
//        var successUrl = "https://qualify.drunkdrivinglawyers.stg2.thelawlinks.com/confirm";
        var successUrl;
        var pathConversions = {
            'cd-api2': [{conversionId: 'AW-786257430/r73gCJXF-4kBEJas9fYC'}],
            'dui-api1': [{
                conversionId: 'AW-983400003/lJRWCLWi0wUQw_z11AM',
                currency: 'USD', currencyValue: 1
            },{
                conversionId: 'AW-10914887802/aQ_4CLzsi8EDEPrwz9Qo',
                currency: 'USD', currencyValue: 1
            }],
            'dui-api2': [{
                conversionId: 'AW-1031512686/VzQzCOTGlwEQ7sTu6wM',
                currency: 'USD', currencyValue: 1
            }],
            'cd-api1': [{conversionId: 'AW-971461227/SLELCOXjzAgQ66SdzwM'}],
            'cd-api1d': [{conversionId: 'AW-971461227/SLELCOXjzAgQ66SdzwM'}],
            'dv-api2a': [{conversionId: 'AW-974095523/Hff-CI2znggQo4m-0AM'}],
            'dv-api3': [{conversionId: 'AW-748831028/_UPECN2ey5kBELSCieUC'}],
            'emp-api2': [{conversionId: 'AW-962071457/bTyjCM_NlgoQoZfgygM'}],
            'ep-api1': [{conversionId: 'AW-956127093/bJlACPuShmgQ9a71xwM'}],
            'ep-api2': [{conversionId: 'AW-10940585669/I7NYCIzE8NwDEMWt8OAo'}],
            'mm-api1': [{conversionId: 'AW-923546411/aB1-CPLSzGQQq-awuAM'}],
            'pi-api5': [{
                conversionId: 'AW-1009299273/LVflCN_L0gIQyd6i4QM',
                currency: 'USD', currencyValue: 1
            }],
            'pi-api8': [{
                conversionId: 'AW-11220233643/M8r4CLOpj6wYEKvbnOYp',
                currency: 'USD', currencyValue: 1
            }],
            'pi-api9': [{
                conversionId: 'AW-1068017229/BxV3COOaPRDNzKL9Aw',
                currency: 'USD', currencyValue: 1
            },{
                conversionId: 'AW-11220217057/yPZCCKrBy9MYEOHZm-Yp',
                currency: 'USD', currencyValue: 1
            }],
            'wc-api2': [{
                conversionId: 'AW-1000541745/qr85CP_MrgMQsZyM3QM',
                currency: 'USD', currencyValue: 1
            }],
            'wc-api9': [{
                conversionId: 'AW-11220217057/yPZCCKrBy9MYEOHZm-Yp',
                currency: 'USD', currencyValue: 1
            }]
        };

        //cleanup the excess trustedform items so it doesn't send to leads
        // if (noloPath.CONSTANTS.trustedFormAOPs.includes(parseInt($("body").attr('data-pid'))) || $("body").attr('data-type') == 'sem') {
            var formStep = document.querySelector('#nolopath[data-step]').getAttribute('data-step');
            var isStepPII = document.querySelector('[data-form-step=' + formStep +'].active [name=first_name]');
            if (isStepPII != null) {
                document.querySelectorAll("[name*='xxTrustedForm']").forEach(function($element, idx){
                    if ($element.parentElement.id != 'for-trusted') {
                        // console.log($element, $element.parentElement.id);
                        $element.remove();
                    }
                });
                
                this.setTrustedForm();
            }
        // }

        // also add to analytics_before_closing_body list
        pathConversions['cd-api1pp'] = pathConversions['cd-api1'];
        pathConversions['dui-api1e'] = pathConversions['dui-api1'];
        pathConversions['dui-api1a'] = pathConversions['dui-api1'];
        pathConversions['dui-api1pp'] = pathConversions['dui-api1'];
        pathConversions['dui-api1ppa'] = pathConversions['dui-api1a'];
        pathConversions['dui-api1ppe'] = pathConversions['dui-api1e'];
        pathConversions['dv-api2app'] = pathConversions['dv-api2a'];
        pathConversions['emp-api2pp'] = pathConversions['emp-api2'];
        pathConversions['ep-api1pp'] = pathConversions['ep-api1'];
        pathConversions['ep-api2pp'] = pathConversions['ep-api2'];
        pathConversions['mm-api1pp'] = pathConversions['mm-api1'];
        pathConversions['pi-api5pp'] = pathConversions['pi-api5'];
        pathConversions['wc-api2pp'] = pathConversions['wc-api2'];

        var formQuestionData = this.getQuestionData();
        var form_pid = postDataObj.practice_area_id != undefined ? parseInt(postDataObj.practice_area_id) : parseInt(formQuestionData.practice_area_id);
        var searchParamsData = new URLSearchParams(window.location.search);
        var regionType = this.options.type;
        var questionnaireAOPs = [81, 84, 5016];

        if($('#nolopath-q1110').length == 1 && $('#nolopath-q1110').val() == '4: Currently employed at the same organization' && $('#nolopath-q1112').length && $('#nolopath-q1112').val() != '') {
            questionnaireAOPs.push(16);
        }

        if((questionnaireAOPs.includes(form_pid) && (regionType == 'organic' || regionType == 'sem' || regionType == 'top')) || (this.pathData.pathId == 'cd-api1d') ) {
            this.setHiddenField('has_custom_questions', '1');
        } 

        var process = this;
        var fields = this.getQueryParams(postData);
        var $phone_field = $form.find('input.validate-phone');
        var $email_field = $form.find('input[type="email"]');
        var $update_pid = false;
        // EHCS-3171 - Duplication Check for Phone is Not Working in Frontend
        if(typeof fields.phone != 'undefined' && $phone_field) {
            var phone_field_val = $phone_field.val();
            var phone_field_val_trim = phone_field_val.replace(/\D/g,'');
            var formInputsData = $form.serializeArray();
            $.each(formInputsData, function(i, field){
                if(field.name == 'phone') {
                    formInputsData[i].value = phone_field_val_trim;
                }
                if(field.name == 'questions[1110]' && field.value == '4: Currently employed at the same organization') {
                    $update_pid = true;
                }
              });
              postData = $.param(formInputsData);

              if($update_pid == true) {
                $.each(formInputsData, function(i, field){
                    if(field.name == 'pid' || field.name == 'practice_area_id') {
                        formInputsData[i].value = 16;
                        $form.find('input[name="pid"]').val(16);
                        $form.find('input[name="practice_area_id"]').val(16);
                    }
                });
                postData = $.param(formInputsData);
              }
        }

        // EHCS-4779 - CRO Winner Implementation - Update UI of Estate Planning Law Firm lander
        if( (this.pathData.pathId == 'ep-api1' || this.pathData.pathId == 'ep-api1pp') && regionType == 'sem') {
            var formInputsData1 = $form.serializeArray();
            $.each(formInputsData1, function(i, field){
                var answerOptions = {
                    '1': '1: Less than $50k',
                    '2': '2: $50k - $100k',
                    '3': '3: $100k - $250k',
                    '4': '4: $250k - $500k',
                    '5': '5: $500k - $1m',
                    '6': '6: More than $1 million',
                };
                var answerOptionKeys = Object.keys(answerOptions);
                if(field.name == 'questions[16]' && answerOptionKeys.includes(field.value)) {
                    formInputsData1[i].value = answerOptions[field.value];
                }
            });
            postData = $.param(formInputsData1);
        }

        // EHCS-2609: tcpa consent flag needs to be added here:
        // if (this.pathData.practiceAreaId == '169071') {
            //default to tcpa flag 1
            //this.setHiddenField('sms_consent_date', new Date().toUTCString());
        // }

        var elmDisabled = $elm.find('div.form-item.disabled');
        var hideRawId = elmDisabled.attr('data-raw-id');

        /* EHCS-1720 - map cancer options to option 1 (Yes) */
        var needMapping = postData.includes("questions%5B671%5D=");
        if (needMapping) {
            postData = this.mapAnswer(postData);
        }

        if (hideRawId > 0) {
            var disabledPattern = '&questions%5B'+hideRawId+'%5D=0';
            postData = postData.replace(disabledPattern, '');
        }

        //LLPLAT-1788 For min-path3 confirm page FE answer set copy update
        var questionOnTracks = [];
        if(this.$element.find('[data-answer-track=1]').length>0 || this.$element.find('[data-answer-track=true]').length>0){
            questionOnTracks = $elm.find('[data-answer-track=1],[data-answer-track=true]').map(function(){
                var questionID = $(this).attr('data-raw-id').toString();
                return questionID
            }).get();//only return array
        }
        this.questionOnTracks = questionOnTracks;

        // clear errors
        this.clearErrors();

        if(fields.phone || fields.email){
            var phoneValid = false;
            var emailValid = false;
            var promisePhone = $.ajax({
                type: 'POST',
                url: '/path2/service/getRPVValidate',
                data: {'phone': fields.phone.replace(/\D/g,'')}
            })

            var promiseEmail = $.ajax({
                type: 'POST',
                url: '/path2/service/getEmailValidate',
                data: {'email': decodeURIComponent(fields.mail)}
            })
            promisePhone.done(function(data, status){
                if(data.accept == true){
                    phoneValid = true;
                }
            }).then(function() {
                promiseEmail.done(function(data, status){
                    if(data.valid == true){
                        emailValid = true;
                    }
                })
                .then(function() {
                    if(!phoneValid){
                        if (pi5bRouting) {
                            $phone_field.addClass('valid-error');
                        } else { process.setInlineError($phone_field, process.getErrorMessage('invalid', 'default', 'phone')); }
                        $phone_field.val('');
                        process.toggleSubmitButton('disable', false);
                    }
                    if(!emailValid){
                        if (pi5bRouting) {
                            $email_field.addClass('valid-error');
                        } else { process.setInlineError($email_field, process.getErrorMessage('invalid', 'default', 'email_valid')); }
                        $email_field.val('');
                        process.toggleSubmitButton('disable', false);
                    }
                }).then(function() {
                    if(emailValid && phoneValid){
                        postData += '&domain=' + $.NOLO_PATH_CONSTANTS.canonicalhost;
                        
                        var postEntries = new URLSearchParams(postData);
                        var postObj = Object.fromEntries(postEntries);
//                        console.log("@@ validateUsingServer: postObj: ", postObj);
//                        console.log("@@ validateUsingServer: referer: ", postObj.referer);
                        
                        var apiData = process.prepareLeadApi($form, postData, leadApiUrl);
                        var useNgageApi = apiData.useNgageApi;
                        leadApiUrl = apiData.apiUrl;
                        postData = apiData.postData;

                        if(nqRouting && form_pid == 83){
                            if($('#enrichmentModal').is(":hidden") && $('#finalSubmit').length == 0){
                                process.submitToQueue(postData);
                                return;
                            } 
                        }

                        //EHCS-5556
                        if (toolsSubmitForms.includes($('body').attr('data-path'))) {
                            // partner_source_type: null to Categorize as "other form"
                            postData.metadata.ping_json.partner_info.partner_source_type = null;

                            // auto_populate_aop per path (dv-api3 = 96 Divorce, cc-api2-v2 = 94 Child Custody)
                            postData.metadata.auto_populate_aop_id = toolsSubmitAop[$('body').attr('data-path')] || 96;

                            postData.metadata.ping_json.partner_info.partner_source_name = 'Nolopath';
                            postData.metadata.ping_json.partner_info.partner_source_id = 555;

                            var urlObj = new URL(postObj.referer);
                            var nqSuccessUrl = urlObj.origin + urlObj.pathname + '/confirmsuccess';
                            process.submitToQueue(postData, nqSuccessUrl);
                            return;
                        }

                        //EHCS-5744: ep-api1 lead-scoring Q&A variant (np=ls) — queue/TYP flow
                        //mirroring dv-api3-v2 above, without the dv-api3-v2-only partner/aop overrides
                        if (['ep-api1', 'ep-api1pp'].includes($('body').attr('data-path')) && new URLSearchParams(window.location.search).get('np') === 'ls') {
                            var urlObj = new URL(postObj.referer);
                            var nqSuccessUrl = urlObj.origin + urlObj.pathname + '/confirmsuccess?np=ls';
                            process.submitToQueue(postData, nqSuccessUrl);
                            return;
                        }

                        if(nqRouting && form_pid == 83){
                            if ($('#redirectSubmit').length > 0) {
                                var urlObj = new URL(postObj.referer);
                                var nqSuccessUrl = urlObj.origin + urlObj.pathname + '/confirmsuccess';
                                // $.redirect(nqSuccessUrl, postData);
                                process.submitToTools(postData, nqSuccessUrl, true);
                                return;
                            }
                            else if ($('#finalSubmit').length != 0) {
                                var urlObj = new URL(postObj.referer);
                                var nqSuccessUrl = urlObj.origin + urlObj.pathname + '/confirmsuccess';
                                process.submitToTools(postData, nqSuccessUrl, false);
                                return;
                            }
                        }
                        // create the promise
                        var promise = $.ajax({
                            type: 'POST',
                            crossDomain: true,
                            url: leadApiUrl,
                            data: postData,
                            dataType: 'json'
                        });

                        // process submission response
                        promise.done(function(data, status, xhr){

                            if (process.getPathSubscriptionList() == 'webmd') {
                                var $elm = process.$element;
                                var providerInfo = $elm.data('providerInfo');
                                if (providerInfo != false) {
                                    data.profile = providerInfo.data.profile;
                                }
                            }
//                            console.log("@@ validateUsingServer: data: ", data);
//                            console.log("@@ validateUsingServer: status: ", status);
//                            console.log("@@ validateUsingServer: postObj: ", postObj);

                            if(useNgageApi && status === 'success') {
                                //EHCS-3808
                                var first_name = document.querySelector("#form-item-first_name input").value,
                                last_name = document.querySelector("#form-item-last_name input").value,
                                phone = document.querySelector("#form-item-phone input").value,
                                zip = document.querySelector("#nolopath-qzip").value,
                                mail = document.querySelector("#form-item-mail input").value;
                                fbConversion(first_name,last_name,mail,phone,zip);

                                var conversion, conversionId, currency, currencyValue;
                                var pathId = postObj.path;
                                if (pathId === undefined) {
                                    var pathId = process.getPathID();
                                }
                                
                                process.triggerGa4Event('formSubmitted', 'leadGeneration');
                                var urlObj = new URL(postObj.referer);
                                var conversions = pathConversions[pathId];

                                // while (conversions.length > 0) {
                                //     conversion = conversions.shift();
                                //     conversionId = conversion.conversionId;
                                //     if (conversion.currency === undefined) {
                                //         gtag('event', 'conversion', {
                                //             'send_to': conversionId
                                //         });
                                //     } else {
                                //         currency = conversion.currency;
                                //         currencyValue = conversion.currencyValue;
                                //         gtag('event', 'conversion', {
                                //             'send_to': conversionId,
                                //             'currency':  currency,
                                //             'value': currencyValue
                                //         });
                                //     }
                                // }

                                process.triggerEvent('semConversion', 'goal', postData);
                                process.triggerEvent('semLeadSubmission', 'submit');
                                successUrl = urlObj.origin + urlObj.pathname + '/confirmsuccess';
                                setTimeout(function() {
                                $.redirect(successUrl, postData);
                                }, 1250);
                                return;
                                
                            }

                            if(data.status == 'OK') {
                                var $input_ele = process.$element;
                                $input_ele.append('<input type="hidden" name="lead_submission_response"/>');
                                $input_ele.find('input[name="lead_submission_response"]').val(JSON.stringify(data));
                                process.triggerGa4Event('formSubmitted', 'leadGeneration');
                            }
                            // send the current answers to form fields
                            data.nolopath = fields;

                            return process.onAjaxSuccessSubmit(data, status, xhr);
                        });

                        // catch ajax errors
                        promise.fail(function(xhr, status, error){
                            return process.onAjaxErrorSubmit(xhr, status, error, null, leadApiUrl);
                        });

                        return;
                    }
                });
            });
        } else {
            postData += '&domain=' + $.NOLO_PATH_CONSTANTS.canonicalhost;
            // create the promise
            var promise = $.ajax({
                type: 'POST',
                crossDomain: true,
                url: leadApiUrl,
                data: postData,
                dataType: 'json'
            });

            // process submission response
            promise.done(function(data, status, xhr){
                if (process.getPathSubscriptionList() == 'webmd') {
                    var $elm = process.$element;
                    var providerInfo = $elm.data('providerInfo');
                    if (providerInfo != false) {
                        data.profile = providerInfo.data.profile;
                    }
                }

                if(data.status == 'OK') {
                    var $input_ele = process.$element;
                    $input_ele.append('<input type="hidden" name="lead_submission_response"/>');
                    $input_ele.find('input[name="lead_submission_response"]').val(JSON.stringify(data));
                    process.triggerGa4Event('formSubmitted', 'leadGeneration');
                }
                // send the current answers to form fields
                data.nolopath = fields;

                return process.onAjaxSuccessSubmit(data, status, xhr);
            });

            // catch ajax errors
            promise.fail(function(xhr, status, error){
                return process.onAjaxErrorSubmit(xhr, status, error, null, leadApiUrl);
            });

            return;
            }
        };
   noloPath.prototype.prepareLeadApi = function($form, postData, leadApiUrl){
//        const ngageApiUrl = 'https://webops.stg2.thelawlinks.com/cdiscovery_api/api/nggateway/nololead';
        const ngageApiUrl = 'https://www.martindalecd.com/cdiscovery_api/api/nggateway/nololead';
        const nolopathNgageApiUrl = '/path2/service/postNgage';
        
        const ngageApiForms = [
            '/sem/cd-api1', '/sem/cd-api1pp',
            '/sem/cd-api1d', '/sem/cd-api1dpp',
            '/sem/cd-api2',
            '/sem/dui-api1', '/sem/dui-api1pp',
            '/sem/dui-api1a', '/sem/dui-api1ppa',
            '/sem/dui-api1e', '/sem/dui-api1ppe',
            '/sem/dui-api2',
            '/sem/dv-api2a', '/sem/dv-api2app',
            '/sem/dv-api3', '/sem/dv-api3-v2',
            '/sem/emp-api2', '/sem/emp-api2pp',
            '/sem/ep-api1', '/sem/ep-api1pp',
            '/sem/ep-api2', '/sem/ep-api2pp',
            '/sem/mm-api1', '/sem/mm-api1pp',
            '/sem/pi-api5', '/sem/pi-api5pp',
            '/sem/pi-api8',
            '/sem/pi-api9',
            '/sem/wc-api2', '/sem/wc-api2pp',
            '/sem/wc-api9',
            '/sem/cc-api2-v2',
            '/sem2/cd-api1', '/sem2/cd-api1pp'
        ];   // forms handledby ngage leads api

        const proxy_thru_nolopath = [
            '/sem/cd-api1d', '/sem/cd-api1dpp'
        ]

        const aiSpeechTextForms = [
            '/sem/dui-api1ppe', '/sem/dui-api1e'
        ]
        const ExpungementAop = 8937;
        const postEntries = new URLSearchParams(postData);
        const postObj = Object.fromEntries(postEntries);
        var pid = Number(postObj.pid);
        var pathUrl = postObj.path_url;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var semData = urlParams.get('data') ? urlParams.get('data') : urlParams.get('keywordid');
        var semSource = urlParams.get('source') ? urlParams.get('source') : urlParams.get('utm_source');
//        console.log("@@ prepareLeadApi: ngageApiForms: ", ngageApiForms);
//        console.log("@@ prepareLeadApi: postObj: ", postObj);
//        console.log("@@ prepareLeadApi: pathUrl: ", pathUrl);

        // Holding this QATextSet for NDR purposes
        window.global_qa_obj = this.buildQATextSet(postObj, $form);
      
        if (ngageApiForms.indexOf(pathUrl) === -1 || pid === ExpungementAop) {
            return {apiUrl: leadApiUrl, postData: postData, useNgageApi: false};
        }
        
        var qaTextSet;
        if((this.pathData.pathId == 'pi-api5' || this.pathData.pathId == 'pi-api5pp') && (urlParams.has('routing') && urlParams.get('routing') == 'pi5b')){
            // quiz styled
            qaTextSet = this.buildQATextSetQuiz(postObj, $form);
        } else {
            //standard
            qaTextSet = this.buildQATextSet(postObj, $form);
        }
//        var qaSet = this.buildQASet(postObj, qaTextSet);
        var consumer_info = this.buildConsumerInfo(postObj);
        var case_info = this.buildCaseInfo(postObj, qaTextSet);
        if((this.pathData.pathId == 'pi-api5' || this.pathData.pathId == 'pi-api5pp') && (urlParams.has('routing') && urlParams.get('routing') == 'pi5b')){
            case_info.questions['98'] = '8';
        }

        var transcriptQAJson = [];
        var transcriptJsonQaPaths = [
            'cd-api1d', 'cd-api1dpp',
            'dv-api3', 'dv-api3-v2',
            'cc-api2-v2',
        ];
        var transcriptJsonQaPathAops = [
            '14','96','94'
        ];
        var boolTranscriptJsonQa = false;
        if (transcriptJsonQaPaths.includes(this.pathData.pathId) && transcriptJsonQaPathAops.includes(document.querySelector('body').getAttribute('data-pid'))) {
            boolTranscriptJsonQa = true;
            console.log('transcript true in prepare');
        }
        //EHCS-5744: ep-api1 lead-scoring Q&A variant (np=ls) only — live ep-api1/ep-api1pp are unaffected
        if (['ep-api1', 'ep-api1pp'].includes(this.pathData.pathId) && new URLSearchParams(window.location.search).get('np') === 'ls') {
            boolTranscriptJsonQa = true;
        }
        var case_description_with_q_and_a = this.buildDescriptionWithQNA(postObj, qaTextSet, transcriptQAJson);

        var curDate = new Date();
        var leadDate = this.formatNgageApiDate(curDate);
        var sms_optin_status = document.querySelector(".form-hidden-questions input[name='sms_optin_status']").value;
        
        // TCPA Consent Verbiage
        var full_tcpa = '';
        document.querySelectorAll("label[data-tcpa*=leadid_tcpa]").forEach(function($element, idx) {
            full_tcpa += ($element.innerText + ' ');
            // document.querySelector(".form-hidden-questions input[name='tcpa_consent_verbiage']").value = full_tcpa;
        });
        full_tcpa = full_tcpa.trim();
        full_tcpa = full_tcpa.replace("Terms of Use", "[Terms of Use](https://www.internetbrands.com/ibterms/)");
        full_tcpa = full_tcpa.replace("Privacy Policy", "[Privacy Policy](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace("privacy policy", "[privacy policy](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace(/\b(click here)\b/gi, function(match){return "[" + match + "](ACTION:SUBMIT_WITHOUT_CONSENT)"});

        //for spanish
        full_tcpa = full_tcpa.replace("Términos de Uso", "[Términos de Uso](https://www.internetbrands.com/ibterms/)");
        full_tcpa = full_tcpa.replace("Política de Privacidad", "[Política de Privacidad](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace("política de privacidad", "[política de privacidad](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace('oprime aquí', function(match){return "[" + match + "](ACTION:SUBMIT_WITHOUT_CONSENT)"});

        full_tcpa = full_tcpa.replace(/(\r\n|\n|\r)/gm, "");
        
        var ping_obj = {
            "auth_token": "ng_9061f69c1ef3212edd160ca53c39ff73",
            "auth_token_name": "ngage",
            "partner_info": {
                "partner_source_name": "Ngage",
                "partner_lead_id": "12345",
                "partner_lead_date": leadDate,
                "partner_source_type": "1-0-UP-Form",
                "partner_source_id": "555",
                "partner_source_url": postObj.referer,
                "partner_sem_source": semSource,
                "partner_sem_data": semData
            },
            "consumer_info": consumer_info,
            "case_info": case_info
        };

        //if smartly id exists as a hidden input 
        if(document.querySelector('input[name=smartly_fb_ad_id]')) {
            ping_obj['case_info'].smartly_fb_ad_id = postObj.smartly_fb_ad_id;
            ping_obj['case_info'].smartly_fb_click_time = postObj.smartly_fb_click_time;
        }

        // note: ip_address will be added by cDiscovery_api gateway proxy
        var metaObj = {
            "ping_json": ping_obj,
            "q_and_a": this.reformatQaTextSet(qaTextSet.qaTextSet),
            "sms_optin_status": sms_optin_status,
            "tcpa_consent_verbiage": full_tcpa,
            "referer": (document.querySelector('input[name="referer"]') || {}).value || ''
        };

        if (['cd-api1d', 'cd-api1dpp'].includes(this.pathData.pathId) && pid == 14) {
            delete metaObj.ping_json.case_info.questions;
        }

        //if smartly id exists as a hidden input 
        if(document.querySelector('input[name=smartly_fb_ad_id]')) {
            metaObj.smartly_fb_ad_id = postObj.smartly_fb_ad_id;
            metaObj.smartly_fb_click_time = postObj.smartly_fb_click_time;
        }

        if(document.querySelector(".form-hidden-questions input[name='govmt_emp_question']") && document.querySelector(".form-hidden-questions input[name='govmt_emp_answer']")) {
            var q_and_a_filter = [];
            metaObj['q_and_a'].forEach(function(item) {
                if($.trim(item.question) !== "What is the cause of the injury that you incurred?") {
                    q_and_a_filter.push(item);
                }
            });
            metaObj['q_and_a'] = q_and_a_filter;

            var govmt_emp_question = document.querySelector(".form-hidden-questions input[name='govmt_emp_question']").value;
            var govmt_emp_answer = document.querySelector(".form-hidden-questions input[name='govmt_emp_answer']").value;
            var govtEmpMbr = {'question': govmt_emp_question, 'answer': govmt_emp_answer};

            metaObj['q_and_a'].push(govtEmpMbr);
            if(govmt_emp_answer == 'Yes') {
                if(document.querySelector(".form-step-questions input[name='emplr_name']")) {
                    var emplr_name_question = document.querySelector(".form-step-questions label[for='nolopath-qemplr_name']").textContent;
                    emplr_name_question = emplr_name_question.substring(0, emplr_name_question.indexOf('?') + '?'.length);
                    var emplr_name_answer = $.trim(document.querySelector(".form-step-questions input[name='emplr_name']").value);
                    var emprMbr = {'question': emplr_name_question, 'answer': emplr_name_answer};
                    metaObj['q_and_a'].push(emprMbr);
                }
            }
        }

        if (aiSpeechTextForms.indexOf(pathUrl) !== -1) {
            if (document.querySelector('.form-hidden-questions input[name="aiSpeechText"]')){
                metaObj.aiSpeechText = document.querySelector('.form-hidden-questions input[name="aiSpeechText"').value;
            } else {
                metaObj.aiSpeechText = false;
            }
        }

        var ngagePostObj = {
            "WebsiteID": "15-103-212-197-7-216-247-236",
            "name": postObj.first_name + ' ' + postObj.last_name,
            "email": postObj.mail,
            "phone": postObj.phone.replace(/\D/g,''),
            "zip": postObj.zip,
            "description": case_description_with_q_and_a,
            "loc": postObj.referer,
            "metadata": metaObj,
            "use_redirect": "no"
        };

        // NOLOPM-2752: also expose Google Places location data at the root level of the Ngage
        // payload (in addition to metadata.ping_json.consumer_info.location_*). Added only when
        // present, so non-geo ngage forms are unaffected.
        var ngageLocationFields = [
            'location_city', 'location_state', 'location_state_abbr',
            'location_county', 'location_lat', 'location_lng', 'location_formatted_address'
        ];
        for (var li = 0; li < ngageLocationFields.length; li++) {
            var nlf = ngageLocationFields[li];
            if (postObj[nlf]) {
                ngagePostObj[nlf] = postObj[nlf];
            }
        }

        if (document.querySelector('input[name="xxTrustedFormCertUrl"]') != null) {
            var trustedFormID = document.querySelector('input[name="xxTrustedFormCertUrl"]').value;
            metaObj.trusted_form_id = trustedFormID.substring(trustedFormID.lastIndexOf('/')+1);
        }

        if(boolTranscriptJsonQa == true) {
            ngagePostObj.metadata.ping_json.consumer_info.allow_without_qa = true;
            ngagePostObj.metadata.ping_json.consumer_info.transcript = transcriptQAJson;
            ngagePostObj.metadata.ping_json.case_info.case_description = ngagePostObj.description;
        }
    
    //    console.log("@@ prepareLeadApi: ngagePostObj: ", ngagePostObj)
        var newPostData = new URLSearchParams(ngagePostObj).toString();
//        return {apiUrl: ngageApiUrl, postData: newPostData, useNgageApi: true};

        if (proxy_thru_nolopath.indexOf(pathUrl) !== -1 ) {
            return {apiUrl: nolopathNgageApiUrl, postData: ngagePostObj, useNgageApi: true};            
        } else {
            return {apiUrl: ngageApiUrl, postData: ngagePostObj, useNgageApi: true};
        }
    };


    noloPath.prototype.addQnaObject = function(obj, q, a) {
        obj = obj || [];
        obj.push({ question: q, response: a });
        return obj;
    };

    noloPath.prototype.buildDescriptionWithQNA = function(postObj, qaTextSet, transcriptQAJson) {
        var qaDescText = 'Questions and Answers: ';
        transcriptQAJson = transcriptQAJson || [];
        /*
         * EHCS-3902: add Q & A texts to case description
         */
        var descriptionWithQAPaths = [
            'pi-api5', 'pi-api5pp', 
            'pi-api9', 
            'cd-api1', 'cd-api1pp', 
            'cd-api1d', 'cd-api1dpp',
            'cd-api2', 
            'wc-api2', 'wc-api2pp', 
            'wc-api9', 
            'pi-api8',
            'emp-api2', 'emp-api2pp',
            'ep-api1', 'ep-api1pp',
            'ep-api2', 'ep-api2pp',
            'mm-api1', 'mm-api1pp',
            'dui-api1', 'dui-api1pp',
            'dui-api1e', 'dui-api1ppe',
            'dui-api2',
            'dv-api3', 'dv-api3-v2',
            'cc-api2-v2'
        ];
        var ConditionalDescWithQAPaths = [
            'dui-api1', 'dui-api1pp',
            'dui-api1e', 'dui-api1ppe',
            'wc-api2', 'wc-api2pp',
            'wc-api9', 'wc-api9pp'
        ];

        var routingQAInCD = [
            'pi-api9',
            'cd-api1', 'cd-api1pp',
            'cd-api1d', 'cd-api1dpp',
            'cd-api2',
            'wc-api2', 'wc-api2pp',
            'wc-api9',
            'dui-api1', 'dui-api1pp',
            'dui-api1e', 'dui-api1ppe',
            'dui-api2',
        ]

        var WcConditionalDescWithQAPaths = [
            'dui-api1', 'dui-api1pp', 'dui-api1e', 'dui-api1ppe',
        ];

        var Wc2ConditionalDescWithQAPaths = [
            'wc-api2', 'wc-api2pp'
        ];

        var transcriptJsonQaPaths = [
            'cd-api1d', 'cd-api1dpp',
            'dv-api3', 'dv-api3-v2',
            'cc-api2-v2'
        ];

        var transcriptJsonQaPathAops = [
            '14', '96', '94'
        ];

        var boolTranscriptJsonQa = false;
        if (transcriptJsonQaPaths.includes(this.pathData.pathId) && transcriptJsonQaPathAops.includes(document.querySelector('body').getAttribute('data-pid'))) {
            boolTranscriptJsonQa = true;
            console.log('transcript true in build');
        }
        //EHCS-5744: ep-api1 lead-scoring Q&A variant (np=ls) only — live ep-api1/ep-api1pp are unaffected
        if (['ep-api1', 'ep-api1pp'].includes(this.pathData.pathId) && new URLSearchParams(window.location.search).get('np') === 'ls') {
            boolTranscriptJsonQa = true;
        }

        var caseDescription = "Description of Incident: \n" + postObj.case_description;
        var caseDescriptionWithQA = caseDescription;
        var path = postObj.path;
        var pathUrl = postObj.path_url;
        if (path === undefined) {
            var path = pathUrl.substring(5);
        }
        var urlParams = new URLSearchParams(window.location.search);
        var qaInDesc = false;
        var pi5bRouting = false;
        if (ConditionalDescWithQAPaths.includes(path) && urlParams.has('qaInDesc')) {
            qaInDesc = urlParams.get('qaInDesc');
        }
        var nqRouting = false;
        if((this.pathData.pathId == 'wc-api2' || this.pathData.pathId == 'wc-api2pp') && urlParams.has('nq')){
            nqRouting = urlParams.get('nq');
        }
        // if((path == 'pi-api5' || path == 'pi-api5pp') && urlParams.has('routing')){ og-pi5b
        //     pi5bRouting = urlParams.get('routing');
        // }

        if ((WcConditionalDescWithQAPaths.includes(path) && urlParams.has('qaInDesc')) || routingQAInCD.includes(path)) {
            if(document.querySelector(".form-hidden-questions input[name='routing_question']") !=null && document.querySelector(".form-hidden-questions input[name='routing_answer']") != null) {
                var routing_question = document.querySelector(".form-hidden-questions input[name='routing_question']").value;
                var routing_answer = document.querySelector(".form-hidden-questions input[name='routing_answer']").value;
                qaDescText += '\n' + routing_question + ' RESPONSE: ' + routing_answer;
                if(boolTranscriptJsonQa) {
                    this.addQnaObject(transcriptQAJson, routing_question, routing_answer);
                }
            }
        }

        var boolIsWc2Questinare = false;
        if(Wc2ConditionalDescWithQAPaths.includes(path) && urlParams.has('questionnaire') && urlParams.get('questionnaire') == 'true') {
            if(document.querySelector(".form-hidden-questions input[name='govmt_emp_question']") !=null && document.querySelector(".form-hidden-questions input[name='govmt_emp_answer']") != null) {
                boolIsWc2Questinare = true;
                var govmt_emp_question = document.querySelector(".form-hidden-questions input[name='govmt_emp_question']").value;
                var govmt_emp_answer = document.querySelector(".form-hidden-questions input[name='govmt_emp_answer']").value;
                qaDescText += '\n' + govmt_emp_question + ' RESPONSE: ' + govmt_emp_answer;
                if(govmt_emp_answer == 'Yes') {
                    if(document.querySelector(".form-step-questions input[name='emplr_name']")) {
                        var emplr_name_question = document.querySelector(".form-step-questions label[for='nolopath-qemplr_name']").textContent;
                        emplr_name_question = emplr_name_question.substring(0, emplr_name_question.indexOf('?') + '?'.length);
                        var emplr_name_answer = $.trim(document.querySelector(".form-step-questions input[name='emplr_name']").value);
                        qaDescText += '\n' + emplr_name_question + ' RESPONSE: ' + emplr_name_answer;
                        if(boolTranscriptJsonQa) {
                            this.addQnaObject(transcriptQAJson, emplr_name_question, emplr_name_answer);
                        }
                    }
                }
            }
        }

        if (descriptionWithQAPaths.includes(path) || qaInDesc === "true") {
            var qaSet = qaTextSet.qaTextSet;
            for (var $i=0; $i<qaSet.length; $i++) {
                if(boolIsWc2Questinare==true && qaSet[$i].id[0] == '109') {
                    continue;
                }
                qaDescText += '\n' + qaSet[$i].question + ' RESPONSE: ' + String(qaSet[$i].answer || "").replace(/<\/?(br|span)[^>]*>/gi, "");
                if(boolTranscriptJsonQa) {
                    this.addQnaObject(transcriptQAJson, qaSet[$i].question.toString().trim(), String(qaSet[$i].answer || "").replace(/<\/?(br|span)[^>]*>/gi, ""));
                }
                // if(pi5bRouting == 'pi5b'){ og-pi5b
                //     switch (qaSet[$i].id[0]){
                //         case '39':
                //             var qnaObject = this.getQnaObject('form-item-conditional_2');
                //             if (qnaObject) qaDescText += '\n' + qnaObject.question + ' RESPONSE: ' + qnaObject.answer;
                //             break;
                //         case '98':
                //             qaDescText += '\n' + 'Type Of Injury:'+' RESPONSE: ' + this.getTypeOfInjury();
                //             var qnaObject = this.getQnaObject('form-item-conditional_1');
                //             if (qnaObject) qaDescText += '\n' + qnaObject.question + ' RESPONSE: ' + qnaObject.answer;
                //             if(sessionStorage.getItem('dogbite')){
                //                 var qnaObject = this.getQnaObject('form-item-dogbite_1_up');
                //                 if (qnaObject) qaDescText += '\n' + qnaObject.question + ' RESPONSE: ' + qnaObject.answer;
                //             } else if (sessionStorage.getItem('slipfall')){
                //                 var qnaObject = this.getQnaObject('form-item-slipfall_1_up');
                //                 if (qnaObject) qaDescText += '\n' + qnaObject.question + ' RESPONSE: ' + qnaObject.answer;
                //             }
                //             break;
                //     }
                // }
            };

            if(nqRouting && $('input[name="injury_reported_enrich"]:checked').length == 1 && $('input[name="prior_injury_enrich"]:checked').length == 1){
                qaDescText += '\n' + 'Was the injury reported and documented? RESPONSE: ' + $('input[name="injury_reported_enrich"]:checked').val() + '\n Did you have a prior injury? RESPONSE: ' + $('input[name="prior_injury_enrich"]:checked').val();
                if(boolTranscriptJsonQa) {
                    this.addQnaObject(transcriptQAJson, 'Was the injury reported and documented?', $('input[name="injury_reported_enrich"]:checked').val());
                    this.addQnaObject(transcriptQAJson, 'Did you have a prior injury?', $('input[name="prior_injury_enrich"]:checked').val());
                }
            }
            caseDescriptionWithQA = caseDescription + '\n\n' + qaDescText;
        }
        
        return caseDescriptionWithQA;
    };

    noloPath.prototype.getQnaObject = function(questionName){
        var Qna = null;
        var abTestQna = JSON.parse(sessionStorage.getItem('abTestQna'));
        if(sessionStorage.getItem('abTestQna')){
            Qna = abTestQna[questionName]
        }
        if(!Qna) return null;
        var qnaAnswer = Qna[Object.keys(Qna)[0]];
        var qnaQuestion = Object.keys(Qna)[0];
        return {'question':qnaQuestion, 'answer': qnaAnswer};
    }

    noloPath.prototype.getTypeOfInjury = function(){
        var pid = sessionStorage.getItem('pid');
        switch(pid){
            case '30a':
                return 'Dog Bite';
            case '30b':
                return 'Slip & Fall';
            case '30c':
                return 'Other Injury';
        }
    }

    noloPath.prototype.buildCaseInfo = function(postObj, qaTextSet){
        var caseInfo = {
            "practice_area_id": postObj.practice_area_id,
            "case_description": postObj.case_description,
            "questions": this.reformatQaSet(qaTextSet.qaSet),
        };

        if (document.querySelector('input[name="xxTrustedFormCertUrl"]') != null) {
            var trustedFormID = document.querySelector('input[name="xxTrustedFormCertUrl"]').value;
            caseInfo.trusted_form_id = trustedFormID.substring(trustedFormID.lastIndexOf('/')+1);
        }
        
        return caseInfo;
    };

    noloPath.prototype.buildConsumerInfo = function(postObj){
        var $elm = this.$element;
        var sms_optin_status = document.querySelector(".form-hidden-questions input[name='sms_optin_status']").value;

        // TCPA Consent Verbiage
        var full_tcpa = '';
        document.querySelectorAll("label[data-tcpa*=leadid_tcpa]").forEach(function($element, idx) {
            full_tcpa += ($element.innerText + ' ');
            // document.querySelector(".form-hidden-questions input[name='tcpa_consent_verbiage']").value = full_tcpa;
        });
        full_tcpa = full_tcpa.trim();
        full_tcpa = full_tcpa.replace("Terms of Use", "[Terms of Use](https://www.internetbrands.com/ibterms/)");
        full_tcpa = full_tcpa.replace("Privacy Policy", "[Privacy Policy](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace("privacy policy", "[privacy policy](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace(/\b(click here)\b/gi, function(match){return "[" + match + "](ACTION:SUBMIT_WITHOUT_CONSENT)"});

        //for spanish
        full_tcpa = full_tcpa.replace("Términos de Uso", "[Términos de Uso](https://www.internetbrands.com/ibterms/)");
        full_tcpa = full_tcpa.replace("Política de Privacidad", "[Política de Privacidad](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace("política de privacidad", "[política de privacidad](https://www.internetbrands.com/privacy/privacy-main)");
        full_tcpa = full_tcpa.replace('oprime aquí', function(match){return "[" + match + "](ACTION:SUBMIT_WITHOUT_CONSENT)"});

        full_tcpa = full_tcpa.replace(/(\r\n|\n|\r)/gm, "");
        
        var consumerInfo = {
            "first_name": postObj.first_name,
            "last_name": postObj.last_name,
            "zip": postObj.zip,
            "mail": postObj.mail,
            "phone": postObj.phone.replace(/\D/g,''),
            "sms_optin_status": sms_optin_status,
            "tcpa_consent_verbiage": full_tcpa
        };

        // NOLOPM-2752: pass Google Places location data to the Ngage (martindale) API too,
        // using the same field names as the leads-submit endpoint. Added only when present
        // (i.e. the dui-api1 geo variant), so other ngage forms are unaffected.
        var locationFields = [
            'location_city', 'location_state', 'location_state_abbr',
            'location_county', 'location_lat', 'location_lng', 'location_formatted_address'
        ];
        for (var i = 0; i < locationFields.length; i++) {
            var lf = locationFields[i];
            if (postObj[lf]) {
                consumerInfo[lf] = postObj[lf];
            }
        }

        return consumerInfo;
    };

    noloPath.prototype.formatNgageApiDate = function(date){
        var yyyy = date.getFullYear();
        var mm = date.getMonth()+1;
        var dd = date.getDate();
        if (mm < 10) mm = '0' + mm;
        if (dd < 10) dd = '0' + dd;
        const formattedDate = mm + '/' + dd + '/' + yyyy;

        return formattedDate; 
    };

    noloPath.prototype.buildQASet = function(postObj, qaTextSet){
        const qIdRegEx = /[0-9]+\-[0-9]+/;      // match multi-select checkbox format
        var postObjIdx, answer;
        var qa_set = {};
        var aQaTextSet = Array.from(qaTextSet);
        for (var i=0; i< aQaTextSet.length; i++) {
            var mbr = qaTextSet[i];
            var idx = mbr.id;
            if (Number.isNaN(Number(idx)) && !idx.match(qIdRegEx)) {
                continue;
            }
            if (typeof aQaTextSet[i].id === 'undefined') {
                continue;
            }
            if (mbr.id.match(qIdRegEx)) {
                var aQArrayIdxs = idx.split('-');
                postObjIdx = 'questions\[' + aQArrayIdxs[0] + '\]\[' + aQArrayIdxs[1] + '\]';
                answer = postObj[postObjIdx];
                qa_set[aQaTextSet[i].id] = answer;
            } else {
                postObjIdx = 'questions[' + qaTextSet[i].id + ']';
                var answer = postObj[postObjIdx];
                if (answer.indexOf(': ') > -1) {
                    answer = answer.substring(0, answer.indexOf(': '));
                }
                qa_set[aQaTextSet[i].id] = answer;
            }
        }
//        console.log("@@ buildQASet: qa_set: ", qa_set);

        return qa_set;
    };

    noloPath.prototype.buildQATextSet = function(postObj, $form){

        const qIdRegEx = /[0-9]+\-[0-9]+/;      // match multi-select checkbox format
        const inputFormTypes = ['INPUT', 'SELECT', 'TEXTAREA'];
        const formElms = $form.prop('elements');
        var formElm, postObjIdx, question, label, idx, idx0, qaSetIdx, answerId, isMultiSelect;
        var qaMember, qaTextMember;
        var answer = null;
        var idxSet = [];
        var questionSet = [];
        var answerIdSet = [];
        var answerSet = [];
        var multiSelectSet = [];
        var qaSet = [];
        var qaTextSet = [];
        for (var i=0; i<formElms.length; i++) {
            formElm = formElms.item(i);
            if (!formElm.id || !inputFormTypes.includes(formElm.nodeName)) {
                continue;
            }
            var elmId = formElm.id;
            idx = elmId.replace('nolopath-q', '');
            label = Array.from(formElm.labels||[]).map(function(element) {
                return element.textContent.trim();
            }).filter(Boolean).join('');
//            console.log("@@ buildQATextSet: elmId: ", elmId);
//            console.log("@@ buildQATextSet: idx: ", idx);
//            console.log("@@ buildQATextSet: label: ", label);
            if (Number.isNaN(Number(idx)) && !idx.match(qIdRegEx)) {
//                question = label;
//                answer = postObj[idx];
                continue;
            }
            
            if (!idx.match(qIdRegEx)) {
                isMultiSelect = false;
                question = label;
                postObjIdx = 'questions[' + idx + ']';
                var fullAnswer = postObj[postObjIdx];
                if (!fullAnswer) {continue;}
                var answerNodes = fullAnswer.split(': ');
                answerId = answerNodes[0];
                answer = answerNodes[1];
                //input[type=text] specific fix - "name of unsafe product" or a <input type="textarea" name="questions[something]">
                if (formElm.type == 'text' || (formElm.type == "textarea" && formElm.name.includes("questions["))) {
                    answer = answerNodes[0];
                }

                //parquat textarea question handling
                if (formElm.name == "questions[1065]") {
                    answer = formElm.value
                }

                idx0 = idx;
                qaSetIdx = postObjIdx;
            } else {
                if(formElm.type == 'radio' && this.options.type == 'sem' && (this.pathData.pathId == 'ep-api1' || this.pathData.pathId == 'ep-api1pp')) {
                    isMultiSelect = false;
                    var qIdxs = formElm.id.split('-');
                    var qElmId = 'nolopath-' + qIdxs[1];
                    question = $('label[data-q-id="' + qElmId).text();
                    var aQArrayIdxs = idx.split('-');
                    var idx0 = aQArrayIdxs[0];
                    var postQuestinIndex = 'questions['+idx0+']';
                    var fullAnswer = postObj[postQuestinIndex];
                    if (!fullAnswer) {continue;}
                    // Only the checked option for this question should be recorded — the loop
                    // visits every radio in the group, and (unlike 'select' fields) a radio's
                    // posted value is the bare option id (e.g. "7"), never "id: text", so read
                    // the label off data-text instead of splitting fullAnswer on ': '.
                    if (!formElm.checked) {continue;}
                    answerId = fullAnswer;
                    answer = formElm.getAttribute('data-text');
                    qaSetIdx = idx0;
                } else if (formElm.getAttribute("type") == "radio") {
                    // For Radio
                    isMultiSelect = false;
                    var aQArrayIdxs = idx.split('-');
                    idx0 = aQArrayIdxs[0]; // example idx = 14-0 ; idx0 = 14
                    qaSetIdx = 'questions[' + idx0 + ']';
                    postObjIdx = 'questions[' + aQArrayIdxs[0] + ']';
                    var qElmId = 'nolopath-q' + aQArrayIdxs[0]; // ex. #nolopath-q14
                    question = $('label[data-q-id="' + qElmId).text();
                    answerId = postObj['postObjIdx'];
                    answer = label;
                    //need to find out if the question is a radio first...
                    if (postObj.hasOwnProperty(postObjIdx) && formElm.checked) {
                    answer = formElm.getAttribute('data-text');
                    answerId = postObj[postObjIdx];
                    } else {
                        continue;
                    }
                } else {
                    isMultiSelect = true;
                    var aQArrayIdxs = idx.split('-');
                    idx0 = aQArrayIdxs[0];  // example idx = 14-0 ; idx0 = 14
                    qaSetIdx = 'questions[' + idx0 + ']';
                    postObjIdx = 'questions[' + aQArrayIdxs[0] + '][' + aQArrayIdxs[1] + ']';
                    var qElmId = 'nolopath-q' + aQArrayIdxs[0];    // ex. #nolopath-q14
                    question = $('label[data-q-id="' + qElmId).text();
                    answerId = postObj['postObjIdx'];
                    answer = label;
                    if (postObj.hasOwnProperty(postObjIdx)) {
    //                        answer = postObj[postObjIdx];
                        answer = Array.from(formElm.labels||[]).map(function(element) {
                            return element.textContent.trim();
                        }).filter(Boolean).join('');
                        answerId = postObj[postObjIdx];
                    } else {
                        continue;
                    }
                }
            }
            
            if (!answerIdSet.hasOwnProperty(qaSetIdx)) {
                answerIdSet[qaSetIdx] = [];
            }
            answerIdSet[qaSetIdx].push(answerId);
            if (!answerSet.hasOwnProperty(qaSetIdx)) {
                answerSet[qaSetIdx] = [];
            }
            if (answer.indexOf(': ') > -1) {
                answer = answer.substring(answer.indexOf(': ')+2);
            }
            answerSet[qaSetIdx].push(answer);
            if (question.length > 0) {
                question = question.replace(/Step\s\d\sof\s\d/, '');
            }
            if (!questionSet.hasOwnProperty(qaSetIdx)) {
                questionSet[qaSetIdx] = [];
                questionSet[qaSetIdx].push(question);
                multiSelectSet[qaSetIdx] = isMultiSelect;
            }
            if (!idxSet.hasOwnProperty(qaSetIdx)) {
                idxSet[qaSetIdx] = [];
                idxSet[qaSetIdx].push(idx0);
            }
        }

        for (var key in idxSet) {
            qaMember = {
                id: idxSet[key], question: idxSet[key], answer: answerIdSet[key], multiSelect: multiSelectSet[key]
            };
            qaSet.push(qaMember);
            qaTextMember = {
                id: idxSet[key], question: questionSet[key], answer: answerSet[key], multiSelect: multiSelectSet[key]
            };
            qaTextSet.push(qaTextMember);
        }
        var qaAllTextSet = {'qaSet': qaSet, 'qaTextSet': qaTextSet};

        return qaAllTextSet;
    };

    noloPath.prototype.buildQATextSetQuiz = function(postObj, $form){

        // Get every item under fieldset
        var allQs = document.querySelectorAll("fieldset .modal-body_main-step.answered");

        var qaSet = [];
        var qaTextSet =[];

        // ignore case-desc and pii-step
        for (var i=0; i<allQs.length; i++) {
            if (['case-desc', 'pii-step'].includes(allQs[i].getAttribute('data-progress-step'))) {
                //ignore
            } else {
                var qaSetItem = {
                    "id": [allQs[i].getAttribute("data-raw-id")],
                    "question": [allQs[i].getAttribute("data-raw-id")],
                    "answer": [],
                    "multiSelect": false
                };

                var qaTextSetItem = {
                    "id": [ allQs[i].getAttribute("data-raw-id")],
                    "question": [allQs[i].getAttribute("data-short-question")],
                    "answer": [],
                    "multiSelect": false
                }

                qaSetItem["multiSelect"] = document.getElementById(allQs[i].id).querySelector(":checked").type == 'radio' ? false : true;
                qaTextSetItem["multiSelect"] = document.getElementById(allQs[i].id).querySelector(":checked").type == 'radio' ? false : true;

                // Checkbox:
                if (qaSetItem["multiSelect"]) {
                    var checkboxAnswers = document.getElementById(allQs[i].id).querySelectorAll(":checked");
                    qaSetItem["answer"] = [];
                    qaTextSetItem["answer"] =[];
                    for (var j=0; j<checkboxAnswers.length; j++) {
                        qaSetItem["answer"].push(checkboxAnswers[j].value);
                        qaTextSetItem["answer"].push(checkboxAnswers[j].getAttribute("data-text"));
                    }
                } 
                // Radio:
                else {
                    qaSetItem["answer"].push(document.getElementById(allQs[i].id).querySelector(":checked").value);
                    qaTextSetItem["answer"].push(document.getElementById(allQs[i].id).querySelector(":checked").getAttribute("data-text"));
                }

                qaSet.push(qaSetItem);
                qaTextSet.push(qaTextSetItem);
            }
        }

        var qaAllTextSet = {'qaSet': qaSet, 'qaTextSet': qaTextSet};

        return qaAllTextSet;
    };

    noloPath.prototype.reformatQaSet = function(qaSet){
        var mbr, answer, newMbr;
        var newSet = {};

        /* Limit to pi5b */
        var pi5bRouting = false;
        var urlParams = new URLSearchParams(window.location.search);
        if((this.pathData.pathId == 'pi-api5' || this.pathData.pathId == 'pi-api5pp') && urlParams.has('routing')){
            pi5bRouting = urlParams.get('routing');
        }

        for (var i=0; i<qaSet.length; i++) {
            mbr = qaSet[i];
            
            // in quiz style, skip ids that don't resemble a Number
            if (pi5bRouting) {
                if (!Number(mbr.question)) { continue; }
            }
            var question = mbr.question;
            if (!mbr.multiSelect) {
                question = question[0];
            }
            answer = mbr.answer;
            if (!mbr.multiSelect) {
                answer = answer[0];
            }
            newSet[question.toString()] = answer;
        }
        return newSet;
    };

    noloPath.prototype.reformatQaTextSet = function(qaTextSet){
        var newSet = [];
        // var pi5bRouting = false; og-pi5b
        // var urlParams = new URLSearchParams(window.location.search);
        // if((this.pathData.pathId == 'pi-api5' || this.pathData.pathId == 'pi-api5pp') && urlParams.has('routing')){
        //     pi5bRouting = urlParams.get('routing');
        // }
        var urlParams = new URLSearchParams(window.location.search);
        var nqRouting = false;
        if((this.pathData.pathId == 'wc-api2' || this.pathData.pathId == 'wc-api2pp') && urlParams.has('nq')){
            nqRouting = urlParams.get('nq');
        }
        qaTextSet.sort(function(a,b) {
            return Number(a.id[0]) > Number(b.id[0]) ? 1 : -1;
        });
        for (var i=0; i<qaTextSet.length; i++) {
            var mbr = qaTextSet[i];
            var question = mbr.question[0];
            var answer = mbr.answer;
            if (answer.length === 1) {
                answer = answer[0];
            }
            if (answer.indexOf(': ') > -1) {
                answer = answer.substring(answer.indexOf(': ')+2);
            }
            var newMbr = {'question': question, 'answer': answer};
            newSet.push(newMbr);
            // if(pi5bRouting == 'pi5b'){ og-pi5b
            //     switch (mbr.id[0]){
            //         case '39':
            //             var qnaObject = this.getQnaObject('form-item-conditional_2');
            //             if (qnaObject) newSet.push({'question': qnaObject.question, 'answer': qnaObject.answer})
            //             break;
            //         case '98':
            //             newSet.push({'question': 'Type Of Injury:', 'answer': this.getTypeOfInjury()})
            //             var qnaObject = this.getQnaObject('form-item-conditional_1');
            //             if (qnaObject) newSet.push({'question': qnaObject.question, 'answer': qnaObject.answer})
            //             if(sessionStorage.getItem('dogbite')){
            //                 var qnaObject = this.getQnaObject('form-item-dogbite_1_up');
            //                 if (qnaObject) newSet.push({'question': qnaObject.question, 'answer': qnaObject.answer})
            //             } else if (sessionStorage.getItem('slipfall')){
            //                 var qnaObject = this.getQnaObject('form-item-slipfall_1_up');
            //                 if (qnaObject) newSet.push({'question': qnaObject.question, 'answer': qnaObject.answer})
            //             }
            //             break;
            //         default:
            //             break;
            //     }
            // }
        }
        if(nqRouting && $('input[name="injury_reported_enrich"]:checked').length == 1 && $('input[name="prior_injury_enrich"]:checked').length == 1) {
            var newMbr = {'question': "Was the injury reported and documented?", 'answer': $('input[name="injury_reported_enrich"]:checked').val()};
            newSet.push(newMbr);
            newMbr = {'question': 'Did you have a prior injury?', 'answer': $('input[name="prior_injury_enrich"]:checked').val()};
            newSet.push(newMbr);
        }
        return newSet;
    };

    noloPath.prototype.getWebmdProviderInfo = function(){
        var $elm = this.$element;
        var directGuid = this.extractDirectGUID();
        var url = window.location.origin + "/path/service/getProviderInfo/";
        $.get(url + directGuid).done(function(data, status, xhr) {
            if (data.profile.data.location.phone){
                var pStandardLoose = /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})(.*)$/;
                data.profile.data.info.phoneClickToCall = data.profile.data.location.phone[0].replace(pStandardLoose, '+1$1$2$3');
                data.profile.data.info.phoneFormatted = data.profile.data.location.phone[0].replace(pStandardLoose, '($1) $2-$3');
            }
            $elm.data('providerInfo', {data: data});
        }).error(function(){
            var $elm = this.$element;
            $elm.data('providerInfo', false);
        });
    }

    noloPath.prototype.clearErrors = function(){
        var $elm = this.$element;

        // find all .error classes and remove them
        $elm.find('.has-error').removeClass('has-error');
        $elm.find('.error').removeClass('error');

        // find all .inline-error containers and remove them
        $elm.find('.inline-error').remove();

        // clear the status errors and hide the container
        $elm.find('.form-status-errors').html('').hide();

        // clear status error data
        $elm.data(noloPath.DATANAME + '.status', []);

        // clear submit button error
        this.removeSubmitButtonError();

        $("body").removeClass("threshold-error");
        $("body").removeClass("refresh-error");

        return;
    }

    noloPath.prototype.removeInlineError = function(field){
        var $field = field;
        var $parent = $field.parents('.form-group');

        if($parent.hasClass('has-error')){
            $parent.removeClass('has-error');
            $parent.find('.error').removeClass('error');
            $parent.find('.inline-error').remove();
        }
    }

    noloPath.prototype.setSubmitButtonError = function() {
        var $submitButton = $('.form-action-submit').not('.case-description-submit');
        var message = this.getErrorMessage('submit', 'default');
        if ($('.submit-error').length == 0) {
            $submitButton.after('<div class="submit-error" style="display: none !important;">' + message + '</div>');
        }
    }

    noloPath.prototype.removeSubmitButtonError = function() {
        $('.submit-error').remove();
    }

    noloPath.prototype.setErrorData = function(key, value){
        // 'errorData' should be initialized from the start
        // if it was not, initialize it as a blank object
        if(!this.errorData){
            this.errorData = {};
        }

        // set 'errorData' key-value pair
        this.errorData[key] = value;

        // return the value
        return value;
    }

    noloPath.prototype.setPathData = function(key, value){
        // 'pathData' should be initialized from the start
        // if it was not, initialize it as a blank object
        if(!this.pathData){
            this.pathData = {};
        }

        // set 'pathData' key-value pair
        this.pathData[key] = value;

        // return the value
        return value;
    }

    noloPath.prototype.setCurrentStep = function(currentStep){
        var $elm = this.$element;
        var options = this.options;
        var submitBehavior = options.submitBehavior;

        switch(submitBehavior){
            case noloPath.CONSTANTS.submitBehaviorAjax:
            case noloPath.CONSTANTS.submitBehaviorHybrid:
            // @note:
            // + several functions within this application will update this property as the application progresses
            // + utilizes the 'currentStep' argument
            // + assumes 'step-1' when the application first runs
            this.currentStep = currentStep || 'step-1';
            break;

            case noloPath.CONSTANTS.submitBehaviorStatic:
            default:
            // @note:
            // + the 'cNPHDataFormQuestions' PHP class will set this hidden field automatically
            //   as the user advances through the path using 'noloPath.CONSTANTS.submitBehaviorStatic'
            // + ignores the 'currentStep' argument
            // + assumes 'step-1' when the field is not present
            this.currentStep = $elm.find('input[name="nolopath_current_step"]').val() || 'step-1';
            break;
        }

        return this.currentStep;
    }

    noloPath.prototype.setStepsData = function(step){
        var $elm = this.$element;
        var totalSteps  = $elm.find('.form-step').length;
        var currentStep;

        // if the currentStep is not set, set it first
        if(typeof this.currentStep === 'undefined'){
            this.setCurrentStep();
        }
        if(this.currentStep === 'step-2' && this.options.type === 'organic'){
            window.scrollTo(0,0);
        }

        // define current step
        currentStep = step || this.currentStep;

        // set steps data
        this.stepsData = new noloPathStepsData(currentStep, totalSteps);

        return this.stepsData;
    }

    noloPath.prototype.setInlineError = function($field, error){
        // test $field as an instance of jQuery to ensure the operations work
        // ---------
        // @note:
        // + we are testing either instance of 'jQuery' or '$' as the field may be a prototype of one or the other
        //   depending on the implementation
        if(typeof $field === 'object' && ($field instanceof jQuery || $field instanceof $)){
            // EHCS-5739: on the geo variant the visible field is 'zipInput' (pp-v2), while the
            // real 'zip' field is a hidden proxy (#form-item-zip is display:none). Redirect a
            // 'zip' error onto the visible 'zipInput' so server errors (place/find "Invalid Zip
            // Code") are actually seen on mobile.
            if($field.attr('name') === 'zip' && $field.closest('#nolopath').hasClass('np-loc-geo')){
                var $geoZipInput = $field.closest('#nolopath').find('input[name="zipInput"]');
                if($geoZipInput.length){ $field = $geoZipInput; }
            }
            // EHCS-5688/5739: on the geo variant (np-loc-geo), the zip/zipInput field holds a
            // city/location string until a Google Places pick resolves it to a zip. Suppress the
            // client "Invalid 5-digit US zip code" flash ONLY while it holds non-5-digit text
            // (a city being typed) - the '.geo-no-match-msg' handles that. A 5-digit value must
            // still show its error (e.g. the server place/find "Invalid Zip Code" response), and
            // an empty field still shows the required error.
            var _geoFieldName = $field.attr('name');
            var _geoFieldVal = $.trim($field.val() || '');
            if ((_geoFieldName === 'zip' || _geoFieldName === 'zipInput') &&
                $field.closest('#nolopath').hasClass('np-loc-geo') &&
                _geoFieldVal !== '' && !/^\d{5}$/.test(_geoFieldVal)) {
                return;
            }
            // EHCS-5739: for a 5-digit zip rejected on the geo variant (e.g. the server
            // place/find "Invalid Zip Code" response), show the consistent "no match" wording
            // instead of "Invalid 5-digit US zip code".
            if ((_geoFieldName === 'zip' || _geoFieldName === 'zipInput') &&
                $field.closest('#nolopath').hasClass('np-loc-geo') &&
                /^\d{5}$/.test(_geoFieldVal)) {
                error = 'No matches found. Please enter a valid 5-digit ZIP code.';
            }
            var $parent = $field.parents('.form-group');
            var $inline = $parent.find('.inline-error');
            var errorMessage = this.getInlineErrorMessage($field, error);
            var fieldType = $field.prop('tagName');

            // flag the parent container with 'has-error'
            $parent.addClass('has-error');
            $parent.find('.form-control').addClass('error');

            if ($inline.length > 0){
                $inline.html(errorMessage);
            } else {
                switch(fieldType){
                    case 'CHECKBOX':
                    case 'RADIO':
                    case 'DIV':
                    case 'INPUT':
                    case 'SELECT':
                    case 'TEXTAREA':
                    $parent.append('<div class="inline-error">'+errorMessage+'</div>');
                    break;

                    default:
                    $field.after('<div class="inline-error">'+errorMessage+'</div>');
                }
            }
        }
        return;
    }

    noloPath.prototype.setStatusError = function(id, status, errorMessage, errorData){
        var $elm = this.$element;
        var $fse = $elm.find('.form-status-errors');
        var dataName = noloPath.DATANAME + '.status';
        var data = $elm.data(dataName);
        var error = {
            'id': id,
            'status': null,
            'message': errorMessage,
            'data': errorData,
            'is_error': false,
            'is_warning': false,
            'is_success': false,
            'is_info': false,
        };
        var dataExists = false;
        var mst_alerts = this.mst_alerts;

        // check the status type against valid values
        var validStatus = ['error', 'notice', 'info', 'success', 'warning', 'danger'];
        var test = $.inArray(status, validStatus);

        // set error flags
        if (test < 0 || typeof status === 'undefined') {
            error.status = 'error';
            error.is_error = true;
        } else {
            switch(status){
                case 'notice':
                case 'warning':
                error.is_warning = true;
                break;

                case 'success':
                error.is_success = true;
                break

                case 'info':
                error.is_info = true;
                break;

                case 'error':
                case 'danger':
                default:
                error.is_error = true;
                break;
            }

            error.status = status;
        }

        // retrieve status error data
        if (!data){
            $elm.data(dataName, data = [error]);
        } else {
            // double-check if a specific error id already exists, so we do not create a duplicate
            for (var i in data){
                if (data[i]['id'] === id) {
                    dataExists = true;
                    break;
                }
            }

            // set the status error message data
            if (!dataExists) {
                data.push(error);
            }
        }

        // render and show
        this.render(mst_alerts, '.form-status-errors', {'errors': data});
        $fse.show();

        // scroll to the top
        $('html, body').animate({ scrollTop: 0 }, 'fast');

        return;
    }

    noloPath.prototype.getEventParameters = function(event, params, data){
        var path = this.getPathID();
        var loader = this.getPathLoader();
        var blockId = this.getBlockId();
        var regionId = this.getRegionId();
        var regionGeneral = this.getRegionGeneral(regionId)
        var p = params || 'default';
        var e = {
            'type': event,
            'extraParameters': {
                'step'     : p,
                'path'     : path,
                'loader'   : loader,
                'block'    : blockId,
                'region'   : regionId,
                'leadsapi' : data || {},
                'regionGeneral' : regionGeneral
                }
            };

        return e;
    }

    noloPath.prototype.triggerEvent = function(event, params, data){
        var $elm = this.getElement();
        var e = this.getEventParameters(event, params, data);

        $elm.trigger(e);
        return false;
    }

    noloPath.prototype.triggerGa4Event = function(event, params, data){
        var noloPathAnalyticsData = $("#nolopath").data('nolo.noloPathAnalytics');
        if( this.options.type === 'organic' && noloPathAnalyticsData.options.google_ga4_id ) {
            var pid = parseInt( this.getPathData('practiceAreaId') );
            var ga4_pids = $.NOLO_PATH_CONSTANTS.ga4EnabledAOPs;
            if( ga4_pids && ( ga4_pids.includes( pid ) || ga4_pids.includes( pid.toString() ) ) || ( pid == 8937 && event == 'questionAnswered' && params == 'q8937' ) || ( event == 'formSubmitted' && params == 'leadGeneration' ) ) {
                try{
                    this.triggerEvent(event, params, data);
                }catch (e) {
                    console.log('e=', e);
                }
            }
        }
    }

    noloPath.prototype.setGa4ContentGroup = function( pid, practice_area_name ) {
        var noloPathAnalyticsData = $("#nolopath").data('nolo.noloPathAnalytics');
        var ga4_pids = $.NOLO_PATH_CONSTANTS.ga4EnabledAOPs;
        pid = parseInt( pid );
        var regionId = this.getRegionId();
        var regionGeneral = this.getRegionGeneral(regionId);

        if( this.options.type === 'organic' && (regionGeneral != 'top' && pid != 0 && noloPathAnalyticsData.options.google_ga4_id && practice_area_name)) {
            if( typeof gtag == 'function')gtag('set', {'content_group': practice_area_name});
            else {
//                console.log('adding to gtagStack')
                if(!window.gtagStack) window.gtagStack=[];
                window.gtagStack.push(['set', {'content_group': practice_area_name}]);
            }

        } else if( window.location.host.includes('nolo.com') && this.options.type === 'organic' && regionGeneral == 'top'  && typeof gtag == 'function') {
            // EHCS-2182 - Change the Leads Routing logic for the PI leads
            if( typeof gtag == 'function') gtag('set', {'content_group': practice_area_name});
            else {
//                console.log('adding to gtagStack')
                if(!window.gtagStack) window.gtagStack=[];
                window.gtagStack.push(['set', {'content_group': practice_area_name}])
            }
        }
    }

    noloPath.prototype.setBreadcrumb = function(){
        var $elm = this.$element;
        var $crumb = $elm.find('.breadcrumb > li');
        var stepIdx = this.getCurrentStepIndex();
        var isOnLastStep = this.isOnLastStep();

        $crumb.each(function(idx){
            var self = $(this);

            // add the before class so we can modify the crumb immediately before the 'active' crumb
            if(self.hasClass('before')){
                self.removeClass('before');
            }

            // remove the current 'active' class, and replace with 'before'
            if(self.hasClass('active')){
                self.removeClass('active');
            }

            // set 'active' class
            if(idx === (stepIdx - 1)){
                self.addClass('active');
                self.prev().addClass('before');
            }
        });

        // EHCS-5744: ep-api1 (np=ls) wants a cumulative fill (steps 1..N all
        // filled, not just the current one highlighted) — add a dedicated
        // class rather than repurposing '.active'/'.before' so dv-api3-v2
        // and every other path's breadcrumb behavior is untouched.
        if (['ep-api1', 'ep-api1pp'].includes(this.pathData.pathId) && new URLSearchParams(window.location.search).get('np') === 'ls') {
            $crumb.each(function(idx){
                $(this).toggleClass('epls-filled', idx <= (stepIdx - 1));
            });
        }

        // switches the breadcrumb to use '.last-step' styles
        if(isOnLastStep){
            $elm.find('.breadcrumb').addClass('last-step');
        }

        // EHCS-5697: dv-api3-v2 groups several form steps under one visual
        // breadcrumb segment (e.g. 3 "Summary Info" steps share one label).
        // Figma shows the active segment's "N of total" progress and a
        // checkmark on fully-completed segments — neither is something the
        // shared engine natively supports (it only toggles .active/.before).
        if (['dv-api3', 'dv-api3-v2'].includes(this.pathData.pathId)) {
            this.setSegmentedBreadcrumbLabels($crumb, stepIdx);
        } else if (['ep-api1', 'ep-api1pp'].includes(this.pathData.pathId) && new URLSearchParams(window.location.search).get('np') === 'ls') {
            this.setStepLabelText($crumb, stepIdx);
        }

        return;
    }

    // EHCS-5744: ep-api1 (np=ls) shows a single text line above the progress
    // bar ("Your situation — step N of 3" / "Your contact details") instead
    // of per-segment breadcrumb labels — the li's themselves stay blank
    // (font-size: 0), pure colored bars, via CSS. Consecutive li's sharing
    // the same configured 'label' (question_set_ep-api1-ls) are grouped;
    // groups of 1 show their label plain, with no "— step N of total" suffix.
    noloPath.prototype.setStepLabelText = function($crumb, stepIdx){
        var activeIdx = stepIdx - 1;
        var groups = [];

        $crumb.each(function(idx){
            var $li = $(this);
            var baseLabel = $li.data('baseLabel');
            if (baseLabel === undefined) {
                baseLabel = $.trim($li.text());
                $li.data('baseLabel', baseLabel);
            }
            var lastGroup = groups[groups.length - 1];
            if (lastGroup && lastGroup.label === baseLabel) {
                lastGroup.items.push(idx);
            } else {
                groups.push({ label: baseLabel, items: [idx] });
            }
        });

        var activeGroup = null;
        for (var i = 0; i < groups.length; i++) {
            var g = groups[i];
            if (activeIdx >= g.items[0] && activeIdx <= g.items[g.items.length - 1]) {
                activeGroup = g;
                break;
            }
        }
        if (!activeGroup) { return; }

        var text = activeGroup.label;
        if (activeGroup.items.length > 1) {
            var posInGroup = (activeIdx - activeGroup.items[0]) + 1;
            text += ' — step ' + posInGroup + ' of ' + activeGroup.items.length;
        }

        $('#epls-step-label').text(text);
    }

    noloPath.prototype.setSegmentedBreadcrumbLabels = function($crumb, stepIdx){
        var checkmarkSvg = '<svg class="dv3v2-step-check" viewBox="0 0 16 16" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#175759"/><path d="M4.5 8.3L6.8 10.6L11.5 5.5" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var activeIdx = stepIdx - 1; // 0-based, matches $crumb.each's idx

        // group consecutive <li>s sharing the same base label (cached in
        // jQuery data on first run, since later runs may have already
        // rewritten the visible li's text with a "— N of total" suffix
        // or a checkmark)
        var groups = [];
        $crumb.each(function(idx){
            var $li = $(this);
            var baseLabel = $li.data('baseLabel');
            if (baseLabel === undefined) {
                baseLabel = $.trim($li.text());
                $li.data('baseLabel', baseLabel);
            }
            var lastGroup = groups[groups.length - 1];
            if (lastGroup && lastGroup.label === baseLabel) {
                lastGroup.items.push(idx);
            } else {
                groups.push({ label: baseLabel, items: [idx] });
            }
        });

        groups.forEach(function(group){
            var $target = $crumb.eq(group.items[0]);
            var groupStart = group.items[0];
            var groupEnd = group.items[group.items.length - 1];

            if (activeIdx > groupEnd) {
                // fully completed segment
                $target.html(group.label + ' ' + checkmarkSvg);
            } else if (activeIdx >= groupStart && activeIdx <= groupEnd) {
                // active segment — show progress within the group
                var posInGroup = (activeIdx - groupStart) + 1;
                $target.text(group.label + ' — ' + posInGroup + ' of ' + group.items.length);
            } else {
                // not yet reached
                $target.text(group.label);
            }
        });
    }

    noloPath.prototype.setActionButtons = function(){
        var $submit = this.getElement('.form-action-submit, .form-action-backtrack');
        var isOnLastStep = this.isOnLastStep();
        var isOnFirstStep = this.isOnFirstStep();
        var isOnBeforeLastStep = this.isOnBeforeLastStep();

        if(isOnFirstStep){
            // switches the submit button to use step styles and label
            $submit.addClass('first-step');
            $submit.html(function(index, oldHtml){
                return $(this).data('labelFirst') || $(this).data('labelStep') || oldHtml;
            });
        } else {
            $submit.removeClass('first-step');
        }

        if(isOnLastStep){
            // switches the submit button to use '.last-step' styles and label
            $submit.addClass('last-step')
            $submit.html(function(index, oldHtml){
                return $(this).data('labelLast') || $(this).data('labelStep') || oldHtml;
            });
        } else {
            $submit.removeClass('last-step');
        }

        if(isOnBeforeLastStep){
            // switches the submit button to use '.before-last-step' styles and label
            $submit.addClass('before-last-step')
            $submit.html(function(index, oldHtml){
                return $(this).data('labelBeforeLast') || $(this).data('labelStep') || oldHtml;
            });
        } else {
            $submit.removeClass('before-last-step');
        }

        if(!isOnFirstStep && !isOnLastStep && !isOnBeforeLastStep){
            $submit.html(function(index, oldHtml){
                return $(this).data('labelStep') || oldHtml;
            });
        }
    }

    noloPath.prototype.setProviders = function(providers, showProfile){
        var $container = this.getElement('.form-providers');
        var options = this.options;
        var data = {
            'count': providers.length,
            'has_providers': (providers.length > 0),
            'has_one_provider': (providers.length === 1),
            'practice_area_name': this.getPathPracticeAreaName(),
            'message': options.providersMessage,
            'show_profile': showProfile || false,
            'providers': [],
        };
        var val;

        if (data.has_providers){
            data.providers = providers;
        }
        this.render(this.mst_providers, '.form-providers', data);
        $container.show();

        return;
    }

    noloPath.prototype.setProvidersText = function(count, practiceArea){
        var $providersText = this.getElement('.form-providers-text');
        var data = {
            'count': count,
            'has_providers': (count > 0),
            'has_one_provider': (count === 1),
            'practice_area_name': practiceArea,
        };
        this.render(this.mst_providers_text, '.form-providers-text', data);

        if (data.has_providers) {
            $providersText.show();
        } else {
            $providersText.hide();
        }
    }

    noloPath.prototype.setFormSummary = function(){
        var $summary = this.getElement('.form-summary');
        for(var i=0; i<this.getQuestionData().questions.length; i++){
            if(!this.getQuestionData().questions[i].isRequired && !this.getQuestionData().questions[i].answered){
                this.getQuestionData().questions[i].value = 'N/A';
                this.getQuestionData().questions[i].answered = true;
            }
        }
        var summaryData = this.getQuestionData();
        // render the summary block
        this.render(this.mst_summary, $summary, summaryData);

        // bind the show more behavior for the case description summary
        this.bindShowMore();

        this.bindSummaryEdit();
    }

    noloPath.prototype.setHiddenField = function(name, value, decodeValue, fieldId){
        var $elm = this.$element;
        var $hidden = $elm.find('.form-hidden-questions');
        var $field  = $elm.find('input[name="'+name+'"]');

        // determine 'decodeValue'
        if(typeof decodeValue === 'undefined'){
            decodeValue = true;
        }

        // decode value
        if (typeof decodeValue === 'boolean' && decodeValue){
            value = decodeURIComponent(value);
        }

        if ($field.length > 0){
            // update the field value
            $field.val(value);

            // set id if possible
            if (fieldId != null) {
                $field.attr("id",fieldId);
            }
        } else if (fieldId) {
            $field = '<input id="'+fieldId+'" type="hidden" name="'+name+'" value="'+value+'" />';
            $hidden.append($field);
        }else {
            // add the field
            $field = '<input type="hidden" name="'+name+'" value="'+value+'" />';
            $hidden.append($field);
        }

        return;
    }

    noloPath.prototype.setSurl = function(){
        var $field = this.getElement('input[name="surl"]');
        var surl = $field.val();

        if(!surl || decodeURIComponent(surl) === '/'){
            // use the surl property generated earlier
            surl = this.surl;
        } else {
            // update the surl property
            this.surl = surl;
        }
        //check if the surl is absolute path: contains scheme(https).subdomain(www/stg).domain
        var isAbsolute = /(https:\/\/)[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~]*)*(#[\w\-]*)?(\?.*)?/.test(surl);
        if(!isAbsolute && location.search.includes('surl')){
            //EHCS-1904: Only fix bottom lead
            //piece surl using knowing attributes
            var surl_relative = surl.replace(/^\//, '');
            var domain = this.getElement('input[name="domain"]').val();
            if(!domain) domain = 'nolo.com';
            var SUBDOMAIN_BTM_LEAD_MAP = {
                'dev-path'  : 'dev-ncms',
                'stg1-path' : 'stg1',
                'stg2-path' : 'stg2',
                'stg3-path' : 'stg3',
                'stg4-path' : 'stg4',
                'stg5-path' : 'stg5',
                'www'       : 'www',
                'default' : ''
            };
            var hostSubdomain = location.hostname.split('.')[0];
            var bottom_lead_subdomain = SUBDOMAIN_BTM_LEAD_MAP[hostSubdomain]+'.';
            // ECHS-1939: production only: when subdomain is not in the map
            if(!SUBDOMAIN_BTM_LEAD_MAP[hostSubdomain]) bottom_lead_subdomain = SUBDOMAIN_BTM_LEAD_MAP['default'];
            var surl_absolute = 'https://'+bottom_lead_subdomain+domain+'/'+surl_relative;
            surl = surl_absolute;
        }
        // create/update hidden field
        this.setHiddenField('surl', surl);
    }

    noloPath.prototype.setTrustedForm = function(){
        try {
            // create/update hidden field
            var trustedFormID = document.querySelector('input[name="xxTrustedFormCertUrl"]').value;
            this.setHiddenField('trusted_form_id', trustedFormID.substring(trustedFormID.lastIndexOf('/')+1));
        } catch(e) {
            console.log("Trusted Form failed to populate");
        }
    }

    noloPath.prototype.setReferer = function(){
        var $field = this.getElement('input[name="referer"]');
        var ref = $field.val();

        if(!ref){
            // use the referer property generated earlier 
            
            // When ref is undefined/null....
            if(document.querySelector('body').getAttribute('data-type') == 'sem') {
                // SEM ref/referer will be CURRENT URL + query params
                ref = this.referer;
            } else {
                // SEO ref/referer will be the immediate previous URL
                ref = document.referrer;
            }
        } else {
            // update the referer property
            this.referer = ref;
        }

        // create/update hidden field
        this.setHiddenField('referer', ref);
    }

    noloPath.prototype.setAutoPopulateAOPid = function(){
        const autoPopulatePaths = [
            'dv-api2', 'dv-api2pp',
            'dv-api3', 'dv-api3-v2'
        ];

        if(document.querySelector('body[data-path]') && document.querySelector('body[data-path]').getAttribute('data-path')) {
            var data_path = document.querySelector('body[data-path]').getAttribute('data-path');
            if (autoPopulatePaths.includes(data_path)) {
                var data_path = document.querySelector('body[data-path]').getAttribute('data-path');
                this.setHiddenField('auto_populate_aop_id', "96");
                // this.setHiddenField('allow_without_qa', "true");
            }
        }
    }

    noloPath.prototype.setCompanyID = function(){
        const autoPopulateCompanyIDPaths = [
            'spanish'
        ];
        if(document.querySelector('body[data-path]') && document.querySelector('body[data-path]').getAttribute('data-path')) {
            var data_path = document.querySelector('body[data-path]').getAttribute('data-path');
            
            if (autoPopulateCompanyIDPaths.includes(data_path)) {
                this.setHiddenField('company_id', "Totalsocial - SEM - SPA");
            }
        }
    }

    noloPath.prototype.setBlockInfo = function(){
        var query = this.query;
        var params = ['block_id', 'region_id', 'path_url'];

        for (var i = 0; i < params.length; i++) {
            if(query[params[i]]){
                // create/update hidden field
                this.setHiddenField(params[i], query[params[i]]);
            }
        }
    }

    noloPath.prototype.setNanigansPID = function(){
        var $elm = this.$element;
        var $field = $elm.find('input[name="nan_pid"]');
        var pid = $field.val();

        // duplicate the 'nan_pid' parameter if detected
        // + this is intended for nanigans analytics handling
        if(pid){
            this.setHiddenField('nan_nan_pid', pid);
        }
    }

    noloPath.prototype.extractDirectGUID = function () {
        // extract the 'direct_guid' only if configured
        if(this.options.setDirectGuid){
            var pathname = location.pathname;
            var guidRegEx = /[a-zA-Z0-9\-]{16,}$/g;
            var match = pathname.match(guidRegEx);

            if($.isArray(match)){
                return match[0];
            }
        }

        return;
    }

    noloPath.prototype.setDirectGuid = function () {
        // set the 'direct_guid' only if configured
        if(this.options.setDirectGuid){
            var $elm = this.$element;
            var $field = $elm.find('input[name="direct_guid"]');
            var directGuid = $field.val();

            if (typeof directGuid !== 'undefined' && $field.attr('type') !== 'hidden') {
                this.setHiddenField('direct_guid', directGuid);
            } else {
                var urlGuid = this.extractDirectGUID();
                if (urlGuid) this.setHiddenField('direct_guid', urlGuid);
            }
        }
    }

    noloPath.prototype.setDefaultAOP = function () {
        var aopSelector = 'select#nolopath-practice-area-select';
        var $elm = this.$element;
        var $aopSelect = $elm.find(aopSelector);
        var $currentAop = $aopSelect.find('option[selected]');
        var $default = $currentAop.next();

        $currentAop.removeAttr('selected');
        $default.attr('selected', 'selected');
        $aopSelect.val($default.val()).change();
    }

    noloPath.prototype.setSkey = function(skey){
        var $elm = this.$element;
        var $field = $elm.find('input[name="skey"]');
        var val = $field.val();

        // in cases of non-AJAX submission, the skey is propagated through POST,
        // and is automatically created as a hidden field on page load.
        if(typeof skey !== 'undefined'){
            this.setHiddenField('skey', skey);
            return skey;
        }

        return val;
    }

    noloPath.prototype.setUserEngaged = function(value){
        this.stepsData.isUserEngaged = (typeof value === 'boolean') ? value : this.stepsData.isUserEngaged;
        return this.stepsData.isUserEngaged;
    }

    noloPath.prototype.getCookie = function(name){
        return Cookies.get(name);
    }

    noloPath.prototype.setCookie = function(name, value, options){
        return Cookies.set(name, value, options);
    }

    noloPath.prototype.setNanigansParams = function(data){
        var $elm = this.$element;
        var nan_params = ['nan_app_id', 'nan_type', 'nan_name', 'nan_user_id', 'nan_ut1'];
        var $nan_param;
        var current_step;
        var leadgen_data;
        var special_step;
        var nan_param_vals = {};
        var val;

        if(typeof data === 'object'){
            current_step = this.getCurrentStepIndex() || data.step,
            leadgen_data = data.data,
            special_step = data.special;

            switch(special_step){
                case 'confirm':
                    nan_param_vals['nan_name'] = 'form_complete';
                    nan_param_vals['nan_type'] = 'user';
                    nan_param_vals['nan_ut1']  = leadgen_data.user.mail_hash;
                break;

                case 'last':
                default:
                    nan_param_vals['nan_name'] = 'step_'+ (current_step + 1);
                    nan_param_vals['nan_type'] = 'user';
                    if(leadgen_data){
                        nan_param_vals['nan_user_id'] = leadgen_data.skey;
                    }
            }
        }

        for (var i=0; i < nan_params.length; i++){
            $nan_param = $elm.find('input[name="'+nan_params[i]+'"]');
            val = nan_param_vals[nan_params[i]];

            if($nan_param.length > 0){
                // update hidden parameter if exists
                if ($nan_param.val() !== val && typeof val !== 'undefined'){
                    $nan_param.val(val);
                }
            } else {
                // add the hidden parameter if it doesn't exist
                this.setHiddenField(nan_params[i], '');
            }
        }
    }

    noloPath.prototype.redirect = function(url, values, method, target){
        if(typeof $.redirect == 'function' && typeof Redirect == 'undefined' && $('#nolopath-insert').length>0 && window.routingTarget) {
            delete window.routingTarget;
            localStorage.setItem(
                'values',
                JSON.stringify(values)
            )
            $.redirect(url, values, method, target)
            return;
        }
        try {
            // use the redirect plugin to send POST response data to another page
            Redirect(url, values, method, target);
        } catch (err) {
            $.error('Unable to call $.redirect: ' + err.message);
        }

        return;
    }

    noloPath.prototype.render = function(template, target, data, partials, method){
        // use Mustache.js to render stuff to the page

        Mustache.parse(template);
        var rendered = Mustache.render(template, data, partials);
        var $target;
        var allowedMethods = noloPath.CONSTANTS.renderInsertionMethods;

        // set the value of $target
        switch (typeof target){
            case 'object':
            // a jQuery object
            $target = target;
            break;

            case 'string':
            default:
            // a selector string
            $target = this.$element.find(target);
        }

        // render if the target is valid
        if($target.length > 0){

            // set insertion method
            // -----
            // @note:
            // + 'method' will accept the following valid jQuery insertion methods
            //   + 'html': replace the contents of the target
            //   + 'after': insert as the element 'after' the target
            //   + 'before': insert as the element 'before' the target
            //   + 'append': insert as the 'last' element of the target
            //   + 'prepend': insert as the 'first' element of the target
            //   + 'replaceWith': replace the target
            // + by default, if undefined, method is set to 'html'
            method = method || 'html';

            // test for valid methods
            if(($.inArray(method, allowedMethods) >= 0) && (typeof $target[method] === 'function')){
                // run the insertion function
                $target[method](rendered);
            } else {
                // throw an error to the browser for developer correction
                $.error('Desired render insertion method, ' + method + ', is not a valid jQuery DOM insertion function!');
            }
        }
        return;
    }

    noloPath.prototype.onAjaxSuccessValidateZip = function(data, status, xhr){
        var $elm = this.$element;
        var $zip = $elm.find('input[name="zip"]');
        var $loc = $elm.find('input[name=location]');
        var $parent = $zip.parents('.form-group');
        var z = $.trim($zip.val());
        var cachedData = $elm.data('zipCodeData') || {};
        var errors = noloPath.CONSTANTS.inlineErrorMessages[this.options.lang];
        var urlParams = new URLSearchParams(window.location.search);

        

        // invalid 5-digit zip code detected
        // flag field with error
        if(data === 'Invalid Zip Code'){
            this.setInlineError($zip, errors.invalid.zip);
            // if(this.pathData.pathId == 'pi-api5' && urlParams.get('routing') == 'pi5b'  && this.getCurrentStep() == 'step-1'){ og-pi5b
            //     this.setInlineError($('#zipInput'), errors.invalid.zip);
            // }
            this.triggerEvent('semZipValidation', 'invalid-zip');

            // update 'zipCodeData'
            cachedData = {
                'zipCode' : z,
                'status': 'error',
                'message': data,
                'location': null,
            };
            $elm.data('zipCodeData', cachedData);

            return false;
        }

        // valid 5-digit zip code detected
        if($parent.hasClass('has-error')){
            $parent.removeClass('has-error');
            $parent.find('.error').removeClass('error');
            $zip.next().remove();
        }

        // update the field value to use the trimmed zip-code
        // also update the location field, if present
        $zip.val(z);
        $loc.val(z);

        // Setting state based from zip code
        var states=[{state:"Alabama",short_state:"AL"},{state:"Alaska",short_state:"AK"},{state:"Arizona",short_state:"AZ"},{state:"Arkansas",short_state:"AR"},{state:"California",short_state:"CA"},{state:"Colorado",short_state:"CO"},{state:"Connecticut",short_state:"CT"},{state:"dc",short_state:"DC"},{state:"Delaware",short_state:"DE"},{state:"Florida",short_state:"FL"},{state:"Georgia",short_state:"GA"},{state:"Hawaii",short_state:"HI"},{state:"Idaho",short_state:"ID"},{state:"Illinois",short_state:"IL"},{state:"Indiana",short_state:"IN"},{state:"Iowa",short_state:"IA"},{state:"Kansas",short_state:"KS"},{state:"Kentucky",short_state:"KY"},{state:"Louisiana",short_state:"LA"},{state:"Maine",short_state:"ME"},{state:"Maryland",short_state:"MD"},{state:"Massachusetts",short_state:"MA"},{state:"Michigan",short_state:"MI"},{state:"Minnesota",short_state:"MN"},{state:"Mississippi",short_state:"MS"},{state:"Missouri",short_state:"MO"},{state:"Montana",short_state:"MT"},{state:"Nebraska",short_state:"NE"},{state:"Nevada",short_state:"NV"},{state:"New Hampshire",short_state:"NH"},{state:"New Jersey",short_state:"NJ"},{state:"New Mexico",short_state:"NM"},{state:"New York",short_state:"NY"},{state:"North Carolina",short_state:"NC"},{state:"North Dakota",short_state:"ND"},{state:"Ohio",short_state:"OH"},{state:"Oklahoma",short_state:"OK"},{state:"Oregon",short_state:"OR"},{state:"Pennsylvania",short_state:"PA"},{state:"Rhode Island",short_state:"RI"},{state:"South Carolina",short_state:"SC"},{state:"South Dakota",short_state:"SD"},{state:"Tennessee",short_state:"TN"},{state:"Texas",short_state:"TX"},{state:"Utah",short_state:"UT"},{state:"Vermont",short_state:"VT"},{state:"Virginia",short_state:"VA"},{state:"Washington",short_state:"WA"},{state:"West Virginia",short_state:"WV"},{state:"Wisconsin",short_state:"WI"},{state:"Wyoming",short_state:"WY"}];
        var stateSplit = data.split(', ');
        var state_name;
        try {
            state_name = states.find(function(x){
                return x.short_state==stateSplit[1];
            }).state.toLowerCase().replace(/ /g,'')
        } catch (error) {
            state_name = '';
        }
        this.setHiddenField('zip_state', state_name);

        if(!cachedData.zipCode || cachedData.zipCode !== z){
            // update 'zipCodeData'
            cachedData = {
                'zipCode' : z,
                'status': 'success',
                'message': null,
                'location': data,
            };
            $elm.data('zipCodeData', cachedData);
        }

        // trigger 'semZipValidation' event for analytics
        this.triggerEvent('semZipValidation', 'valid-zip');

        return true;
    }

    noloPath.prototype.onAjaxSuccessSubmit = function(data, status, xhr){

        var options = this.options;
        var currentStep = this.getCurrentStep();
        var nextStep = this.getNextStep();
        var errorCount, passCurrent;
        var isOnLastStep = this.isOnLastStep();
        var process = this;

        // set the skey hidden field to store the session id
        var skey = this.setSkey(data.skey);

        // the 'data.status' property can return 2 possible values
        // + 'OK': all required form fields are validated and and will return a successful submission to the api.
        // + 'NOT OK': not all required form fields are validated, or an error has occured.
        // -----


        if(data.status === 'OK'){
            // the skey is not typically sent back after a successful POST to LEADSAPI
            // add it back for nanigans integration on the confirmation page
            data.skey = skey;
            data.first_name = data.user.first_name;
           // data.email = data.user.mail;

            // trigger 'semFormSubmission' custom event: the Leads submission is succeed.
            // console.log(JSON.stringify(data));
            $('#nolopath').data()['requestId'] = data.request_id;
            $('#nolopath').data()['lead_type'] = data.lead_type;
            this.triggerEvent('semLeadSubmission', 'submit');

            // all required form fields are validated and and will return a successful submission to the api.
            // run confirmation step functions
            this.loadConfirmationStep(data, this.questionOnTracks);
        } else {
            // LEADSAPI maybe offline
            if(!data.status || !data.status_codes){
                // stop further processing to correct the error encountered
                return this.onErrorLeadsApiOffline(data);
            }

            // status codes cannot be empty if 'data.status' is 'NOT OK'
            if(data.status_codes.length === 0) {
                // stop further processing to correct the error encountered
                return this.onErrorStatusCodesEmpty(data);
            }

            // specific errors
            // stop further processing to correct the error encountered
            if(data.status_codes){
                // the practice_area_id is not valid for this domain
                // @note:
                // + you should not be getting this normally, and is indicative that there is a wrong configuration somewhere
                if(data.status_codes.practice_area_id){
                    return this.onErrorPracticeAreaConfig(data);
                }

                // in cases where the submission request was already completed before,
                // the api can return an invalid skey error
                if(data.status_codes.skey){
                    return this.onErrorSkey(data);
                }

                // the api can flag a specific user's IP as blacklisted
                if(data.status_codes.userIP){
                    return this.onErrorBlacklist(data);
                }

                // ssdi-api4, spanish: user opted out via TCPA 'click here' link (sms_optin_status=0 auto-submit)
                // api returns status:"NOT OK" with status_codes:{sms_optin_status: 474}
                // treat as successful confirmation with sms_optout_status flag set for mustache template
                var islTotalLawyerSemSsdi4Path = $("body.nolopath-domain-leads-totallawyers").length == 1 && $("body").attr('data-type') === 'sem' && ($("body").attr('data-path') === 'ssdi-api4' || $("body").attr('data-path') === 'ssdi-api5' || $("body").attr('data-path') === 'spanish');

                if( islTotalLawyerSemSsdi4Path && data.status_codes.sms_optin_status === 474 ){
                    data.sms_optout_status = true;
                    return this.loadConfirmationStep(data, this.questionOnTracks);
                }

                // the api can flag a specific user's name, email and/or phone as previously submitted
                if(
                    data.status_codes.first_name === 102 ||
                    data.status_codes.last_name === 102 ||
                    data.status_codes.mail === 102 ||
                    data.status_codes.phone === 102
                ){
                    return this.onErrorDuplicateLeads(data);
                }

            }

            errorCount  = this.validateServerAnswers(data);
            passCurrent = (errorCount.steps[currentStep] === 0);

            // required form fields are either not entered or have invalid formatting.
            if(errorCount.steps.extra.length > 0){
                // somehow, the detected questions do not match the configured questions from the server
                data.errorCount = errorCount;
                this.onErrorDetectedQuestions(data);
            } else if(isOnLastStep && errorCount.total > 0 && errorCount.total !== errorCount.steps[currentStep]) {
                // we are on the last step and somehow we have not answered all the questions...
                data.errorCount = errorCount;
                data.isOnLastStep = isOnLastStep;
                this.onErrorDetectedQuestions(data);
            } else if(passCurrent){
                // if no errors in the current step, advance to the next step
                this.loadNextStep(nextStep, data);
            } else {
                // trigger 'semError' custom event
                this.triggerEvent('semError', 'error-server-validation-failed');
            }

            // enable the submit button
            this.toggleSubmitButton('enable');
        }        

        return true;
    }

    noloPath.prototype.onAjaxErrorSubmit = function(xhr, status, error, $field, url){
        var debug = this.getOptions('debug');
        var errorMsg;
        var data = {
            'xhr': xhr,
            'status': status,
            'error': error,
            'url': url
        };

        if(error === 'Forbidden'){
            this.setStatusError('leadsApi403', 'error', xhr.responseJSON.message, data);
            this.setInlineError($field, 'Cannot validate this field because of a network error');

            return false;
        }

        // catch based on xhr.readyState
        // ----------
        // xhr.readyState valid values:
        // + 0: request not initialized
        // + 1: server connection established
        // + 2: request received
        // + 3: processing request
        // + 4: request finished and response is ready
        // ----------
        // @note:
        // + it is possible that this will be triggered when it is about to make a request,
        //   but interupted by leaving the page prematurely
        // + just catch it, but do not file an obvious error for the user
        switch(xhr.readyState){
            case 0:
            // this command is intentionally toggled off for production
            if(debug){
                errorMsg = 'Unable to process your request due to a server error (xhr). Visit <a target="_blank" href="' + data.url + '" title="' + data.url + '">this link</a> and accept certificate.';
                this.setStatusError('ajaxReadyState0', 'error', errorMsg, data);
                console.error('Unable to initialize the request to: ' + data.url);
            }
            return false;
            break;

            case 4:
                switch(xhr.status){
                    case 500:
                    errorMsg = 'Unable to process your request due to a server error (' + xhr.status + ')';
                    this.setStatusError('leadsApi500', 'error', errorMsg, data);
                    this.setInlineError($field, 'Cannot validate this field because of a network error');
                    if(debug){
                        console.error(xhr.statusText + ': ' + data.url);
                    }
                    break;
                }
            return false;
            break;
        }


        // in case there is another error type, use this to generate a generic one
        errorMsg = 'Unable to process your request due to a server error';
        this.setStatusError('genericOnAjaxErrorSubmit', 'error', errorMsg, data);

        return false;
    }

    noloPath.prototype.onErrorLeadsApiOffline = function(data){
        var errorMsg = this.getErrorMessage('offline', 'default');

        this.setStatusError('leadsApiOffline', 'error', errorMsg, data);

        // trigger 'semError' custom event
        this.triggerEvent('semError', 'error-leads-api-offline');

        return false;
    }

    noloPath.prototype.onErrorStatusCodesEmpty = function(data){
        var errorMsg = this.getErrorMessage('offline', 'status_codes');

        this.setStatusError('statusCodesEmpty', 'error', errorMsg, data);

        // trigger 'semError' custom event
        this.triggerEvent('semError', 'error-status-codes-empty');

        return false;
    }

    noloPath.prototype.onErrorDetectedQuestions = function(data){
        var errorMsg = 'The server was expecting more questions to be answered. The following question IDs need to be investigated: ';
        var missingQuestions = data.errorCount.steps.extra;
        var leadsErrors = data.errors;
        var isOnLastStep = data.isOnLastStep || false;
        var missing = [];

        if(isOnLastStep){
            for (var q in leadsErrors){
                if(q==='answers'){
                    for (var a in leadsErrors[q]){
                        missing.push('questions['+a+']');
                    }
                } else {
                    missing.push(q);
                }
            }
        } else {
            for (var q in missingQuestions){
                missing.push(missingQuestions[q]);
            }
        }

        errorMsg = errorMsg + missing.join(', ');

        this.setStatusError('leadsApiPracticeAreaConfig', 'error', errorMsg, data);

        // trigger 'semError' custom event
        this.triggerEvent('semError', 'error-detected-questions');

        return false;
    }

    noloPath.prototype.onErrorPracticeAreaConfig = function(data){
        var errorMsg = this.getErrorMessage(data.status_codes.practice_area_id, 'practice_area_id');

        this.setStatusError('leadsApiPracticeAreaConfig', 'error', errorMsg, data);

        // trigger 'semError' custom event
        this.triggerEvent('semError', 'error-practice-area');

        return false;
    }

    noloPath.prototype.onErrorSkey = function(data){
        var errorMsg = this.getErrorMessage(data.status_codes.skey, 'skey');

        this.setStatusError('leadsApiSkeyInvalid', 'error', errorMsg, data);

        // trigger 'semError' custom event
        this.triggerEvent('semError', 'error-skey');

        return false;
    }

    noloPath.prototype.onErrorBlacklist = function(data){
        var code = data.status_codes.userIP || 101;
        var errorMsg = this.getErrorMessage(code, 'userip');

        // the ipError is triggered when the user is submitting from a blocked IP
        // and will typically be detected upon the user attempting to go to step2
        this.setStatusError('leadsApiSpamIpError', 'error', errorMsg, data);

        // enable the submit button to allow the user to make any corrections as a result of the errors
        this.toggleSubmitButton('enable');

        // trigger 'semError' custom event
        this.triggerEvent('semError', 'error-spam');

        return false;
    }

    noloPath.prototype.onErrorDuplicateLeads = function(data){
        var errorMsg = this.getErrorMessage(102, 'default');
        var $elm = this.$element;
        var $form = $elm.find('form');
        // the ipError is triggered when the user is submitting from a blocked IP
        // and will typically be detected upon the user attempting to go to step2
        this.setStatusError('leadsApiDupeError', 'error', errorMsg, data);
        if(data.status_codes.mail == 102){
            var $email_field = $form.find('input[type="email"]');
            this.setInlineError($email_field, 'Please check your answer and resubmit.');
        }

        // EHCS-3257 - Prod: Legacy path phone field is not highlighted in red and does not display error message on duplicate phone submission
        if(data.status_codes.phone == 102){
            var $phone_field = $form.find('input[type="tel"]');

            // EHCS-4793: input[type="tel"] is too generic
            if ($phone_field.length > 1 && (document.querySelector('body').getAttribute('data-path') == 'ssdi-api5')) {
                $phone_field = $form.find('input#nolopath-qphone[type="tel"]');
            }

            this.setInlineError($phone_field, 'Please check your answer and resubmit.');
        }

        // enable the submit button to allow the user to make any corrections as a result of the errors
        this.toggleSubmitButton('enable');

        // trigger 'semError' custom event
        this.triggerEvent('semError', 'error-dupe');

        return false;
    }

    noloPath.prototype.loadCurrentStep = function(){
        var $elm = this.$element;
        var $questions = $elm.find('.form-step-questions');
        var $practiceAreaSelect = $elm.find('.form-practice-area-select');
        var step = this.getCurrentStep();
        var prev = this.getPreviousStep();
        var next = this.getNextStep();
        var $current  = $questions.children('.form-'+step);
        var $previous = prev ? $questions.children('.form-'+prev) : [];
        var $next = next ? $questions.children('.form-'+next) : [];
        var isOnFirstStep = this.isOnFirstStep();
        var isOnLastStep = this.isOnLastStep();
        var isOnBeforeLastStep = this.isOnBeforeLastStep();
        var firstQuestion = $current.find('.form-item').eq(0);
        var trackPageUrl = true;
        var current_page_url = window.location.href;
        var pathId = $elm.attr('data-path-id');
        // EHCS-2353 : Mobile Criminal Defense SEM Path -Auto deselects the answer for routing question on browser back yet able to go next       
        if(current_page_url != localStorage.getItem('current_page_url')) {
            localStorage.setItem('current_page_url', current_page_url);
            trackPageUrl = true;
        } else {
            trackPageUrl = false;
            if(typeof isOnFirstStep == 'undefined' && localStorage.getItem('custom_routing_pid') != null) {
                localStorage.removeItem('custom_routing_pid');
            }
        }

        // display the current step
        $current.show().addClass('active').removeClass('previous').removeClass('next');

        // set the 'active' class to the first '.form-item' in this step
        firstQuestion.addClass('active');
        if (!firstQuestion.hasClass('required')) {
            this.enableSubsequentOptionalQuestions(firstQuestion);
        }

        if($previous.length > 0){
            // hide the previous step
            $previous.hide().removeClass('active').addClass('previous');

            // hide the practice area select field
            if($practiceAreaSelect.length > 0 && $practiceAreaSelect.is(':visible')){
                $practiceAreaSelect.hide();
            }

            // remove the element class identifying the 'previous' step
            $elm.removeClass('nolopath-'+prev);
        } else {
            // EHCS-2353 : Mobile Criminal Defense SEM Path -Auto deselects the answer for routing question on browser back yet able to go next
            // EHCS-2462: deselects answer for pi-api9
            if( $practiceAreaSelect.length > 0 && $practiceAreaSelect.is(':visible') ) {
                var custom_routing_pid = localStorage.getItem('custom_routing_pid');
                if($('body').hasClass('media-range-mobile') && isOnFirstStep == true && trackPageUrl == false) {
                    var selected_pid = $practiceAreaSelect.find(":selected").val();
                    localStorage.setItem('custom_routing_pid', selected_pid);
                // EHCS-2462: deselects answer for pi-api9 and pi-api5 (due to duplicate)
                }else if(typeof isOnFirstStep == 'undefined' && trackPageUrl == true && custom_routing_pid != null && pathId != 'pi-api9' && pathId != 'pi-api5pp') {
                    custom_routing_pid = localStorage.getItem('custom_routing_pid');
                    $("#nolopath-practice-area-select").val(custom_routing_pid).change();
                    $('.form-practice-area-select').find('button[data-update-field-name="practice_area_select"][data-update-field-value="'+ custom_routing_pid +'"]').not('[custom_routing="true"]').addClass('active');
                }
            }
        }

        if($next.length > 0){
            // hide the next step, for cases we are navigating back using the backtrack button
            $next.hide().removeClass('active').addClass('next');

            // remove the element class identifying the 'next' step
            $elm.removeClass('nolopath-'+next);
        }

        // set the current step class
        $elm.addClass('nolopath-'+step);


        if(isOnFirstStep){
            $elm.addClass('nolopath-step-first');
            $('body').addClass('form-path-step-1');
        } else {
            $elm.removeClass('nolopath-step-first');
            $('body').removeClass('form-path-'+prev).addClass('form-path-'+step);
        }

        if(isOnLastStep){
            $elm.addClass('nolopath-step-last');
            if (this.getPathSubscriptionList() == 'webmd') {
                this.getWebmdProviderInfo();
            }
        } else {
            $elm.removeClass('nolopath-step-last');
        }

        if(isOnBeforeLastStep){
            $elm.addClass('nolopath-step-before-last');
        } else {
            $elm.removeClass('nolopath-step-before-last');
        }

        // set the active crumb based on the current step
        this.setBreadcrumb();

        // set the action button labels
        this.setActionButtons();

        // additional tasks for the last step
        if (isOnLastStep){
            if (this.options.is_masstort) {
                fbq('trackCustom', 'Masstort Last Step');
            }
            this.loadLastStep();
        }

        //Pre-fill already answered questions
        var stepQuestions = $elm.data('questionData').questions;
        for (var i = 0; i < stepQuestions.length; i++) {
            if (stepQuestions[i].value !== null) {
                var $stepQuestion = $('#' + stepQuestions[i].id);
                $stepQuestion.addClass('answered').removeClass('not-answered');
                $stepQuestion.find('select').trigger('change');
                $stepQuestion.find('textarea').attr('readonly', false);
                $stepQuestion.removeClass('visited');
            }
        };

        //Guarantees that the first question is visible if it has an answer
        firstQuestion.addClass('visited');

        // EHCS-5560: ssdi-api4 Premier lead dynamic case_description behavior
        this.initSsdiApi4PremierLeadBehavior();

        this.initCrimdApp1();

        // identify specific steps for event triggers
        this.loadCurrentStepEvents();
    }

    noloPath.prototype.loadCurrentStepEvents = function(){
        var submitBehavior = this.options.submitBehavior;

        switch(submitBehavior){
            case noloPath.CONSTANTS.submitBehaviorStatic:
                this.loadCurrentStepEventsViaStatic();
            break;

            case noloPath.CONSTANTS.submitBehaviorAjax:
            case noloPath.CONSTANTS.submitBehaviorHybrid:
                this.loadCurrentStepEventsViaAjax();
            break;

            default:
                return false;
            break;
        }

        return false;
    }

    noloPath.prototype.loadCurrentStepEventsViaStatic = function(){
        var isOnFirstStep = this.isOnFirstStep();
        var step = this.getCurrentStep();
        var special = this.getSpecialStep();
        var isInitDone = this.isInitDone();
        var isFormLoaded = this.isFormLoaded();

        // trigger 'semStepLoad' custom event
        // -----
        // @note
        // + identifies that the current path step has finished loading
        // + required to trigger analytics that depend on a step being loaded, like Google Analytics
        // + this event can happen, even if a form is not yet loaded
        // + for analytics that require a form loaded, look into the 'semFormLoad' event
        if(!isInitDone){
            // event identifying the first step
            if (isOnFirstStep){
                this.triggerEvent('semStepLoad', 'init');
            }

            // event identifying the current step
            this.triggerEvent('semStepLoad', step);

            // event identifying the current special step
            if (typeof special !== 'undefined'){
                this.triggerEvent('semStepLoad', special);
            }
        }

        // trigger 'semFormLoad' custom event
        // -----
        // @note
        // + identifies that the current path form has finished loading
        // + can trigger multiple times, if the practice area select dropdown is present, and used
        // + required to trigger analytics that depend on a form being loaded, like Nanigans
        //   + in the case of multiple event triggers, 'noloPathAnalytics' has a built-in functionality
        //     to prevent triggering the same event handler more than once
        if(isFormLoaded){
            // event identifying the first step
            if (isOnFirstStep){
                this.triggerEvent('semFormLoad', 'init');
                this.triggerGa4Event('pageLoad', 'init');
            }

            // event identifying the current step
            this.triggerEvent('semFormLoad', step);

            // event identifying the current special step
            if (typeof special !== 'undefined'){
                this.triggerEvent('semFormLoad', special);
            }
        }
    }

    noloPath.prototype.loadCurrentStepEventsViaAjax = function(){
        var isOnFirstStep = this.isOnFirstStep();
        var step = this.getCurrentStep();
        var special = this.getSpecialStep();
        var isInitDone = this.isInitDone();
        var isFormLoaded = this.isFormLoaded();
        var isOnLastStep = this.isOnLastStep();

        // trigger first step events
        // -----
        // @note:
        // + 'semStepLoad, step-1' could be triggered multiple times when the practice area select dropdown is present
        // + prevent this by checking if the 'init()' function has completed
        // + isOnFirstStep can be 'undefined' when there is no form initially loaded becuase of the practice area select dropdown
        if ((typeof isOnFirstStep === 'undefined') || (isOnFirstStep && !isInitDone)){
            this.triggerEvent('semStepLoad', 'init');
            this.triggerEvent('semStepLoad', step);
            this.triggerEvent('semStepLoad', special);
            this.triggerGa4Event('pageLoad', 'init');
        }

        // trigger non-first-step events
        if(!isOnFirstStep && isInitDone){
            // trigger 'semStepLoad' custom event, identifying the current step
            this.triggerEvent('semStepLoad', step);

            // trigger 'semStepLoad' custom event, identifying the current special step
            if (typeof special !== 'undefined'){
                this.triggerEvent('semStepLoad', special);
            }
        }
        var pathId = $('#nolopath').data('pathId');

        // trigger 'semFormLoad' custom event
        // -----
        // @note
        // + identifies that the current path form has finished loading
        // + can trigger multiple times, if the practice area select dropdown is present, and used
        // + required to trigger analytics that depend on a form being loaded, like Nanigans
        //   + in the case of multiple event triggers, 'noloPathAnalytics' has a built-in functionality
        //     to prevent triggering the same event handler more than once
        if(isFormLoaded){
            // event identifying the first step
            if (isOnFirstStep){
                this.triggerEvent('semFormLoad', 'init');
                this.triggerGa4Event('pageLoad', 'init');
            } else {
                // list of hybrid-behavior lead paths embedded in NCMS that need to scroll to top on next step
                var scrollTopPaths = ['form1a', 'vaping-form1a'];
                if (scrollTopPaths.indexOf($('#nolopath').data('pathId')) > -1) {
                    $('html').animate({scrollTop: $('#nolopath').offset().top}, 500);
                } else if ($('#nolopath').data('pathId') === 'vaping-form2a') {
                    $('html').animate({scrollTop: $('#page-container').offset().top}, 500);
                }
            }

            // event identifying the current step
            this.triggerEvent('semFormLoad', step);

            // event identifying the current special step
            if (typeof special !== 'undefined'){
                this.triggerEvent('semFormLoad', special);
            }
        }
    }

    noloPath.prototype.initCrimdApp1 = function() {
        var pathId = this.pathData.pathId;
        var currentStep = this.getCurrentStep();

        // Only applies to cd-api1, step-1 (zip + case_description step)
        if ((pathId !== 'cd-api1' || currentStep !== 'step-1') && (pathId !== 'cd-api1pp' || currentStep !== 'step-1')) {
            return;
        }

        var $isCdApi1 = $('.page-nolosem-cd-api1');
        var $isCdApi1pp = $('.page-nolosem-cd-api1pp');
        if ( $isCdApi1.length == 1) {
            $isCdApi1
                .find('label[for="nolopath-practice-area-select"]')
                .html('Do you have a pending charge? <span class="hint_subtext">Your answer helps us connect you with the right attorney <br/> — not a generic referral.</span>');
        } else if ($isCdApi1pp.length == 1) {
            $isCdApi1pp
                .find('label[for="nolopath-practice-area-select"]')
                .html('Do you have a pending charge? <span class="hint_subtext">Your answer helps us connect you with the right attorney <br/> — not a generic referral.</span>');
        }
    }
    
    // EHCS-5620: the Spanish lander (path 'spanish') is a clone of ssdi-api4 and
    // shares all of its behavior (Premier logic, interstitial, validation tweaks).
    noloPath.prototype.isSsdiApi4Family = function(pathId) {
        pathId = pathId || this.pathData.pathId;
        return pathId === 'ssdi-api4' || pathId === 'spanish';
    }

    // EHCS-5560: ssdi-api4 Premier lead — show/hide case_description on step-4 load based on whether the Premier lead conditions are met
    noloPath.prototype.initSsdiApi4PremierLeadBehavior = function() {
        var pathId = this.pathData.pathId;
        var currentStep = this.getCurrentStep();

        // Only applies to the ssdi-api4 family, step-4 (zip + case_description step)
        if (!this.isSsdiApi4Family(pathId) || currentStep !== 'step-4') {
            return;
        }

        var isPremierLeadSet = this.isSsdiApi4PremierLead();
        if(isPremierLeadSet) {
            var $caseDescriptionContainer = $('#form-item-case_description');
            var $caseDescription = $('#nolopath-qcase_description');
            if ($caseDescriptionContainer.length > 0 && $caseDescription.length > 0) {
                $caseDescriptionContainer.addClass('answered').removeClass('not-answered');
                $caseDescriptionContainer.hide();
                // EHCS-5560: ssdi-api4 Premier lead dynamic case_description set hard coded value "This is a Premier Lead" to the case description field for Premier leads
                $caseDescription.val('This is a Premier Lead');
            }
        } else if (pathId == 'spanish' && !isPremierLeadSet) {
            var $caseDescriptionContainer = $('#form-item-case_description');
            var $caseDescription = $('#nolopath-qcase_description');
            if ($caseDescriptionContainer.length > 0 && $caseDescription.length > 0) {
                $caseDescriptionContainer.addClass('answered').removeClass('not-answered');
                $caseDescriptionContainer.hide();
                $caseDescription.val('This is a not a Premier Lead');
            }
        }
    }

    // EHCS-5560: Evaluate whether the current ssdi-api4 answers qualify as a Premier lead.
    // Premier SSDI Lead condition:
    //   age >= 50 && age <= 63
    //   AND q1067, q1068, q1069 answered "1: Yes" (select value "1", answer id 1)
    //   AND q1070, q1071 answered "2: No"  (select value "2", answer id 2)

    noloPath.prototype.isSsdiApi4PremierAge = function() {
        var ageSelect = document.querySelector('#nolopath-q1066');
        if (!ageSelect || ageSelect.selectedIndex < 0) {
            return false;
        }

        // Read the displayed age from the option text (values are age-1 due to API offset)
        var age = parseInt(ageSelect.options[ageSelect.selectedIndex].text);
        if (isNaN(age)) return false;
        return age >= 50 && age <= 63;
    }

    noloPath.prototype.isSsdiApi4PremierLead = function() {
        var ageSelect = document.querySelector('#nolopath-q1066');
        if (!ageSelect || ageSelect.selectedIndex < 0) {
            return false;
        }

        // Read the displayed age from the option text (values are age-1 due to API offset)
        var age = parseInt(ageSelect.options[ageSelect.selectedIndex].text);
        if (isNaN(age) || age < 50 || age > 63) {
            return false;
        }

        // select option values are formatted "<answer id>: <label>" (id is 1-based per
        // cNoloLeadsDataQuestionsConfig's select/select_tel increment); compare on the id
        // rather than the label text so this also works on /sem/spanish, where the label
        // is "Sí"/"No" instead of "Yes"/"No".
        function answerId(qid) {
            var val = $('#nolopath-q' + qid).val() || '';
            return val.split(':')[0];
        }

        // q1067 "expect to be out of work ≥1yr?" Yes=1, q1068 "treated by doctor?" Yes=1,
        // q1069 "full-time job past 5yrs?" Yes=1
        var q1067Val = $('#nolopath-q1067').val();
        var q1068Val = $('#nolopath-q1068').val();
        var q1069Val = $('#nolopath-q1069').val();
        // q1070 "already receive SS benefits?" No=2, q1071 "hired advocate/attorney?" No=2
        var q1070Val = $('#nolopath-q1070').val();
        var q1071Val = $('#nolopath-q1071').val();

        if ($("body").attr('data-path') === 'spanish') {
            return (answerId(1067) == 1 && answerId(1068) == 1 && answerId(1069) == 1 &&
                answerId(1070) == 2 && answerId(1071) == 2);
        } else {
            return (q1067Val === '1: Yes' && q1068Val === '1: Yes' && q1069Val === '1: Yes');
        }
    }

    // loadNextStep function
    // perform the following actions when on loading the next step in the form submission process
    noloPath.prototype.loadNextStep = function(step, data){
        var options = this.options;

        // EHCS-5621: ssdi-api4 — on the Step 1 -> Step 2 transition, show the
        // interstitial "Call vs. Continue" screen instead of advancing to Q3.
        // Hooked here (the dispatcher common to static/ajax/hybrid behaviors) so it
        // fires regardless of submitBehavior. Returns true and defers navigation
        // when the interstitial is shown; "Continue with form" re-enters loadNextStep.
        if (this.maybeShowSsdiApi4Interstitial(step, data)) {
            return false;
        }

        var submitBehavior = options.submitBehavior;
        var special = this.getSpecialStep();
        var params = {'step': step, 'data': data, 'special': special};

        // update nanigans params
        this.setNanigansParams(params);

        switch(submitBehavior){
            case noloPath.CONSTANTS.submitBehaviorStatic:
                this.loadNextStepViaStatic(step, data, special);
            break;

            case noloPath.CONSTANTS.submitBehaviorAjax:
            case noloPath.CONSTANTS.submitBehaviorHybrid:
                this.loadNextStepViaAjax(step, data, special);
                return false;
            break;

            default:
                return false;
            break;
        }

        return false;
    }

    noloPath.prototype.loadNextStepViaStatic = function(step, data, special){
        var $elm = this.$element;
        var $form = $elm.find('form');
        var action = this.getNextStepUrl(step);
        var queryString = location.search.substring(1);
        if (queryString) { queryString = '?'+queryString; }

        // set a new form action url to POST to the next step
        $form.attr('action', action+queryString).submit();

        return false;
    }

    noloPath.prototype.loadNextStepViaAjax = function(step, data, special){
        var $elm = this.$element;
        var stepToDisplay = step;
        var stepToHide = step;

        // set the new 'current step'
        this.setCurrentStep(step);

        // refresh steps data
        this.setStepsData();

        // load the 'new' current step
        this.loadCurrentStep();

        return false;
    }

    // EHCS-5621: ssdi-api4 interstitial "Call vs. Continue" step ------------------

    // Push a named event into the GTM dataLayer (pattern per confirmsuccess.php).
    noloPath.prototype.pushSsdiApi4InterstitialEvent = function(eventName){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': eventName });
    }

    // Intercepts the ssdi-api4 Step 1 -> Step 2 forward transition to display the
    // interstitial. Returns true when the interstitial was shown (caller stops
    // advancing); the deferred navigation resumes on "Continue with form".
    noloPath.prototype.maybeShowSsdiApi4Interstitial = function(step, data){
        if (!this.isSsdiApi4Family()) { return false; }
        if (this._ssdiInterstitialShown) { return false; }
        if (this.getCurrentStep() !== 'step-1' || step !== 'step-2') { return false; }

        var $elm = this.$element;
        var $interstitial = $elm.find('.form-interstitial');
        if ($interstitial.length === 0) { return false; }

        // stash the pending step so "Continue with form" can resume navigation
        this._ssdiInterstitialPending = { step: step, data: data };
        this._ssdiInterstitialShown = true;

        // swap the form for the interstitial screen; flag the body so CSS can
        // react (e.g. hide the sidebar) only while the interstitial is showing
        $elm.find('.form-container').hide();
        $interstitial.show();
        $('body').addClass('ssdi-interstitial-active');

        this.pushSsdiApi4InterstitialEvent('view_interstitial_step');

        return true;
    }

    // Binds the interstitial button handlers (ssdi-api4 only). Called once from init().
    noloPath.prototype.bindSsdiApi4Interstitial = function(){
        if (!this.isSsdiApi4Family()) { return; }

        var self = this;
        var $elm = this.$element;

        // "Continue with form" — resume the deferred Step 1 -> Step 2 navigation.
        // Re-enters loadNextStep; the _ssdiInterstitialShown flag lets it pass
        // through and dispatch normally (static full-page POST or ajax).
        $elm.on('click', '.form-interstitial [data-interstitial-action="continue"]', function(e){
            e.preventDefault();
            self.pushSsdiApi4InterstitialEvent('continue_with_form');

            var pending = self._ssdiInterstitialPending || { step: 'step-2', data: null };
            self._ssdiInterstitialPending = null;

            // $elm.find('.form-interstitial').hide();
            // $elm.find('.form-container').show();
            $('body').removeClass('ssdi-interstitial-active');

            self.loadNextStep(pending.step, pending.data);
        });

        // "Call ..." — fire the analytics event; the tel: href performs the call
        $elm.on('click', '.form-interstitial [data-interstitial-action="call"]', function(){
            self.pushSsdiApi4InterstitialEvent('interstitial_phone_call');
        });
    }

    noloPath.prototype.loadLastStep = function(){
        var $elm = this.$element;

        // display the 'TCPA' message
        $elm.find('.form-tcpa-message').show();

        // EHCS-2609: display TCPA agreement for SSDI
        // EHCS-3103: display TCPA for all AOP
        // if (this.pathData.practiceAreaId == '169071') {
            $elm.find('.tcpa-agreement').show();
            $elm.find('.terms-agreement').hide();
            $elm.find('.terms-agreement').remove();
            this.setHiddenField('sms_optin_status', '1');
            //this.setHiddenField('leadid_tcpa_disclosure_1', '', false, 'leadid_tcpa_disclosure_1');
            //this.setHiddenField('leadid_tcpa_disclosure_2', '', false, 'leadid_tcpa_disclosure_2');
            $elm.find('.tcpa-agreement').attr('data-tcpa','leadid_tcpa_disclosure_1');
            $elm.find('.terms-agreement-2').attr('data-tcpa','leadid_tcpa_disclosure_2');

            this.setHiddenField('tcpa_consent_verbiage', '');

            $elm.find('.tcpa-opt-out').click(function() {
                // tcpa flag -> 0
                document.querySelector(".form-hidden-questions input[name='sms_optin_status']").value = 0;
                document.querySelector(".form-actions button[type='submit']").click();
            });
        // }

        // display providers if this path is configured to do so
        this.getProvidersData();

        // set summary block
        this.setFormSummary();
    }

    noloPath.prototype.loadConfirmationStep = function(data, questionOnTracks){
        var $elm = this.getElement();
        var $form = this.getElement('form');
        var options = this.getOptions();
        var map = this.getQuestionData('map');
        var confirmModel = new noloPathConfirm(data, options, map, questionOnTracks);
        var submitBehavior = this.getOptions('submitBehavior');
        var prevStep = this.getCurrentStep();
        var nextStep = this.getNextStep();
        var url, method;

        // EHCS-2353 : Mobile Criminal Defense SEM Path -Auto deselects the answer for routing question on browser back yet able to go next
        if(localStorage.getItem('current_page_url') != null) {
            localStorage.removeItem('current_page_url');
            if(data.is_unrouted == true || (typeof data.unrouted == 'undefined' && typeof data.is_unrouted == 'undefined' && typeof data.confirm_route == 'undefined')) {
                localStorage.removeItem('custom_routing_pid');
            }
        }

        // set analytics data
        confirmModel.analytics = this.getEventParameters('semConversion', 'goal', data);
        // EHCS-2263: fix for routing question -> unrouted(after aop switching)
        if(data.routing_unrouted) {
            confirmModel.confirm_route.route='confirm/unrouted'
            nextStep='step-undefined';
        }

        // EHCS-5697: dv-api3-v2 stays on one URL (/sem/dv-api3-v2) through
        // steps 1-4; only the true last-step -> confirmation transition
        // redirects to /confirmsuccess as it does today. The static/hybrid
        // branch below always redirects regardless of which step is next
        // (getNextStep() only returns 'confirm' once there's truly no next
        // step — for an intermediate step it's 'step-2', 'step-3', etc.,
        // and getNextStepUrl()/this.redirect() would navigate there just
        // the same as for the real end), so this has to be intercepted
        // here rather than solved via submitBehavior alone. The leads-api
        // POST in validateUsingServer/onAjaxSuccessSubmit that got us here
        // still runs on every step exactly as before — this only changes
        // what the client does with a successful "intermediate step"
        // response: show the next step's already-rendered form content in
        // place (reusing the same primitives loadNextStepViaAjax uses for
        // backtracking) instead of navigating to a new URL.
        var isRealConfirmTransition = (nextStep === 'confirm') || !!confirmModel.confirm_route.route;
        if (['dv-api3', 'dv-api3-v2'].includes(this.pathData.pathId) && !isRealConfirmTransition) {
            this.setCurrentStep(nextStep);
            this.setStepsData();
            this.loadCurrentStep();
            return;
        }

        switch(submitBehavior){
            case noloPath.CONSTANTS.submitBehaviorStatic:
            case noloPath.CONSTANTS.submitBehaviorHybrid:
            // determine the url for the confirmation page
            if(confirmModel.confirm_route.route){
                url = this.getNextStepUrl(confirmModel.confirm_route.route);
            } else {
                url = this.getNextStepUrl(nextStep);
            }

            // determine the form submission method
            method = $form.attr('method');

            // compile the confirmation data and redirect results to the confirmation page
            this.redirect(url, confirmModel, method);
            break;

            //------------------------------------------------------------------
            //   <<<<<< submitBehaviorAjax >>>>>>
            //------------------------------------------------------------------
            case noloPath.CONSTANTS.submitBehaviorAjax:
            if(location.pathname.includes('min-path3') && confirmModel.confirm_route.route == 'confirm/disqualified') {
                //hide the DIY even leads type is network, for min-path3
                $("body").addClass('disqualified-route');
            }
            // trigger the 'semConversion' custom event
            this.triggerEvent('semConversion', 'goal', data);
            this.triggerEvent('semLeadSubmission', 'submit');

            // replace the entire contents of this element with the confirmation step
            // -----
            // @note:
            // + this operation DESTROYS all data and event handlers
            //   associated with the contents of the parent element
            this.render(this.mst_confirmation, $elm, confirmModel);
            this.ajaxConversion(data, confirmModel);

            // add an element class identifying that the 'confirmation' step is loaded
            $elm.removeClass('nolopath-'+prevStep).removeClass('nolopath-step-last').addClass('nolopath-'+nextStep);
            $('body').removeClass('form-path-'+prevStep).addClass('form-path-'+nextStep);

            // trigger the 'noloPathRelatedProducts' plugin, if the container is available
            // -----
            // @note:
            // + the target container will only be present if the lead is 'unsold'
            // + the target container, if available, is only present after the render.
            if(confirmModel.show_products){
                this.loadRelatedProducts();
            }else if(location.href.includes("min-path3") && this.getPathPracticeAreaId() == 4){
                window.onlyNDR = true;
                this.loadRelatedProducts();
            }

            // trigger the 'noloPathSms' plugin, if the container is available
            // -----
            // @note:
            // + the target container will only be present if user phone is sms-capable
            // + the target container, if available, is only present after the render.
            if(confirmModel.show_sms){
                this.loadSmsNotice();
            }
            break;

            default:
            break;
        }
    }

    noloPath.prototype.loadRelatedProducts = function() {
        var $elm = this.getElement();
        var retry = noloPath.CONSTANTS.ajaxCallRetry;
        var interval = noloPath.CONSTANTS.ajaxCallRetryInterval;
        var debug = this.getOptions('debug');
        var minPath3BkNdr = location.href.includes("min-path3") && this.getPathPracticeAreaId() == 4;
        var wait, timer;

        // waiting function
        // -----
        // @note:
        // + there is a slight lag between the 'render' and 'loadRelatedProducts' functions
        // + it was possible for 'loadRelatedProducts' to trigger before 'render' fully executes
        // + this waiting function allows us to do a reasonable amount of retries
        //   to trigger the 'noloPathRelatedProducts' plugin
        var waitingForRelatedProducts = function(){
            var deferred = $.Deferred();
            // check every second for the element
            timer = setInterval(function() {
                var $products = minPath3BkNdr?$elm.find('[data-toggle="noloPathGiftBasket"]'):$elm.find('[data-toggle="noloPathRelatedProducts"]');
                if($products.length === 0 && retry > 0) {
                    // notify the 'deferred' object in-case we want to do a progress function call
                    deferred.notify();
                    retry--;
                } else {
                    // resolve the 'deferred' object once the element is available, or retries are expired
                    clearInterval(timer);
                    if($products.length > 0) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                }
            }, interval);

            return deferred.promise();
        }

        // an existing queued request is happening
        // wait until data('providersData') is populated
        wait = waitingForRelatedProducts();

        // when waiting, report progress
        wait.progress(function(){
            if(debug){
                console.log('looking for related products container: %o', retry);
            }
        });

        // when finished, use trigger the 'noloPathRelatedProducts' plugin
        wait.done(function(){
            var $products = minPath3BkNdr?$elm.find('[data-toggle="noloPathGiftBasket"]'):$elm.find('[data-toggle="noloPathRelatedProducts"]');

            // initialize 'noloPathRelatedProducts' plugin
            $products.noloPathRelatedProducts();
        });

        // when failed,
        // + it may be a sold lead
        // + the practice area is configured not to load related products
        wait.fail(function(){
            if(debug){
                console.log('related products container not found after ' + noloPath.CONSTANTS.ajaxCallRetry + ' tries.');
            }
        });
    }

    noloPath.prototype.loadSmsNotice = function() {
        var $elm = this.getElement();
        var retry = noloPath.CONSTANTS.ajaxCallRetry;
        var interval = noloPath.CONSTANTS.ajaxCallRetryInterval;
        var debug = this.getOptions('debug');
        var wait, timer;

        // waiting function
        // -----
        // @note:
        // + there is a slight lag between the 'render' and 'loadSmsNotice' functions
        // + it was possible for 'loadSmsNotice' to trigger before 'render' fully executes
        // + this waiting function allows us to do a reasonable amount of retries
        //   to trigger the 'noloPathSms' plugin
        var waitingForSmsNotice = function(){
            var deferred = $.Deferred();
            // check every second for the element
            timer = setInterval(function() {
                var $sms = $elm.find('[data-toggle="noloPathSms"]');
                if($sms.length === 0 && retry > 0) {
                    // notify the 'deferred' object in-case we want to do a progress function call
                    deferred.notify();
                    retry--;
                } else {
                    // resolve the 'deferred' object once the element is available, or retries are expired
                    clearInterval(timer);
                    if($sms.length > 0) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                }
            }, interval);

            return deferred.promise();
        }

        // an existing queued request is happening
        // wait until data('providersData') is populated
        wait = waitingForSmsNotice();

        // when waiting, report progress
        wait.progress(function(){
            if(debug){
                console.log('looking for sms notification container: %o', retry);
            }
        });

        // when finished, use trigger the 'noloPathSms' plugin
        wait.done(function(){
            var $sms = $elm.find('[data-toggle="noloPathSms"]');

            // initialize 'noloPathSms' plugin
            $sms.noloPathSms();
        });

        // when failed, it may be an unsold lead
        wait.fail(function(){
            if(debug){
                console.log('sms notification container not found after ' + noloPath.CONSTANTS.ajaxCallRetry + ' tries.');
            }
        });
    }

    noloPath.prototype.validateClientAnswers = function() {
        var $elm = this.$element;
        var $formGroups = $elm.find('form .form-group');
        var process = this;
        var currentStep = this.getCurrentStep();
        var totalSteps = this.getTotalSteps();
        var errorList = [];
        var data = {};

        $formGroups.each(function(){
            var self = $(this);
            var $field = self.find('.form-control');
            var $checkbox = self.find('.checkbox');
            var $radio = self.find('.radio');
            var step = self.parents('.form-step').data('formStep');
            var isVisible = self.is(':visible');
            var val, xssVal, checked, errorItem, $remote;
            var range = {'min': null, 'max': null};
            var rangeMinOnly, rangeMaxOnly, rangeMinMax;

            if(self.hasClass('required')){
                // validate for non-empty values
                if($field.length > 0){
                    val = $.trim($field.val());
                    xssVal = process.xssFilter(val);

                    if($field.hasClass('form-textarea') || $field.hasClass('form-text')){
                        // if they do not match, update the answer to the sanitized version
                        if($field.hasClass('form-textarea') && $field.attr('name') == 'case_description') {
                            var islTotalLawyerSemSsdi4Path = $("body.nolopath-domain-leads-totallawyers").length == 1 && $("body").attr('data-type') === 'sem' && ($("body").attr('data-path') === 'ssdi-api4' || $("body").attr('data-path') === 'ssdi-api5' || $("body").attr('data-path') === 'spanish');
                            if(val.length <= 0) {
                                errorItem = new noloPathInlineErrorItem($field, 'invalid', 'Description is required', step);
                            } else if (!islTotalLawyerSemSsdi4Path && val.length < 10) {
                                errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getInlineErrorMessage($field, 'invalid'), step);
                            }
                        } else {
                            if(val !== xssVal){
                                $field.val(xssVal);
                                val = xssVal;
                            }
                        }
                    }

                    if(val){
                        if ($field.prop('tagName') === 'SELECT'){
                            $remote = $field.filter('input[data-toggle="remoteUpdate"]');
                            if($remote.length > 0 && $remote.is(':visible')){
                                // we are using a textfield to map its value into the actual SELECT field
                                val = $remote.val();

                                if (self.hasClass('validate-integer')){
                                    if(!process.isInteger(val)){
                                        errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getErrorMessage('invalid', 'integer'), step);
                                    } else {
                                        range = process.getNumberRangeFromClass(self.attr('class'));
                                        if (!process.isNumberInRange(val, range)){
                                            errorItem = new noloPathInlineErrorItem($field, 'invalid', 'Age must be an integer between ' + range.min + ' and ' + range.max, step);
                                        }
                                    }
                                }
                            } else if(val === '0'){
                                errorItem = new noloPathInlineErrorItem($field, 'missing', process.getInlineErrorMessage($field, 'missing'), step);
                            }
                        }
                        if(self.hasClass('validate-zip') && !process.isZip(val)){
                            errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getInlineErrorMessage($field, 'invalid'), step);
                        }

                        if(self.hasClass('validate-email') && !process.isEmail(val)){
                            errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getInlineErrorMessage($field, 'invalid'), step);
                        }

                        if(self.hasClass('validate-phone') && !process.isPhone(val)){
                            errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getInlineErrorMessage($field, 'invalid'), step);
                        }

                        if(self.hasClass('validate-fullname')){
                            var fullNameArr = val.split(' ');
                            if (fullNameArr.length <= 1 || fullNameArr[1].length == 0) {
                                errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getInlineErrorMessage($field, 'invalid'), step);
                            }
                        }

                        if(self.hasClass('validate-date')) {
                            var date = process.parseDate(val);
                            if (!date.valueOf()) {
                                errorItem = new noloPathInlineErrorItem($field, 'invalid', 'Invalid date format. Please input your date in the YYYY-MM-DD format.' , step);
                            } else if (!process.isValidDate(date)) {
                                errorItem = new noloPathInlineErrorItem($field, 'invalid', 'The appointment date must be after the current date.' , step);
                            }
                        }

                        if(self.hasClass('validate-integer') && $field.prop('tagName') !== 'SELECT'){
                            if(!process.isInteger(val)){
                                errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getErrorMessage('invalid', 'integer'), step);
                            } else {
                                range = process.getNumberRangeFromClass(self.attr('class'));
                                if (!process.isNumberInRange(val, range)){
                                    if (range.minOnly){
                                        errorItem = new noloPathInlineErrorItem($field, 'invalid', 'This field requires a minimum integer number of ' + range.min, step);
                                    }
                                    if (range.maxOnly){
                                        errorItem = new noloPathInlineErrorItem($field, 'invalid', 'This field requires a maximum integer number of ' + range.max, step);
                                    }
                                    if (range.minMax){
                                        errorItem = new noloPathInlineErrorItem($field, 'invalid', 'This field requires a integer number between ' + range.min + ' and ' + range.max, step);
                                    }
                                }
                            }
                        }

                        if (self.hasClass('validate-number') && $field.prop('tagName') !== 'SELECT'){
                            if(!process.isNumeric(val)){
                                errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getErrorMessage('invalid', 'number'), step);
                            } else {
                                range = process.getNumberRangeFromClass(self.attr('class'));
                                if (!process.isNumberInRange(val, range)){
                                    if (range.minOnly){
                                        errorItem = new noloPathInlineErrorItem($field, 'invalid', 'This field requires a minimum number of ' + range.min, step);
                                    }
                                    if (range.maxOnly){
                                        errorItem = new noloPathInlineErrorItem($field, 'invalid', 'This field requires a maximum number of ' + range.max, step);
                                    }
                                    if (range.minMax){
                                        errorItem = new noloPathInlineErrorItem($field, 'invalid', 'This field requires a number between ' + range.min + ' and ' + range.max, step);
                                    }
                                }
                            }
                        }

                    } else {
                        if(!self.data('clientOptional')){
                            if($field.hasClass('form-textarea') && $field.attr('name') == 'case_description') {
                                if(val.length <= 0) {
                                    errorItem = new noloPathInlineErrorItem($field, 'invalid', 'Description is required', step);
                                } else if (val.length < 10) {
                                    errorItem = new noloPathInlineErrorItem($field, 'invalid', process.getInlineErrorMessage($field, 'invalid'), step);
                                }
                            } else {
                                errorItem = new noloPathInlineErrorItem($field, 'missing', process.getInlineErrorMessage($field, 'missing'), step);
                            }
                        }
                    }
                }

                if($checkbox.length > 0){
                    checked = $checkbox.find('input:checked').length;
                    if (checked === 0){
                        errorItem = new noloPathInlineErrorItem($checkbox, 'missing', process.getInlineErrorMessage($checkbox, 'missing'), step);
                    }
                }

                if($radio.length > 0){
                    checked = $radio.find('input:checked').length;
                    if (checked === 0){
                        errorItem = new noloPathInlineErrorItem($radio, 'missing', process.getInlineErrorMessage($radio, 'missing'), step);
                    }
                }

                // trigger errors
                if(errorItem){
                    // it is possible that the form field is hidden for the current workflow
                    // depending on visibility, set an appropriate error message
                    if(isVisible){
                        // visible fields will get an inline error
                        process.setInlineError(errorItem.$field, errorItem.message);
                    } else {
                        // invisible fields, within the current step, get a status message
                        // ----------
                        // DISABLING this specific error reporting for now
                        // ----------
                        // if (currentStep === step) {
                        //     process.setStatusError(errorItem.fieldId+'_status', 'error', errorItem.fieldName + ': ' + errorItem.message);
                        // }
                    }
                    errorList.push(errorItem);
                }
            }
        });

        // var urlParams = new URLSearchParams(window.location.search); og-pi5b

        // if(this.pathData.pathId == 'pi-api5' && urlParams.get('routing') == 'pi5b'  && this.getCurrentStep() == 'step-1'){
        //     if ($('#nolopath-practice-area-select').val() == '0'){
        //         var errorItem = new noloPathInlineErrorItem($('#nolopath-practice-area-select'), 'missing', process.getInlineErrorMessage($('#nolopath-practice-area-select'), 'missing'), 'step-1');
        //         process.setInlineError(errorItem.$field, errorItem.message);
        //         errorList.push(errorItem);
        //     }
        //     errorList.some(function(item){
        //         if(item['fieldName'] == 'zip'){
        //             process.setInlineError($('#zipInput'), item.message);
        //             return true;
        //         }
        //         return false;
        //     });
            
        // }

        // if(this.pathData.pathId == 'pi-api5pp' && urlParams.get('routing') == 'pi5b'  && this.getCurrentStep() == 'step-1'){
        //     if ($('#nolopath-practice-area-select').val() == '0'){
        //         var errorItem = new noloPathInlineErrorItem($('#nolopath-practice-area-select'), 'missing', process.getInlineErrorMessage($('#nolopath-practice-area-select'), 'missing'), 'step-1');
        //         process.setInlineError(errorItem.$field, errorItem.message);
        //         errorList.push(errorItem);
        //     }
        // }

        // set total client errors
        data = new noloPathInlineErrorTotals(errorList, totalSteps);

        // if there are inline errors show the submit error
        if ($('.inline-error').length > 0 || $('.zip-error').length > 0) {
            this.setSubmitButtonError();
        }

        // save this for future reference
        this.setErrorData('client', data);

        return data;
    }

    noloPath.prototype.validateServerAnswers = function(postResponse){
        var $elm = this.$element;
        var $formGroups = $elm.find('form .form-group');
        var process = this;
        var currentStep = this.getCurrentStep();
        var totalSteps = this.getTotalSteps();
        var errorList = [];
        var data = {};
        var errors = noloPath.CONSTANTS.inlineErrorMessages[this.options.lang];

        // standardize the error data to easily match fields with their error messages
        var status = {};

        for (var i in postResponse.status_codes){
            if (i === 'answers'){
                // the server reports that there are questions with missing answers
                for (var j in postResponse.status_codes[i]){
                   status['questions['+j+']'] = postResponse.status_codes[i][j];
                }
            } else if(i === 'questions') {
                // the server reports that there are missing questions in the form
                for (var j in postResponse.status_codes[i]){
                   status['questions['+j+']'] = postResponse.status_codes[i][j];
                }
            } else {
                // the server reports that there are specific named fields with missing answers
                status[i] = postResponse.status_codes[i];
            }
        }

        var $field;
        var step, errorItem, isVisible;
        for(var k in status){
            $field = $formGroups.find('.form-control[name="'+k+'"], input[type="checkbox"][name*="'+k+'"], input[type="radio"][name="'+k+'"]');
            step = $field.parents('.form-step').data('formStep');
            errorItem = new noloPathInlineErrorItem($field, status[k], process.getInlineErrorMessage($field, status[k]), step, k);
            isVisible = ($field.length > 0) ? $field.is('*:visible') : false;

            // trigger errors
            if(errorItem) {
                if(isVisible){
                    process.setInlineError(errorItem.$field, errorItem.error);
                } 
                // else if (postResponse.nolopath.path == 'pi-api5' && postResponse.nolopath.routing == 'pi5b' && errorItem.fieldName == 'zip'){ og-pi5b
                //     process.setInlineError($('#zipInput'), errors.invalid.zip);
                // }
                else {
                    if (currentStep === step) {
                        process.setStatusError(errorItem.fieldId+'_status', 'error', errorItem.fieldName + ': ' + errorItem.message);
                    }
                }

                errorList.push(errorItem);
            }
        }

        // set total server errors
        data = new noloPathInlineErrorTotals(errorList, totalSteps);

        // save this for future reference
        this.setErrorData('server', data);

        return data;
    }

    noloPath.prototype.validateSelect = function(event) {
        var self = $(event.target);
        var not_answered = (self.val() === 0);
        var client_optional = !self.hasClass('required') || self.data('clientOptional');
        /*
        var parent = self.parents('.form-item');
        var not_answered = (self.val() === 0 || self.val() === '0');
        var client_optional = (!self.hasClass('required') && !parent.hasClass('required')) || self.data('clientOptional');
        */

        return this.validateFormItem(self, not_answered, 'missing', client_optional);
    }

    noloPath.prototype.validateCheckbox = function(event) {
        var self = $(event.target);
        var not_answered = true;
        var client_optional = !self.hasClass('required') || self.data('clientOptional');

        self.parents('.form-item').find(':input[type=checkbox]').each(
            function(){
                if(this.checked == true){
                    not_answered = false;
                }
            }
        );

        return this.validateFormItem(self, not_answered, 'missing', client_optional);
    }

    noloPath.prototype.validateRadio = function(event) {
        var self = $(event.target);
        var not_answered = (!self.is(':checked'));
        var client_optional = !self.hasClass('required') || self.data('clientOptional');
        return this.validateFormItem(self, not_answered, 'missing', client_optional);
    }

    noloPath.prototype.validatePhone = function(event) {
        var self = $(event.target);
        var client_optional = !self.hasClass('required') || self.data('clientOptional');
        var userEnteredVal = self.val().replace(/[^0-9()-]/g, "");
        var inputNumLength = (userEnteredVal.match(/\d/g) || []).length
        var userEnteredValStrip = userEnteredVal;
        var not_answered = true;
        var process = this;
        var initSelectionStart = event.target.selectionStart;        
        var $submit = $('.form-action-submit, .form-action-backtrack');
        userEnteredValStrip = userEnteredValStrip.replaceAll("(","");
        userEnteredValStrip = userEnteredValStrip.replaceAll(")","");
        userEnteredValStrip = userEnteredValStrip.replaceAll("-","");

        // For pi5brouting
        var pi5bRouting = false;
        var urlParams = new URLSearchParams(window.location.search);
        if((this.pathData.pathId == 'pi-api5' || this.pathData.pathId == 'pi-api5pp') && urlParams.has('routing')){
            pi5bRouting = urlParams.get('routing');
        }

        if($submit.hasClass('disabled')){
            this.toggleSubmitButton('enable');
        }

        // EHCS-3211 - Phone number field should not allow user to enter more than 10/11 digits
        if( ( userEnteredValStrip[0] == 1 && inputNumLength > 11 ) || ( userEnteredValStrip[0] != 1 && inputNumLength > 10 ) ) {
            if(event.originalEvent && event.originalEvent.inputType == 'insertFromPaste') {
                this.validateFormItem(self, false, 'missing', true);
                self.val(this.addPhoneDashes(userEnteredVal));
                var formattedPhoneNum = self.val();
                var maxInputChars = formattedPhoneNum[0] == 1 ? 14 : 12;
                maxInputChars = formattedPhoneNum.includes('(') || formattedPhoneNum.includes(')') ? maxInputChars + 1 : maxInputChars;
                self.val(formattedPhoneNum.substring(0,maxInputChars));
                if(!process.isPhone(self.val())) {
                    this.setInlineError(self, this.getErrorMessage('invalid', 'default', 'phone'));
                }
            } else if(event.originalEvent && event.originalEvent.inputType == 'insertText') {
                self.val(userEnteredVal.substring(0,userEnteredVal.length-1));
            }
            return false;
        }

        if(userEnteredValStrip[0] == 1){
            // EHCS-2300
            if( userEnteredVal[0] == '(' && userEnteredVal[1] == 1) {
                not_answered = (userEnteredValStrip.length != 10)
            } else {
                not_answered = (userEnteredValStrip.length != 11) 
            }        
        }else{
            not_answered = (userEnteredValStrip.length != 10)
        }
        if(event.which != 8 && event.originalEvent.data != null){//dont auto add dashes during backspace
            self.val(this.addPhoneDashes(userEnteredVal))
        }

        if(!process.isPhone(self.val())) {
            not_answered = !process.isPhone(self.val());
        }

        if( not_answered ) {
            var error_type = userEnteredValStrip.length == 0 ? 'missing' : 'invalid';
            if (pi5bRouting) {
                $("#Phone_Number").addClass('valid-error');
            } else 
                this.setInlineError(self, this.getErrorMessage(error_type, 'default', 'phone'));
        }

        // EHCS-2312 - Legacy path : Cursor always shifts to the right while editing valid phone number
        var currentSelection = event.target.selectionStart;

        if(self.val().length > 0 ) {
            var setCursorPosition = initSelectionStart;
            var input_val = self.val();
            if(initSelectionStart == currentSelection && currentSelection == self.val().length) {
                setCursorPosition = initSelectionStart;
            } else if(initSelectionStart == currentSelection && currentSelection < self.val().length) {
                setCursorPosition = initSelectionStart;
            } else if(initSelectionStart < currentSelection && currentSelection == self.val().length) {
                // EHCS-2342 : Legacy Path Auto Formatting Issue When Modifying The Three Middle Digits After The Area Code
                var lastChar = input_val[input_val.length-1];
                var secLastChar = input_val[input_val.length-2];
                var phoneSymbols = ['-', '(', ')', ' '];
                var initChar = input_val[initSelectionStart-1];
                var initNextChar = input_val[initSelectionStart];
                if(!phoneSymbols.includes(initChar) && !phoneSymbols.includes(initNextChar) && (initSelectionStart+2) != currentSelection ) {
                    setCursorPosition = initSelectionStart;
                } else if(phoneSymbols.includes(lastChar) || phoneSymbols.includes(secLastChar)) {
                    setCursorPosition = currentSelection;
                } else {
                    setCursorPosition = initSelectionStart;
                }
            } else {
                setCursorPosition = currentSelection;
            }
            
            var phone_field_id = self.attr('id');
            var text_phone_field = document.getElementById(phone_field_id);
            text_phone_field.value = text_phone_field.value;
            text_phone_field.setSelectionRange(setCursorPosition, setCursorPosition);
            text_phone_field.focus();
        }

        return this.validateFormItem(self, not_answered, 'missing', client_optional);
    }

    noloPath.prototype.validateInput = function(event) {
        var self = $(event.target);
        var val = self.val();
        var placeholder = self.attr('placeholder');
        var client_optional = !self.hasClass('required') || self.data('clientOptional');
        var not_answered = (val.length < 1);
        var $submit = $('.form-action-submit, .form-action-backtrack');
        if((self.hasClass('validate-phone') || self.hasClass('validate-email') || self.attr('name') == 'case_description') && $submit.hasClass('disabled')){
            this.toggleSubmitButton('enable', false);
        }

        // input fields without placeholders can use the 'input' event for the error checking
        // we are using the 'blur' event for fields with placeholders to keep IE happy
        // if(
        //     ((event.type === 'input') && (!placeholder || placeholder.length < 1)) ||
        //     ((event.type === 'blur') && (placeholder && placeholder.length > 0))
        // ){
        if(event.type === 'blur' || event.type === 'input'){
            return this.validateFormItem(self, not_answered, 'missing', client_optional);
        }
    }

    noloPath.prototype.validateFormItem = function(self, not_answered, status, optional) {
        var $elm = this.$element;
        var $parent = self.parents('.form-item');
        var client_optional = (typeof optional === 'boolean') ? optional : false;
        var isPracticeAreaSelect = (self.attr('name') === 'practice_area_select');
        var isZip = (self.attr('name') === 'zip');
        var userEngaged = this.isUserEngaged();
        var formStep = $parent.parent().data('formStep');
        var step = this.getCurrentStep();
        var special = this.getSpecialStep();
        $parent.eq(0).addClass('visited');

        var showQID = $parent.attr('show-qid');
        var showCond = $parent.attr('show-cond');
        var answer = self.val();
        var target = $('div#form-item-'+showQID);
        var searchParamsData = new URLSearchParams(window.location.search);
        var isQuestionnaireTest = false;
        var $hiddenQuestions = $elm.find('.form-hidden-questions');

        if (window.NCMS != undefined) {
            isQuestionnaireTest = [81, 84, 5016].includes(parseInt(window.NCMS.aopId)) ? true : false;

            //LDC also has this NCMS global var, check again
            if (window.location.hostname.includes('legal-info') && (window.location.hostname.includes('lawyers.com') || window.location.hostname.includes('mhdev.tech'))) {
                isQuestionnaireTest = [81, 84, 5016].includes(parseInt(document.querySelector('#nolopath[data-practice-area-id]').getAttribute('data-practice-area-id'))) ? true : false;
            }

        } else if(document.querySelector('body').getAttribute('data-type') == 'organic'){
            isQuestionnaireTest = [81, 84, 5016].includes(parseInt(document.querySelector('body').getAttribute('data-pid'))) ? true : false;
        } else if(window.location.hostname.includes('workerscompensationlawfirms') && document.querySelector('body').getAttribute('data-type') == 'sem' && document.querySelector('body').getAttribute('data-pid') == 83){
            if(searchParamsData && searchParamsData.size > 0 && searchParamsData.get('questionnaire') == 'true') {
                $('div#form-item-q109').removeClass('not-answered').addClass('answered');
                $('select#nolopath-q109 option[value="5: Not Sure"]').attr('selected', 'selected');
                if(self.attr('name') === 'govmt_emp') {
                    if(document.querySelector(".form-hidden-questions input[name='govmt_emp_question']") == null && document.querySelector(".form-hidden-questions input[name='govmt_emp_answer']") == null) {
                        $hiddenQuestions.append("<input type='hidden' name='govmt_emp_question' value='Were you a federal government employee at the time of your injury?' />");
                        $hiddenQuestions.append("<input type='hidden' name='govmt_emp_answer' value='govmt_emp_answer' />");
                    }

                    if(answer == '2: Yes') {
                        document.querySelector(".form-hidden-questions input[name='govmt_emp_answer']").value = 'Yes';
                    } else {
                        document.querySelector(".form-hidden-questions input[name='govmt_emp_answer']").value = 'No';
                    }
                }
            }
        }

        if (typeof showQID === 'string' && showQID.length > 1) {
            if (answer[0] == showCond) {
                target.removeClass('optional').removeClass('disabled').addClass('required');
            } else {
                target.removeClass('required').addClass('optional').addClass('disabled');
            }
        }

        // trigger an event that the user has engaged with the form
        // by answering one of the displayed questions
        // -----
        // @note:
        // + ignores any user answer for the zip code since it is usually prefilled
        // + ignores any user answer for the practice area select since it is also usually prefilled
        // + this event will only happen once in every page view
        if(!userEngaged && !isZip && !isPracticeAreaSelect && (step === formStep)){
            this.triggerEvent('semFormUserEngaged', step);
            if(typeof special !== 'undefined') {
                this.triggerEvent('semFormUserEngaged', special);
            }
            this.setUserEngaged(true);
        }

        if (not_answered){

            if (this.isSsdiApi4Family() && step == 'step-5') {
                // $("#"+self.attr('id')+'_tooltip-helper').show();
                switch (self.context.id) {
                    case 'nolopath-qfirst_name':
                    case 'nolopath-qlast_name':
                    case 'nolopath-qmail':
                        this.setInlineError(self,status);
                        break;
                    default:
                        break;
                }
            }

            if(!client_optional) {
                // throw an error to indicate that the question was not answered properly
                this.setInlineError(self, status);

                // NOTE:
                // + if user navigates back & clears previous answer, 'not-answered' class
                // + must be reappended (https://jira.internetbrands.com/browse/EHCS-468)
                $parent.addClass('not-answered').removeClass('answered');

                // identify that the answer is not valid
                $parent.data('valid', false);
            }
            //added if user clear the input immediately after adding some value
            //added only for top leads and mobile
            var regionId = this.getRegionId();
            var urlParams = new URLSearchParams(window.location.search);
            if( this.getRegionGeneral(regionId) == 'top' && this.isMobile() ) {
                if($parent.hasClass('required')){
                    $parent.addClass('not-answered').removeClass('answered');
                    this.setInlineError(self, status);
                    $elm.find('.form-actions').addClass('not-valid').removeClass('valid')
                }
            }            
        } else {

            // EHCS-5160: ssdi-api4 specific handling before removing inline errors
            if (this.isSsdiApi4Family() && step == 'step-5') {
                $(".tooltip-helper-body.show").hide()
                $(".tooltip-helper-body.show").removeClass("show");
                switch (self.context.id) {
                    case 'nolopath-qfirst_name':
                    case 'nolopath-qlast_name':
                        this.removeInlineError(self);
                        break;
                    
                    case 'nolopath-qphone':
                        $("#"+self.attr('id')+'_tooltip-helper').hide();
                        if(self.val().replace(/[^0-9()-]/g, "").length >= 10) {
                            this.removeInlineError(self);
                        } else this.setInlineError(self);
                        break;
                    
                    case 'nolopath-qmail':
                        $("#"+self.attr('id')+'_tooltip-helper').hide();
                        if (/^((?!\.)[\w\-_.\+]*[^.])(@\w+)(\.\w+)$/.test(self.val())) {
                            this.removeInlineError(self);
                        } else this.setInlineError(self, this.getErrorMessage('invalid', 'default', 'email_valid'));
                        break;
                
                    default:
                        this.removeInlineError(self);
                        break;
                }
            } else {
                // remove any inline errors, if present
                this.removeInlineError(self);
            }

            if(this.isGatekeeper(self)) {
                $parent.addClass('show-message');
            } else {
                $parent.removeClass('show-message');
            }

            // identify that the answer is valid
            $parent.data('valid', true);

            // @note:
            // + form items will have the 'not-answered' class by default
            // + replace with 'answered' when the field has a valid answer
            $parent.addClass('answered').removeClass('not-answered');

            // update questionData
            var id = $parent.attr('id');
            var questionData = this.getQuestionData();
            var emptyQuestionData = $.isEmptyObject(questionData);
            var current, field, fieldId;

            if(!this.isGatekeeper(self)) {
                this.enableSubsequentOptionalQuestions($parent.eq(0));
            }

            // it is possible that questionData is empty
            // perform these operations if there is valid data to check
            if(!emptyQuestionData){
                for(var i = 0; i < questionData.questions.length; i++){
                    current = questionData.questions[i];
                    if(current.id === id) {
                        if(!current.answered) {
                            if(id !== 'form-item-zip' || (isQuestionnaireTest && id == 'form-item-zip' && questionData.answered < questionData.step_1_total)){
                                questionData.answered++;

                                if(id === 'form-item-case_description' && questionData.answered > questionData.step_1_total) {
                                    questionData.answered = questionData.step_1_total;
                                }
                            }
                        }

                        // update the current question
                        field = new noloPathQuestionItem($parent);
                        questionData.map['map_' + field.rawId] = field;
                        questionData.questions[i] = field;
                    }
                }

                //if this is an input we want different behavior
                var isInput = false;
                $parent.find('input').each(function(){
                    if($(this).is(':visible')){
                        isInput = true;
                    }
                });

                var searchParams = new URLSearchParams(window.location.search);

                if(!isInput) {
                    var aop_router_select_id = 'nolopath-practice-area-select';
                    if(id == undefined && $(self).attr('id') == aop_router_select_id) {
                        // EHCS-1848: if the answered question is form-practice-area-select question for aop routing, keep it display as part of q-1
                        var $practice_area_router = $(self).closest('.form-item')
                        if($practice_area_router.length==1){
                            $practice_area_router.addClass('active');
                            $elm.find('.progress-container').hide();
                            $elm.find('.forward-link').addClass('disabled');
                            $elm.find("[type='submit'].form-action-submit").addClass('form-incomplete');
                        }
                    } else if(this.isMobile() && (id == 'form-item-q1110' || id == 'form-item-q1111' || id == 'form-item-q1112') && isQuestionnaireTest) {
                        if(questionData.answered === 1){
                            $elm.find('.progress-container').show();
                        }
                        this.updateProgress();
                        this.navigateLogic($parent, 'forward');
                        /*
                        if(id == 'form-item-q1111' || id == 'form-item-q1112') {
                            this.skipSubsequentOptionalQuestions(self, $parent);
                        }
                        */
                    }
                    //ignore navigation logic for zip
                    else if(id !== 'form-item-zip' || isQuestionnaireTest){
                        if(questionData.answered === 1){
                            $elm.find('.progress-container').show();
                        }

                        this.updateProgress();
                        this.navigateLogic($parent, 'forward');
                        if(id == 'form-item-case_description' && this.isMobile() && isQuestionnaireTest) {
                            if(!$parent.hasClass('active')){
                                $parent.addClass('active');
                            };
                        } else if (window.location.hostname.includes('legal-info') && (window.location.hostname.includes('lawyers.com') || window.location.hostname.includes('mhdev.tech'))) {
                            if (id == 'form-item-case_description' && window.innerWidth < 599 && isQuestionnaireTest) {
                                if(!$parent.hasClass('active')){
                                    $parent.addClass('active');
                                };
                            }
                        }
                    }
                }
                else {
                    if(id !== 'form-item-zip' || isQuestionnaireTest){
                        this.updateProgress();
                        $elm.find('.forward-link').removeClass('disabled');

                        // update navigation buttons (forward, back)
                        this.navigateLogic($parent);
                    }
                }

                // Trigger question answered event only for questions and not zip/case description
                if(field && field.rawId){
                    fieldId = isNaN(field.rawId) ? field.rawId : 'q' + field.rawId;
                    this.triggerEvent('semQuestionAnswered', fieldId);
                    if(formStep == undefined || formStep == step) {
                        this.triggerGa4Event('questionAnswered', fieldId);
                    }
                }

            }
            // trigger 'semConversionFunnel' custom event for EHCS-1113 requirements
            if (!isPracticeAreaSelect && step === 'step-1' && !this.isQuestionAnswered(self.attr('id'))) {
                this.setQuestionAnswered(self.attr('id'));
                this.triggerEvent('semConversionFunnel', 'step-' + (questionData.answered + 1));
            }

            // determine if we can display the 'form-actions'
            // -----
            // @note:
            // + because the markup of the practice area dropdown also follows the questions markup,
            //   the 'validateSelect' handler gets bound to it which then triggers the 'validateFormActions' handler
            // + skip 'validateFormActions' if that is the case
            if(!isPracticeAreaSelect){
                this.validateFormActions(self);
            }
        }

        // checks if all inline errors are cleared in order to clear the submit button error
        if ($('.inline-error').length == 0) {
            this.removeSubmitButtonError();
        }

        return;
    }

    // checks the stepQuestionsAnswered array if questionId exists to avoid triggering event for same question
    noloPath.prototype.isQuestionAnswered = function (questionId) {
        if (!this.stepsData.stepQuestionsAnswered) return;
        return this.stepsData.stepQuestionsAnswered.indexOf(questionId) > -1;
    }

    // pushes questionId into stepQuestionsAnswered for EHCS-1113 custom event requirements
    noloPath.prototype.setQuestionAnswered = function (questionId) {
        if (!this.stepsData.stepQuestionsAnswered) return;
        return this.stepsData.stepQuestionsAnswered.push(questionId);
    }

    /**
     * Finds all subsequent questions that are consider to be optional
     * @note: An item is consider optional under the following circunstances:
     * 1. There is no required class
     * 2. Is required but was responded already
     * @param {element} self form-item
     */
    noloPath.prototype.enableSubsequentOptionalQuestions = function (self) {
        var optionalItems = self.nextUntil('.required.not-answered', '.form-item');
        var enabledItems = optionalItems.not('disabled');
//        optionalItems.addClass('active');
        enabledItems.addClass('active');
        // If there are questions that were already answered they will set as visited
//        optionalItems.filter('.answered')
        enabledItems.filter('.answered')
            .addClass('visited');
    };

    noloPath.prototype.skipSubsequentOptionalQuestions = function (self, $parent) {
        if(self){
            var optionalItems = $parent.nextAll(':not(.optional)').addClass('active');
            if(optionalItems){
                optionalItems.filter('.answered').addClass('visited');
            }
        }
    };

    noloPath.prototype.validateFormActions = function(field) {
        var $elm = this.$element;
        var options = this.options;
        var $actions = $elm.find('.form-actions');

        if (options.formBehavior === 'progressive'){
            var formStep = field.parents('.form-step');
            var notAnswered = formStep.find('.not-answered.required').length;
            var hasGatekeeperMessage = $elm.find('.show-message .gatekeeper').length > 0;

            // when there is only 1 question left, change the 'not-valid' class to 'valid'
            if (notAnswered < 2 && $actions.hasClass('not-valid')){
                // unless it's Meso or Carbon Monoxide AOP
                if ((this.getPathData('practiceAreaId') == '397602') || (this.getPathData('practiceAreaId') == '1091') ||
                    this.getPathData('practiceAreaId') == '397620') {
                    if (notAnswered < 1 && $actions.hasClass('not-valid')){
                        $actions.addClass('valid').removeClass('not-valid');
                    }
                }
                else {
                    if(notAnswered == 0){
                        if (window.NCMS != undefined) { //EHCS-3716 article lead path 
                            if (document.querySelector(".navigate-links.last") != null) {
                                $actions.addClass('valid').removeClass('not-valid');
                            }
                        } else {
                            $actions.addClass('valid').removeClass('not-valid');
                            if (window.location.hostname.includes('legal-info') && (window.location.hostname.includes('lawyers.com') || window.location.hostname.includes('mhdev.tech'))) {}
                            else {
                                if([81, 84, 5016].includes(parseInt(document.querySelector('body').getAttribute('data-pid'))) && 
                                document.querySelector("body").getAttribute('data-type') == 'organic') {
                                    $actions.addClass('seen-retain');
                                }
                            }
                        }
                    }
                }
            }

            if(hasGatekeeperMessage) {
                $elm.addClass('has-gatekeeper');
            } else {
                $elm.removeClass('has-gatekeeper');
            }
        }
    }

    noloPath.prototype.getAnswerId = function(value) {
        return value.split(':')[0];;
    }

    // EHCS-611: fix input event firing with placeholder on IE9-11
    //   When clicking on an input field that has a placeholder attribute in IE9-11,
    //   the input event will mistakenly fire and trigger validateInput. To suppress this,
    //   we can unbind all other event listeners on focus, and then rebind validateInput.
    noloPath.prototype.configureBlurWorkaround = function(element, onBlur, eventType) {
        eventType = typeof(eventType) !== 'undefined' ? eventType : 'blur';

        element.on(eventType, onBlur);

        element.on('focus', function(e) {
            var ua = window.navigator.userAgent;
            if (ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1) {
                $(this).off(); // remove all other event listeners ie: blur, input
                setTimeout(function() {
                    element.on(eventType, onBlur); // rebind after events are done
                },1);
            }
        });
    }

    noloPath.prototype.ajaxConversion = function(data, confirmModel){
        var ajaxPaths = ['heartburn-form3a', 'vaping-form2a', 'talcumpowder-form3bm'];
        if (!(ajaxPaths.includes(confirmModel.path))) {
            return 0;
        }

        var confirmRoute = confirmModel.confirm_route.route;
        var nolopath_keys = Object.keys(data.nolopath);
        var hardCompleteRoutes = ['confirm/notused', 'confirm/notdiagnosed'];
        var softCompleteRoutes = ['confirm/cancer-type', 'confirm/noillness'];

        if (confirmRoute === 'confirm') {                                       // success
            gtag('event', 'conversion', {'send_to': 'AW-772998060/VIB9COCz5pYBEKyHzPAC'});
            fbq('trackCustom', 'Masstort Lead');
        } else if (hardCompleteRoutes.includes(confirmRoute)) {                 // hard disq
            gtag('event', 'conversion', {'send_to': 'AW-757445179/ti8DCPj8ra0BELvklukC'});
            fbq('trackCustom', 'Masstort Disqualified');
        } else if (softCompleteRoutes.includes(confirmRoute)) {                 // soft disq
            gtag('event', 'conversion', {'send_to': 'AW-757445179/_KXcCJb9ra0BELvklukC'});
            fbq('trackCustom', 'Masstort Disqualified');
        }

    };

    noloPath.prototype.xssFilter = function(string){
        var xssOptions = {
            whiteList:          [],
            stripIgnoreTag:     true,
            stripIgnoreTagBody: ['script']
        }

        return filterXSS(string, xssOptions);
    }

    noloPath.prototype.appendRouting = function (routing_data){
        var $routingCopy = $($(".form-practice-area-select").clone(true));
        $routingCopy.addClass('mva-routing');
        $routingCopy.show();
        var $routingCopyDrop = $($routingCopy.find('[name="practice_area_select"]'));
        $routingCopyDrop.attr('id','nolopath-practice-area-select-mva');
        // question title
        $routingCopy.find('[for="nolopath-practice-area-select"]').text(routing_data['question']);
        // question option
        $routingCopyDrop.find('option').remove();
        var optionD = document.createElement("option");
        optionD.value = "0";
        optionD.text = "Select Your Legal Issue";
        $routingCopyDrop.append(optionD)
        for (var i = 0; i < routing_data['aop_pid_list'].length; i++) {
            if(routing_data['aop_pid_list'][i]['value'] == 'generic'){
                var option = document.createElement("option");
                option.value = 'generic2'
                option.text = routing_data['aop_pid_list'][i]['option'];
                $routingCopyDrop.append(option);
            } else {
                var option = document.createElement("option");
                option.value = routing_data['aop_pid_list'][i]['value'];
                option.text = routing_data['aop_pid_list'][i]['option'];
                $routingCopyDrop.append(option);
            }
            
        }
        if($('#nolopath').attr('data-route-reset')){
            $routingCopy.find("option[value=125]").prop('selected', true);
            $(".form-container").before($routingCopy)
            $('.form-container').show();
        } else {
            $(".form-container").before($routingCopy)
        }
    }

    noloPath.prototype.pendingRoutingDropDown = function(routing_data){
        if(window.aopRoutingSet) return;
        window.aopRoutingSet = true;
        var $routingCopy = $($(".form-practice-area-select").clone(true));
        $routingCopy.addClass('mva-routing');
        $routingCopy.addClass('aop-routing');
        var $routingCopyDrop = $($routingCopy.find('[name="practice_area_select"]'));
        $routingCopyDrop.attr('id','nolopath-practice-area-select-mva');
        // question title
        $routingCopy.find('[for="nolopath-practice-area-select"]').text(routing_data['question']);
        // question option
        $routingCopyDrop.find('option').remove();
        var optionD = document.createElement("option");
        optionD.value = "0";
        optionD.text = "Select Your Legal Issue";
        $routingCopyDrop.append(optionD)
        for (var i = 0; i < routing_data['aop_pid_list'].length; i++) {
            var option = document.createElement("option");
            option.value = routing_data['aop_pid_list'][i]['value'] == 'generic' ? 'generic2' : routing_data['aop_pid_list'][i]['value'];
            option.text = routing_data['aop_pid_list'][i]['option'];
            $routingCopyDrop.append(option);
        }
        $(".form-practice-area-select").append($routingCopy)
        $(".form-container").hide();
    }

    noloPath.prototype.removeRoutingDropDown = function(){
        window.aopRoutingSet = false;
        // Remove aop routing dropdown and  reset generic dropdown to zero
        $(".aop-routing").remove();
        $(".form-practice-area-select select").val('0')
    }

    noloPath.prototype.redirectMainPath = function(){
        var query = window.location.search;
        var params = new URLSearchParams(query);
        params.delete('pid');
        params.delete('aop');
        var redirect = window.location.protocol + "//" + window.location.host + '/path2/min-path4?' + params.toString();
        window.location.href = redirect;
    }

    //Submit to tools queue endpoint for wc-api2?nq=true && dv-api3
    noloPath.prototype.submitToQueue= function(postData, nqSuccessUrl) {
        nqSuccessUrl = nqSuccessUrl === undefined ? false : nqSuccessUrl;
        var pathId = $('body').attr('data-path');
        var isWCApi2 = $('body').attr('data-path') == 'wc-api2' ? true : false;
        var reqHander = new Headers();
        reqHander.append("Content-Type", "application/json");
        // reqHander.append("X-XSRF-TOKEN", decodeURIComponent(getCookie("XSRF-TOKEN")));

        var parentWrapperQuiz = document.querySelector('#nolopath');
        var trustedFormID = document.querySelector('input[name="xxTrustedFormCertUrl"]').value;
        var trusted_form_id = trustedFormID.substring(trustedFormID.lastIndexOf('/')+1);

        window.ai_case_id = Math.floor(Math.random() * (1e13 + 1e12 +1)) + 1e12;

        var raw = {
            "name": parentWrapperQuiz.querySelector("#nolopath-qfirst_name").value + " " + parentWrapperQuiz.querySelector("#nolopath-qlast_name").value,
            "zip": parentWrapperQuiz.querySelector("input[name='zip'").value,
            "description": parentWrapperQuiz.querySelector("#nolopath-qcase_description") ? parentWrapperQuiz.querySelector("#nolopath-qcase_description").value : '',
            "email": parentWrapperQuiz.querySelector("#nolopath-qmail").value,
            "phone": parentWrapperQuiz.querySelector("#nolopath-qphone").value,
            "loc": parentWrapperQuiz.querySelector("[name=referer]").value,
            "sms_optin_status": parentWrapperQuiz.querySelector("[name=sms_optin_status]").value,
            "tcpa_consent_verbiage": parentWrapperQuiz.querySelector("[name=tcpa_consent_verbiage]").value,
            "trusted_form_id": trusted_form_id,
            "ai_case_id": window.ai_case_id,
            "WebsiteID": "15-103-212-197-7-216-247-236",
            // "prompt": "injury_submission_seo",
            "skip_prediction": true,
            "metadata": postData['metadata']
        };

        var isEpApi1Ls = ['ep-api1', 'ep-api1pp'].includes(pathId) && new URLSearchParams(window.location.search).get('np') === 'ls';

        if (isWCApi2) {
            raw.form_type = "wc_sem_form";
        } else if (isEpApi1Ls) {
            //EHCS-5744: 5-minute pre-processing window for enrichment answers
            raw.queue_timeout_seconds = 300;
        } else {

            //raw also needs to include queue_timeout_seconds
            raw.queue_timeout_seconds = 120;
        }

        var qaObj = [];
        var qandaObj = [];
        
        if (isWCApi2){
            qaObj.push({'question': parentWrapperQuiz.querySelector("input[name='routing_question']").value, 'answer': parentWrapperQuiz.querySelector("input[name='routing_answer']").value});
        }

        $('.form-item .select-box').each(function() {
            const $this = $(this);
            const $parentContainer = $this.closest('.form-item');

            var questionLabel = $parentContainer.find('label.control-label').clone();
            questionLabel.find('em').remove();
            var questionText = questionLabel.text().trim();

            var selectedOption = $this.find('select option:selected');
            var answerText = selectedOption.text().trim();

            if (answerText && answerText !== "Select an answer") {
                var entry = {};
                entry['question'] = questionText;
                entry['answer'] = answerText;
                qaObj.push(entry);
                qandaObj.push(entry);
            }
        });

        // EHCS-5697: dv-api3-v2 uses type=>'radio'/'checkbox' questions
        // (field_input_type_radio/checkbox.mustache) alongside the
        // type=>'select' ones above — those render no .select-box at
        // all, so without this they'd be silently missing from q_and_a.
        $('.form-item').has('.radio, .checkbox').each(function() {
            const $parentContainer = $(this);
            if ($parentContainer.find('.select-box').length) return;

            var questionLabel = $parentContainer.find('label.control-label').clone();
            questionLabel.find('em').remove();
            var questionText = questionLabel.text().trim();

            var answers = [];
            $parentContainer.find('input:checked').each(function() {
                answers.push($(this).attr('data-text') || $(this).val());
            });

            if (answers.length) {
                var entry = {};
                entry['question'] = questionText;
                entry['answer'] = answers.join(', ');
                qaObj.push(entry);
                qandaObj.push(entry);
            }
        });

        // Radio-based tools paths (e.g. cc-api2-v2) have no .select-box, so qandaObj is
        // empty — keep the q_and_a/qa already assembled by prepareLeadApi rather than
        // wiping them. Select-box paths (dv-api3, wc-api2) keep their original behavior.
        if (qandaObj.length > 0) {
            raw['metadata']['q_and_a'] = qandaObj;
            raw['qa'] = qaObj;
        } else {
            raw['qa'] = raw['metadata']['q_and_a'] || [];
        }
        var body = JSON.stringify(raw);

        var requestOptions = {
            method: 'POST',
            headers: reqHander,
            body: body,
            redirect: 'follow'
        };

        fetch('/path2/service/postqueue', requestOptions)
        .then(function (response) {
            return response.json()
        }).then(function (data) {
            $('<input>').attr({
                type: 'hidden',
                id: 'lead_id',
                name: 'lead_id',
                value: data.res.data.lead_id
            }).appendTo('.form-hidden-questions');

            if(isWCApi2) {
                /* wc-api2: queue -> enrichment 
                                        -> not answered? queue timeout
                                        -> yes answered? submit -> TYP
                */
                $('#enrichmentModal').show();
                $('#enrichmentBackdrop').show();
            } else {
                // dv-api3: queue -> TYP -> enrichment -> submit/queue timeout
                raw.lead_id = data.res.data.lead_id;
                if(data.res.status == 'success' && nqSuccessUrl != false){
                    $.redirect(nqSuccessUrl, raw);
                }
            }


        }).catch(function (error) {
            console.error(error)
        });
    }

    //Submit to tools endpoint for wc-api2?nq=true
noloPath.prototype.submitToTools = function(postData, nqSuccessUrl, closeModal) { 
    var reqHander = new Headers();
    reqHander.append("Content-Type", "application/json");

    var parentWrapperQuiz = document.querySelector('#nolopath');
    var trustedFormID = document.querySelector('input[name="xxTrustedFormCertUrl"]').value;
    var trusted_form_id = trustedFormID.substring(trustedFormID.lastIndexOf('/')+1);
    var raw = {
        "name": parentWrapperQuiz.querySelector("#nolopath-qfirst_name").value + " " + parentWrapperQuiz.querySelector("#nolopath-qlast_name").value,
        "zip": parentWrapperQuiz.querySelector("input[name='location'").value,
        "description": parentWrapperQuiz.querySelector("#nolopath-qcase_description").value,
        "email": parentWrapperQuiz.querySelector("#nolopath-qmail").value,
        "phone": parentWrapperQuiz.querySelector("#nolopath-qphone").value,
        "loc": parentWrapperQuiz.querySelector("[name=referer]").value,
        "lead_id": parentWrapperQuiz.querySelector("[name=lead_id]").value,
        "sms_optin_status": parentWrapperQuiz.querySelector("[name=sms_optin_status]").value,
        "tcpa_consent_verbiage": parentWrapperQuiz.querySelector("[name=tcpa_consent_verbiage]").value,
        "trusted_form_id": trusted_form_id,
        "WebsiteID": "15-103-212-197-7-216-247-236",
        // "prompt": "injury_submission_seo",
        "skip_prediction": true,
        "form_type": 'wc_sem_form',
        "metadata": postData['metadata'],
    };

    var qaObj = [];

    var metaObj = [];

    var aiObj = [];

    qaObj.push({'question': parentWrapperQuiz.querySelector("input[name='routing_question']").value, 'answer': parentWrapperQuiz.querySelector("input[name='routing_answer']").value});


    $('.form-item .select-box').each(function() {
        const $this = $(this);
        const $parentContainer = $this.closest('.form-item');

        var questionLabel = $parentContainer.find('label.control-label').clone();
        questionLabel.find('em').remove(); 
        var questionText = questionLabel.text().trim();

        var selectedOption = $this.find('select option:selected');
        var answerText = selectedOption.text().trim();

        if (answerText && answerText !== "Select an answer") {
            var entry = {};
            entry['question'] = questionText;
            entry['answer'] = answerText;
            qaObj.push(entry);
            metaObj.push(entry);
        }
    });

    if(closeModal == false){
        $('.enrichmentBody .form-group').each(function() {
            const $group = $(this);
            
            var questionText = $group.find('.form-label').text().trim();

            var $selectedRadio = $group.find('input[type="radio"]:checked');

            if ($selectedRadio.length > 0) {
                var entry = {};
                entry['question'] = questionText;
                entry['answer'] = $selectedRadio.val().trim();
                metaObj.push(entry);
                aiObj.push(entry);
            }
        });
        raw['ai'] = aiObj;
    }

    raw['metadata']['q_and_a'] = metaObj;

    raw['qa'] = qaObj;

    var requestOptions = {
        method: 'POST',
        headers: reqHander,
        body: JSON.stringify(raw),
        redirect: 'follow'
    };

    fetch('/path2/service/postsubmit', requestOptions)
    .then(function (response) {
        return response.json()
    }).then(function(data) {
        if(data.res.status == 'success' && data.res.data.submit == true){
            $.redirect(nqSuccessUrl, postData);
        }
    }).catch(function (error) {
        console.error(error)
    });

}

    // noloPathStepData MODEL DEFINITION
    // ================================================================================
    var noloPathStepsData = function (currentStep, total) {
        var splitStep = currentStep.split('-');
        var current = parseInt(splitStep[1]);

        this.total   = total;
        this.current = current;

        if(this.total > 0){
            // identify integer values of various step states, based on total and current steps
            this.previous   = (this.current > 1) ? (this.current - 1) : null;
            this.next       = (this.current < this.total) ? (this.current + 1) : null;
            this.last       = this.total;
            this.beforeLast = (this.total - 1);

            // basic tests for the current step
            this.isOnFirstStep      = (this.current === 1);
            this.isOnLastStep       = (this.current === this.last);
            this.isOnBeforeLastStep = (this.current === this.beforeLast);

            // reset user engaged tracking
            this.isUserEngaged = false;

            // See EHCS-1113 for more info
            this.stepQuestionsAnswered = [];
        }
    }



    // noloPathQuestionItem MODEL DEFINITION
    // ================================================================================
    var noloPathQuestionItem = function ($field) {

        this.id = $field.attr('id');
        this.name = $field.data('fieldName');
        this.rawId = $field.data('rawId');
        this.shortLabel = $field.data('shortQuestion');
        this.value = $field.find('.form-control, .radio input, .checkbox input');
        this.step =  $field.parents('fieldset.form-step').data('formStep');
        this.answered = false;
        this.isRequired = $field[0].classList.contains("required");
        var regionType = document.querySelector('body').getAttribute('data-type');
        if (!this.isRequired){
            $field[0].classList.add('optional')
        }

        var question1111 = $field.parents('fieldset.form-step').find("#form-item-q1111");
        var question1112 = $field.parents('fieldset.form-step').find("#form-item-q1112");
        var questionCond1 = $field.parents('fieldset.form-step').find("#form-item-conditional_1");
        var questionCond2 = $field.parents('fieldset.form-step').find("#form-item-conditional_2");
        var questionDogbite = $field.parents('fieldset.form-step').find("#form-item-dogbite_1_up");
        var questionSlipfall = $field.parents('fieldset.form-step').find("#form-item-slipfall_1_up");

        var condVar = ['form-item-conditional_1', 'form-item-conditional_2', 'form-item-slipfall_1_up', 'form-item-dogbite_1_up'];

        if($field[0].classList.contains("conditional-option") && $field[0].classList.contains("not-answered")) {
            $field[0].classList.remove('required');
            $field[0].classList.add('optional');
            this.isRequired = false;
        }

        if($field.parents('fieldset.form-step-2').hasClass('active')){
            if(questionDogbite.length > 0){
                sessionStorage.setItem('dogbite', true);
                sessionStorage.removeItem('slipfall');
            } else if (questionSlipfall.length > 0){
                sessionStorage.setItem('slipfall', true);
                sessionStorage.removeItem('dogbite');
            } else {
                sessionStorage.removeItem('dogbite');
                sessionStorage.removeItem('slipfall');
            }
        }
    
        switch (this.value[0].type) {
            case 'select-one':
                this.isDefaultValue = this.value.find('option:selected').data('default');
                this.value = this.value.find('option:selected').data('optionSummary') || this.value.find('option:selected').data('optionShort') || this.value.find('option:selected').text();
                if (this.value === 'Select an answer' || this.isDefaultValue)
                    this.value = null;
                
                // EHCS-4451: Hide conditional questions if conditional trigger question is not answered
                if($field[0].classList.contains("conditional-question") && this.id == 'form-item-q98' && this.value == null){
                    questionCond1.removeClass('visited answered required active').addClass('hide not-answered disabled');
                } else if ($field[0].classList.contains("conditional-question") && this.id == 'form-item-q98' && this.value != null){
                    //if answered, check the answer and reveal question if necessary
                    var currentValue = this.value;
                    var cond1OptArr = ['No Medical Bills', 'Not Sure'];
                    if(cond1OptArr.includes(currentValue)){
                        questionCond1.removeClass('hide answered optional disabled').addClass('required not-answered active');
                    }  else {
                        document.querySelector('select[id="nolopath-qconditional_1"]').selectedIndex = 0;
                        if(sessionStorage.getItem('abTestQna')){
                            var qnaData = {};
                            qnaData = JSON.parse(sessionStorage.getItem('abTestQna'));
                            if(qnaData['form-item-conditional_1']){
                                delete qnaData['form-item-conditional_1'];
                            }
                            sessionStorage.setItem('abTestQna', JSON.stringify(qnaData));
                        }
                        questionCond1.removeClass('visited answered required active').addClass('hide not-answered disabled');
                    }
                }
                // EHCS-4451: Hide conditional questions if conditional trigger question is not answered
                if($field[0].classList.contains("conditional-question") && this.id == 'form-item-q39' && this.value == null){
                    questionCond2.removeClass('visited answered required active').addClass('hide not-answered disabled');
                } else if ($field[0].classList.contains("conditional-question") && this.id == 'form-item-q39' && this.value != null){
                    //if answered, check the answer and reveal question if necessary
                    var currentValue = this.value;
                    var cond2OptArr = ['Yes'];
                    if(cond2OptArr.includes(currentValue)){
                        questionCond2.removeClass('hide answered optional disabled').addClass('required not-answered active');
                    }  else {
                        document.querySelector('select[id="nolopath-qconditional_2"]').selectedIndex = 0;
                        if(sessionStorage.getItem('abTestQna')){
                            var qnaData = {};
                            qnaData = JSON.parse(sessionStorage.getItem('abTestQna'));
                            if(qnaData['form-item-conditional_2']){
                                delete qnaData['form-item-conditional_2'];
                            }
                            sessionStorage.setItem('abTestQna', JSON.stringify(qnaData));
                        }
                        questionCond2.removeClass('visited answered required active').addClass('hide not-answered disabled');
                    }
                }

                if(condVar.includes(this.id) && $field.parents('fieldset.form-step').hasClass('active')){
                    var qnaData = {}
                    if(sessionStorage.getItem('abTestQna')){
                        qnaData = JSON.parse(sessionStorage.getItem('abTestQna'));
                    } 
                    if(qnaData[this.id]){
                        qnaData[this.id][this.shortLabel] = this.value; 
                    } else {
                        qnaData[this.id] = {};
                        qnaData[this.id][this.shortLabel] = this.value; 
                    }
                    sessionStorage.setItem('abTestQna', JSON.stringify(qnaData));
                }

                if($field[0].classList.contains("conditional-question") && this.id == 'form-item-q1110' && this.value == null) {
                    question1111.removeClass('visited answered required active').addClass('hide not-answered disabled');
                    question1112.removeClass('visited answered required active').addClass('hide not-answered disabled');
                } else if($field[0].classList.contains("conditional-question") && this.id == 'form-item-q1110' && this.value != null) {
                    var currentValue = this.value;
                    var wpOptArr = ['Within the last year','Between 1 to 2 years ago','2 years ago or more'];
                    var empOptArr = ['Currently employed at the same organization'];
                    if(wpOptArr.includes(currentValue)) {
                        //console.log('question1111 : Did the termination violate the terms of your employment contract?');

                        question1111.removeClass('hide answered optional disabled').addClass('required not-answered active');
                        question1112.removeClass('visited answered required active not-answered').addClass('optional hide disabled');

                        if(document.querySelector('select[id="nolopath-q1111"]')){
                            document.querySelector('select[id="nolopath-q1111"]').removeAttribute("disabled");
                            if(regionType == 'sem') {
                                $('#form-item-q1111').removeClass("hide");
                            }
                        }
                        if(document.querySelector('select[id="nolopath-q1112"]')){
                            document.querySelector('select[id="nolopath-q1112"]').setAttribute("disabled", "disabled");
                            if(regionType == 'sem') {
                                $('#form-item-q1112').addClass("hide");
                            }
                        }

                        //console.log('Set AOP as Wrongful Termination AOP - 84');
                        if(document.querySelector('input[name="practice_area_id"]')){
                            document.querySelector('input[name="practice_area_id"]').value = 84;
                        }
                        if(document.querySelector('input[name="pid"]')){
                            document.querySelector('input[name="pid"]').value = 84;
                        }

                        //EHCS-4210: case desc fix
                        if(window.NCMS != undefined) {
                            if(question1111[0].querySelector('select').value != '0') {
                                question1111.removeClass('hide optional not-answered disabled').addClass('required answered active');
                                question1112.addClass('visited answered');
                                if(window.innerWidth > 600) {
                                    setTimeout(function() {
                                        document.getElementById('form-item-case_description').classList.add('active');
                                    },1);
                                }
                            }
                        }
                    } else if(empOptArr.includes(currentValue)) {
                        //console.log('question1112: Please select the category that refers to your employment-related issue -');

                        question1112.removeClass('hide answered optional disabled').addClass('required not-answered active');
                        question1111.removeClass('visited answered required active not-answered').addClass('optional answered hide disabled');

                        if(document.querySelector('select[id="nolopath-q1112"]')){
                            document.querySelector('select[id="nolopath-q1112"]').removeAttribute("disabled");
                            if(regionType == 'sem') {
                                $('#form-item-q1112').removeClass("hide");
                            }
                        }
                        if(document.querySelector('select[id="nolopath-q1111"]')){
                            document.querySelector('select[id="nolopath-q1111"]').setAttribute("disabled", "disabled");
                            if(regionType == 'sem') {
                                $('#form-item-q1111').addClass("hide");
                            }
                        }

                        //console.log('Set AOP as Employment AOP - 16');
                        if(document.querySelector('input[name="practice_area_id"]')){
                            document.querySelector('input[name="practice_area_id"]').value = 16;
                        }
                        if(document.querySelector('input[name="pid"]')){
                            document.querySelector('input[name="pid"]').value = 16;
                        }

                        //EHCS-4210: case desc fix
                        if(window.NCMS != undefined) {
                            if(question1112[0].querySelector('select').value != '0') {
                                question1112.removeClass('hide optional not-answered disabled').addClass('required answered active');
                            }
                        }
                    }
                }else if($field[0].classList.contains("conditional-option") && this.id == 'form-item-q1111' && this.value != null) {
                    //console.log('this.value:', this.value);
                    question1112.addClass('visited answered hide');
                }else if($field[0].classList.contains("conditional-option") && this.id == 'form-item-q1112' && this.value != null) {
                    //console.log('this.value:', this.value);
                    question1111.addClass('visited answered hide');
                }

                break;
            case 'checkbox':
                var temp = '';
                for (var i = 0; i < this.value.length; i++){
                    var current = this.value[i];
                    if(current.checked){
                        if(temp != ''){
                            temp += ', ';
                        }
                        temp += $(current).data('text');
                    }
                }
                this.value = temp != '' ? temp : null;
                break;
            case 'radio':
                for (var i = 0; i < this.value.length; i++){
                    var current = this.value[i];
                    if(current.checked){
                        this.value = $(current).data('text');
                        break;
                    }
                }
                if(typeof this.value === 'object'){
                    this.value = null;
                }
                break;
            default:
                this.value = this.value.val() || null; // (this.isRequired ? null : "n/a")

                // trim it down if it's too long
                if(this.value && this.value.length > 150){
                    this.truncated = true;
                    this.fullValue = this.value;
                    this.value = this.value.substring(0, 150) + '&hellip;';
                }
        }

        if (this.value) {
            this.answered = true;
        }
        this.isDisabledElement = $field[0].classList.contains("hide");
    }




    // noloPathInlineErrorItem MODEL DEFINITION
    // ================================================================================
    var noloPathInlineErrorItem = function ($field, error, message, fieldStep, fieldName) {
        this.error = error;
        this.message = message;
        if($field.length > 0){
            this.$field = $field;
            this.fieldName = $field.attr('name');
            this.fieldId = $field.attr('id');
            this.fieldStep = fieldStep;
        } else {
            this.fieldStep = 'extra';
            this.fieldName = fieldName;
        }
    }




    // noloPathInlineErrorTotals MODEL DEFINITION
    // ================================================================================
    var noloPathInlineErrorTotals = function (data, totalSteps) {
        var steps = {
            'extra': []
        };
        var step;
        // init the steps objects
        for (var j = 0; j < totalSteps; j++){
            steps['step-'+(j+1)] = 0;
        }

        // compile totals
        for (var i = 0; i < data.length; i++){
            step = data[i]['fieldStep'];
            if(step === 'extra'){
                steps.extra.push(data[i]['fieldName']);
            } else {
                steps[step]++;
            }
        }

        this.total = data.length;
        this.steps = steps;
        this.steps.length = totalSteps;
    }




    // noloPathProviderItem MODEL DEFINITION
    // ================================================================================
    var noloPathProviderItem = function (data, options) {
        var pHtmlTag = /(<([^>]+)>)/ig;
        var serverEnvironment = options.serverEnvironment;
        var hostSubdomain;

        switch(serverEnvironment){
            case 'LOCAL':
                hostSubdomain = options.subdomainLocal;
            break;
            case 'STAGE':
            case 'STAGING':
                hostSubdomain = options.subdomainStage;
            break;
            default:
                hostSubdomain = options.subdomainProduction;
            break;
        }

        var subs;
        subs = data.practice_areas;
        data.profile_node_url = '//'+hostSubdomain+'.nolo.com/node/'+data.gid;
        data.profile_resolved_url = data.profile_url || data.profile_node_url;
        data.profile_image = data.picture || '//www.nolo.com/themes/hubv6_nolo/images/placeholders/profile_placeholder_200.png';
        data.subscription = null;
        data.website = data.group_url;

        // discard all but 1st phone number
        if (data.phone){
            var pStandardLoose = /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})(.*)$/;
            data.phoneClickToCall = data.phone.replace(pStandardLoose, '+1$1$2$3');
            data.phoneFormatted = data.phone.replace(pStandardLoose, '($1) $2-$3');
        }

        // append the a protocol agnostic double forward slash, if it does not exist or is another protocol (ex: ftp).
        if (data.website){
            var hasValidProtocol = /^(https?:\/\/|\/\/)/g.test(data.website);
            if(!hasValidProtocol) {
                data.website = '//' + data.website.replace(/\w+:\/\//g, '');
            }
        }

        // strip HTML tags off the profile name
        if (data.profile_name){
            data.profile_name_clean = data.profile_name.replace(pHtmlTag, ' ');
        }

        // strip HTML tags off the taglines
        if (data.tagline){
            data.tagline_clean = data.tagline.replace(pHtmlTag, ' ');
        }

        // compile provider subscription list, if available
        if(subs){
            for (var x = 0, y = 0, list = []; x < subs.length; x++){
                // add to the list if practice area is valid
                if(x < 3 && subs[x]){
                    list.push(subs[x]);
                }

                // anything beyond 3 practice areas, start counting extras
                if(x >= 3) {
                    y++;
                }

                // add to the list the total amount of extras found
                if(x === (subs.length - 1) && y > 0){
                    list.push('('+y+' MORE)');
                }
            }

            // merge final subscription list
            data.subscription = list.join(', ');
        }

        for (var k in data){
            this[k] = data[k];
        }
    }




    // noloPathConfirm MODEL DEFINITION
    // ================================================================================
    var noloPathConfirm = function (data, options, map, questionOnTracks) {
        this.debug = options.debug ? true : false;
        this.title = options.title;
        this.surlLinkBack = options.surlLinkBack;
        this.surlLinkBackMessage = options.surlLinkBackMessage;
        this.logoLinkBack = options.logoLinkBack;
        this.serverEnvironment = options.serverEnvironment;
        this.hideProfileLink = options.hideProfileLink;
        this.disableProfileLink = options.disableProfileLink;
        this.openWebsiteLinkNewTab = options.openWebsiteLinkNewTab;
        this.path = options.pathId;
        this.analytics = null;
        this.hostDomain = options.hostDomain || null;
        this.hostDomainName = options.hostDomainName || null;
        this.confirm_route = {
            'route': 'confirm',
        };

        for(var i in data.qa){
            data.qa[i].answer = data.qa[i].answer || 'N/A';
        }

        // determine host subdomain based on environment to make link corrections, as needed
        switch(options.serverEnvironment){
            case 'LOCAL':
                this.hostSubdomain = options.subdomainLocal;
            break;
            case 'STAGE':
            case 'STAGING':
                this.hostSubdomain = options.subdomainStage;
            break;
            default:
                this.hostSubdomain = options.subdomainProduction;
            break;
        }

        // amend data retrieved from NoloLeads
        for(var i in data){
            switch(i){
                case 'qa':
                    var qa = [];
                    var qaMap = {};
                    var qaData;
                    if (data.qa === undefined || data.qa.length == 0) {
                        // For CLP flow. qa is empty from leads
                        qaData = window.global_qa_obj;
                        
                        // Need to fill these for qaMap
                        // aid - answer id
                        // qid - question id (which order it is)
                        // question as TEXT
                        // answer as TEXT

                        try {
                            var qaDataObj = {};
                            for (var idx = 0; idx < qaData['qaTextSet'].length; idx++) {
                                qaDataObj.qid = qaData['qaSet'][idx].id[0];
                                qaDataObj.aid = qaData['qaSet'][idx].answer[0];
                                qaDataObj.question = qaData['qaTextSet'][idx].question[0];
                                qaDataObj.answer = qaData['qaTextSet'][idx].answer[0];

                                qaMap['q'+qaDataObj.qid] = {'qid': qaDataObj.qid, 'aid': qaDataObj.aid, 'question': qaDataObj.question, 'answer': qaDataObj.answer};
                            }
                        } catch (error) {}
                    } else {
                        for (var j in data[i]){
                            qaData = data[i][j];
                            qaData.question_id = j;

                            // Handle different types of question & answer data
                            if(Array.isArray(qaData.value)) { // Checkboxes
                                qaData.answer_id = qaData.value;
                            } else if (typeof qaData.value === 'object') { // Checkboxes
                                qaData.answer_id = Object.keys(qaData.value);
                            } else if (typeof qaData.value === 'string') { // Select/Radio/Textfield
                                if(qaData.type !== 'textfield') {
                                    qaData.answer_id = qaData.value.split(':')[0];
                                } else {
                                    qaData.answer_id = null;
                                }
                            }

                            if(map['map_'+ j] && map['map_'+ j]['shortLabel']){
                                qaData.question_short = map['map_'+ j]['shortLabel'];
                            }

                            if(questionOnTracks && questionOnTracks.includes(qaData.question_id)){
                                qaData['answer']=qaData.value.split(':')[1];
                            }
                            qa.push(qaData);
                            qaMap['q'+j] = {'qid': j, 'aid': qaData.answer_id, 'question': qaData.question, 'answer': qaData.answer};
                        }
                    }
                    this[i] = qa;

                    qaMap.case_description = data.case_description;

                    this['qa_map'] = qaMap;
                    this['qa_json'] = JSON.stringify(qaMap);
                break;

                case 'partner_affiliate_groups':
                case 'providers':
                    var providers = [];
                    var subs;
                    for (var k in data[i]){
                        providers.push(new noloPathProviderItem(data[i][k], options));
                    }

                    this[i] = providers;
                break;

                case 'lead_type':
                    this[i] = data[i];

                    // it's possible that the 'lead_type' can return 2 lead types separated by a comma
                    // replace with an underscore to allow various lead type properties to resolve correctly
                    this['lead_type_clean'] = data.lead_type.replace(',', '_');

                    // test lead types
                    this['is_network'] = (this.lead_type_clean === 'network');
                    this['is_network_direct'] = (this.lead_type_clean === 'network_direct');
                    this['is_unsold'] = (this.lead_type_clean === 'unsold');
                    this['is_remnant'] = (this.lead_type_clean === 'remnant');
                    this['is_pingpost_ppl'] = (this.lead_type_clean === 'pingpost_ppl');
                    this['is_ppl'] = (this.lead_type_clean === 'ppl');
                    this['is_exclusive'] = (this.lead_type_clean === 'exclusive');
                    this['is_direct'] = (this.lead_type_clean === 'direct');
                    this['is_revive_unsold'] = (this.lead_type_clean === 'revive_unsold');
                    this['is_signed_case'] = (this.lead_type_clean === 'signed_case');
                    this['is_differentiated_leads'] = (this.lead_type_clean === 'differentiated_leads');

                    // 'lead_type' will be empty string if it's routed to CLP 
                    if(data.lead_type === "") {
                        console.log("CLP bound");
                        this['is_clp'] = true;
                    }

                    // dui-api1 or dui-api1pp is survey route
                    if (['dui-api1', 'dui-api1pp'].includes(data.nolopath.path)) {
                        this['is_survey_route'] = true;
                    }
                break;

                case 'user':
                    this[i] = data[i];
                    // set sms notification
                    if(this.user.show_popup){
                        this.show_sms = true;
                        this.leadsSmsApi = options.leadsSmsApi;
                    }
                break;

                default:
                    this[i] = data[i];
                break;
            }
        }

        // /sem/spanish (SSDI Premier): route anything short of the qualifying combination
        // (age 50-63, q1067/1068/1069 = Yes, q1070/1071 = No) to confirm/unrouted, same as cd-api1's hard disqualifies
        if(this.path === 'spanish' && this['qa_map']){
            var premierQids = [1066, 1067, 1068, 1069, 1070, 1071];
            var premierAnswered = premierQids.every(function(pqid){ return this['qa_map']['q'+pqid] !== undefined; }, this);
            if(premierAnswered){
                // select/select_tel answers are re-indexed 1-based by cNoloLeadsDataQuestionsConfig
                // ("value: label"), so Yes=1/No=2 here, and q1066's aid is already the real age.
                var premierAge = parseInt(this['qa_map']['q1066'].aid, 10);
                var qualifiesForPremier = premierAge >= 50 && premierAge <= 63
                    && this['qa_map']['q1067'].aid == 1  // Yes
                    && this['qa_map']['q1068'].aid == 1  // Yes
                    && this['qa_map']['q1069'].aid == 1  // Yes
                    && this['qa_map']['q1070'].aid == 2  // No
                    && this['qa_map']['q1071'].aid == 2; // No
                if(!qualifiesForPremier){
                    this.confirm_route = { route: 'confirm/unrouted' };
                }
            }
        }

        var qid = false;
        // update confirm route
        if(options.confirmRoute){
            var r,matchedCombination,match_pid,match_lead_type,match_qid,match_aid,match_answer;
            for(var i in options.confirmRoute){
                matchedCombination = false;
                r = options.confirmRoute[i];
                // Iterating through all matches in confirmRoute
                for(var m in r.match) {
                    var comb = r.match[m];
                    // EHCS-3838 - Frontend updates : SEO questionnaire A/B test for the 3 sub-AOPs
                    if(this['qa_map']['q'+comb.qid] == undefined){
                        continue;
                    }
                    // loose matching is performed as we are comparing an integer vs a string
                    match_pid = (comb.pid == this.practice_area_id);
                    match_lead_type = (comb.lead_type ? (comb.lead_type == this.lead_type_clean || comb.lead_type == 'any') : true);
                    match_qid = (comb.qid ? comb.qid == this['qa_map']['q'+comb.qid]['qid'] : true);
                    match_aid = (comb.aid ? comb.aid == this['qa_map']['q'+comb.qid]['aid'] : true);
                    match_answer = (comb.answer ? comb.answer == this['qa_map']['q'+comb.qid]['answer'] : true);
                    matchedCombination = match_pid
                        && match_lead_type
                        && match_qid
                        && match_aid
                        && match_answer;
                    // Skip iterating if once failed to match and move on to another combination
                    if (!matchedCombination) break;
                }

                if (matchedCombination) {
                    if(r.options){
                        if(comb.qid){
                            qid = comb.qid;
                        }
                        options['message_header_'+this.lead_type_clean] = r.options.message_header;
                        options['message_'+this.lead_type_clean] = r.options.message;
                    }
                    this.confirm_route = r;
                    break;
                }
            }
            if(data.unrouted){
                $('body').addClass('unrouted-typ');
                this['is_unrouted']=true;
            }

        }


        // set lead type message
        this['message'] = options['message_'+this.lead_type_clean];
        this['message_header'] = options['message_header_'+this.lead_type_clean];

        // LLPLAT-2515 - Update unsold Thank You Page for Legacy Path
        this['message'] = options['message_'+this.lead_type_clean];
        this['queued_for_retry'] = this.queued_for_retry;

        if( this.lead_type_clean === 'unsold' && this.queued_for_retry !== undefined ) {
            if(this.queued_for_retry === true) {
                // display the 3sd specific banner on SEM divorce
                //specific messages for dv-api divorce aop
                if ((this.practice_area_id == 96 && location.pathname.includes('dv-api'))) { 
                    this['show_unsold_queued_for_retry'] = true;
                    this['message_header_extra'] = 'We’re Sorry. We Were Unable to Find an Attorney in Your Area, but There Are Other Options'
                    this['message_header'] = 'Based on Your Responses & Customers Similar to You, We Recommend';
                    this['message'] = '3 Step Divorce, a streamlined online solution allowing you to manage your divorce with ease and affordably from the comfort of your home. Learn more below about 3 Step Divorce could work for you.';
                    this['request_id_nonum'] = data.request_id.replace('#','');
                    if (document.querySelector('input[name="zip_state"]').value != '') {
                        this['zip_state'] = 'states/' + document.querySelector('input[name="zip_state"]').value + ".shtml?newhp";
                    } else { this['zip_state'] = ''; }
                } else {
                    this['show_nolo_50'] = true;
                    this['message'] = options['message_unsold_queued_for_retry_true'];
                }
            } else {
                this['show_unsold_queued_for_retry'] = true;
                this['message'] = options['message_unsold_queued_for_retry_false'];
                if(this.practice_area_id == 4 && !location.pathname.includes('sem')) {
                    this['message'] = 'Unfortunately, we are unable to connect you with a [AOP] attorney near you.';
                }

                //specific messages for dv-api divorce aop
                if ((this.practice_area_id == 96 && location.pathname.includes('dv-api'))) {
                    this['message_header_extra'] = 'We’re Sorry. We Were Unable to Find an Attorney in Your Area, but There Are Other Options'
                    this['message_header'] = 'Based on Your Responses & Customers Similar to You, We Recommend';
                    this['message'] = '3 Step Divorce, a streamlined online solution allowing you to manage your divorce with ease and affordably from the comfort of your home. Learn more below about 3 Step Divorce could work for you.';
                    this['request_id_nonum'] = data.request_id.replace('#','');
                    if (document.querySelector('input[name="zip_state"]').value != '') {
                        this['zip_state'] = 'states/' + document.querySelector('input[name="zip_state"]').value + ".shtml";
                    } else { this['zip_state'] = ''; }
                }
                var url_parts = location.hostname.split('.');
                this['referer_base_domain'] = url_parts.slice(0).slice(-(url_parts.length === 4 ? 3 : 2)).join('.');
            }
        }

        if(this['message']) this['message'] = this['message'].replaceAll("[AOP]", this.practice_area_name);

        // override for options
        if(this.confirm_route.options && !( this.lead_type_clean === 'unsold' && this.queued_for_retry !== undefined )){
            if(this.confirm_route.options.message) {
                this['message'] = this.confirm_route.options.message;
            }
            if(this.confirm_route.options.message_header) {
                this['message_header'] = this.confirm_route.options.message_header;
            }
        }

        if(this['message'] != undefined){
            var practice_area_message = this['message'].replaceAll("[AOP]", this.practice_area_name);
            this['message'] = practice_area_message;
        }

        // set specific content to display
        if(this.confirm_route.options && this.confirm_route.options.show){
            for (var l in this.confirm_route.options.show){
                this['show_'+this.confirm_route.options.show[l]] = this.confirm_route.options.show[l];
            }
        } else {
            for (var l in options['resultsContent_'+this.lead_type_clean]){
                this['show_'+options['resultsContent_'+this.lead_type_clean][l]] = options['resultsContent_'+this.lead_type_clean][l];
            }
        }

        // set form title based on routing question(api5), the confirm data is render by JS
        if(["pi-api5"].includes(this.path)){
            var hasRouting = $("#nolopath").find('input[name="routing"]')?$("#nolopath").find('input[name="routing"]').val():false;
            if(hasRouting){
                this.title = $("#nolopath").find('.panel-title.form-title').first().text();
            }
        }

        // override for options
        if(this.practice_area_id == 5016 && qid == 1108 && this.confirm_route.options && this.lead_type_clean === 'unsold' && this.queued_for_retry == false) {
            if(this.confirm_route.options.message) {
                this['message'] = this.confirm_route.options.message;
            }
            if(this.confirm_route.options.message_header) {
                this['message_header'] = this.confirm_route.options.message_header;
            }
            delete this['show_unsold_queued_for_retry'];
        }
    }

    function nonInjuryFreeRemoval() {
        var original_cta_text = $("[data-label-last='Submit']").text();
        if(($.inArray($("body").attr('data-pid'), ["1", "30", "83", "128", "125", "133"]) !== -1) || document.querySelector('body').classList.contains('path-type-sem')) {
            // $("[data-label-last='Submit']").text(original_cta_text);
            // $("[data-label-last='Submit']").attr('data-label-step', original_cta_text);

            if (document.querySelector('body').classList.contains('nolopath-theme-quasar')) {
                $("[data-label-last='Submit']").text('Get FREE Evaluation');
            }
            
            //don't add FREE to default 
            if ($("body").attr('data-pid') == "1") {
            }else {
                if ($("span.ex").hasClass('up')) {
                    $("span.ex").text('FREE');
                } else {
                    $("span.ex").text('Free');
                }
            } 
        } else {
            if (!document.querySelector('body').classList.contains('path-type-sem')) {
                $("[data-label-last='Submit']").text('Connect with Local Attorneys');
                $("[data-label-last='Submit']").attr('data-label-step', 'Connect with Local Attorneys');
            }
        }
    }

    function handleTrustedForm() {
        // const TRUSTED_FORM_AOPS = [67, 20992, 133, 10581, 1091, 1245, 1077, 19570, 27, 114, 1244, 10469, 8937, 1246, 1078, 5016, 9002, 17783, 81, 9004, 4976, 4774, 1089, 1088, 17, 77, 66, 37, 9002, 397546, 130, 126, 13, 169071, 1081];
        // try {
        //     document.querySelectorAll("[name*='xxTrustedForm']").forEach(function($element, idx){
        //         $element.remove();
        //     });
        //     document.getElementById('tf_noscript').remove();
        //     document.getElementById('tf_script').remove();
        // } catch (error) {}

        // if ((TRUSTED_FORM_AOPS.includes(parseInt($("body").attr('data-pid'))) || $("body").attr('data-type') == 'sem') && document.getElementById('tf_noscript') == null) {
            // var tf = document.createElement('script');
            // tf.type = 'text/javascript';
            // tf.async = true;
            // tf.src = ("https:" == document.location.protocol ? 'https' : 'http') + "://api.trustedform.com/trustedform.js?field=xxTrustedFormCertUrl&ping_field=xxTrustedFormPingUrl&l=" + new Date().getTime() + Math.random();
            // var s = document.getElementsByTagName('script')[0]; 
            // s.parentNode.insertBefore(tf, s);    

            // //noscript
            // var tf_noscript = document.createElement('noscript');
            // tf_noscript.id = 'tf_noscript';
            // document.getElementById('trusted-form-container').appendChild(tf_noscript);

            // var tf_noscript_img = document.createElement('img');
            // tf_noscript_img.src = 'https://api.trustedform.com/ns.gif'
            // document.getElementById('tf_noscript').appendChild(tf_noscript_img);

            try {
                setTimeout(function() {
                    //cleanup xxTrustedForm items that aren't under the #for-trusted selector
                    document.querySelectorAll("[name*='xxTrustedForm']").forEach(function($element, idx){
                        if ($element.parentElement.id != 'for-trusted') {
                            $element.remove();
                        }
                    });
                },1000);
            } catch (error) {
                console.log(error);
            }
        // }
    }

    // noloPath PLUGIN DEFINITION
    // ================================================================================
    function Plugin(option) {
        // store arguments into a local variable so we can reference it for the public methods
        var args = arguments;

        return this.each(function(idx) {
            var $this   = $(this);
            var data    = $this.data(noloPath.DATANAME);
            var options = typeof option == 'object' && option;

            // initialize the plugin for this element for the first time
            if (!data){
                // store the index of this particular instance so we can auto generate ids
                if(typeof options == 'object'){
                    // a configuration object was passed into the plugin
                    // add the 'idx' property into 'options'
                    options.idx = idx;
                } else {
                    // a configuration object was NOT passed into the plugin
                    // declare the 'options' variable as an object with at least the 'idx' property assigned to it
                    options = {
                        'idx': idx,
                    };
                }

                // store the instance of this plugin for this element into memory, if none exists
                // this will initialize the plugin using the 'options' configuration
                $this.data(noloPath.DATANAME, (data = new noloPath(this, options)));
            }

            // call a public method against the initialized plugin
            if (typeof option == 'string'){
                data[option].apply(this, Array.prototype.slice.call(args, 1));
            }
        })
    }

    // assign a previous plugin definition into another variable for 'noConflict'
    var old = $.fn[noloPath.NAME];

    // assign the noloPath PLUGIN DEFINITION
    $.fn[noloPath.NAME]                = Plugin;

    // assign the noloPath PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    $.fn[noloPath.NAME]['constructor'] = noloPath;




    // noloPath NO CONFLICT
    // ================================================================================
    $.fn[noloPath.NAME]['noConflict'] = function () {
        $.fn[noloPath.NAME] = old;
        return this;
    }


    // noloPath DATA-API
    // ================================================================================
    $(document).ready(function(){
        // auto-initialize elements that contain the 'data-toggle="noloPath"' attribute
        var $elm = $('[data-toggle="noloPath"]');

        $( '.question-tooltip' ).tooltip();
        // pass a blank object to simplify the initialization
        // default plugin options and data attribute configuration options will be used for data-api initialization
        var option = {};

        // initialize the plugin upon document ready
        Plugin.call($elm, option);
    });

    //EHCS-2257: divorcenet dynamic params adding
    $(document).ready(function(){
        $("a#diy-divorcenet").prop("href","https://www.divorcenet.com/online-divorce"+window.location.search);
    });

    //EHCS-4051: get free eval -> connect with local attorneys
    $(document).ready(function(){
        nonInjuryFreeRemoval();
    });
    
    //EHCS-3096: Place geolocation call on sem path page itself
    $(document ).ready(function() {
        if (document.querySelector('.dp-vars-title')){
            $.ajax({
                url: "https://geocoding.internetbrands.com/geocoding/api/v1.1/getCityStateZipCode",
                type: 'GET',
                success: function(res) {
                    $('span#city').text(res.city);
                    $('span#state').text(res.state.stateName);
                }
            });
        }
    });

    $(document).ready(function() {
    })
}));
